(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4682],{

/***/ 77392:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
var prefix = 'fas';
var iconName = 'caret-down';
var width = 320;
var height = 512;
var aliases = [];
var unicode = 'f0d7';
var svgPathData = 'M137.4 374.6c12.5 12.5 32.8 12.5 45.3 0l128-128c9.2-9.2 11.9-22.9 6.9-34.9s-16.6-19.8-29.6-19.8L32 192c-12.9 0-24.6 7.8-29.6 19.8s-2.2 25.7 6.9 34.9l128 128z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faCaretDown = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;

/***/ }),

/***/ 57079:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ store; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(35944);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/lodash/lodash.js
var lodash = __webpack_require__(96486);
// EXTERNAL MODULE: ./src/api/graphql/SkuPresentation/Gql__SkuPresentation__Decoder__List.bs.js
var Gql_SkuPresentation_Decoder_List_bs = __webpack_require__(1651);
// EXTERNAL MODULE: ./src/models/Models.bs.js
var Models_bs = __webpack_require__(37698);
// EXTERNAL MODULE: ./src/utils/PageContentResolver.bs.js
var PageContentResolver_bs = __webpack_require__(73763);
// EXTERNAL MODULE: ./src/common/utils/react.tsx
var utils_react = __webpack_require__(4331);
// EXTERNAL MODULE: ./src/components/library/SeoMeta.tsx
var SeoMeta = __webpack_require__(48882);
;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_class_call_check.mjs
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./src/common/utils/string.ts
var string = __webpack_require__(53782);
;// CONCATENATED MODULE: ./src/utils/fp/index.ts
/*
 * Copyright (c) 2014-present, Prezzee
 * All rights reserved.
 */ /**
 * Function flow
 * @param f1
 * @param f2
 */ var flow = function(f1, f2) {
    return function(arg) {
        return f1(f2(arg));
    };
};
/**
 * Function list flow
 * @param arr
 */ var flowList = function(arr) {
    return arr.reduce(flow, function(value) {
        return value;
    });
};
/**
 * Run function with arg
 * @param fn
 */ var run = function(fn) {
    return function(arg) {
        return fn(arg);
    };
};
/**
 * Identity func
 * @param arg
 */ var identity = function(arg) {
    return arg;
};

// EXTERNAL MODULE: ./src/common/util.ts + 3 modules
var util = __webpack_require__(42358);
// EXTERNAL MODULE: ./src/hooks/useSegment.ts
var useSegment = __webpack_require__(59945);
// EXTERNAL MODULE: ./src/bindings/Segment.bs.js + 1 modules
var Segment_bs = __webpack_require__(73840);
// EXTERNAL MODULE: ./src/models/segment.model.ts
var segment_model = __webpack_require__(13813);
// EXTERNAL MODULE: ./src/utils/Regex.tsx
var Regex = __webpack_require__(38612);
;// CONCATENATED MODULE: ./src/contexts/DrainContext.tsx















var DrainType;
(function(DrainType) {
    DrainType["Filter"] = "filter";
    DrainType["Sorting"] = "sorting";
})(DrainType || (DrainType = {}));
var SortValue;
(function(SortValue) {
    SortValue["LiteralUp"] = "a-z";
    SortValue["LiteralDown"] = "z-a";
    SortValue["Featured"] = "featured";
    SortValue["NewArrivals"] = "new_arrivals";
})(SortValue || (SortValue = {}));
var DEFAULT_FILTER_PAGE = {
    code: "default",
    parent: void 0
};
var DEFAULT_FILTER_CURRENT = {
    elements: []
};
var Device;
(function(Device) {
    Device["Desktop"] = "desktop";
    Device["Mobile"] = "mobile";
    Device["Tablet"] = "tablet";
})(Device || (Device = {}));
function uniqueCardList(list) {
    return Object.values(list.reduce(function(acc, obj) {
        return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, acc), (0,_define_property/* default */.Z)({}, obj.uid, obj));
    }, {}));
}
/**
 * Returns SKU Presentation codename regarding the region
 * @todo: compose the unmapped liked value
 * @param codename
 */ function getPresentationCodename(codename) {
    if (codename === "location") {
        var _obj;
        return (_obj = {}, (0,_define_property/* default */.Z)(_obj, util/* COUNTRY.Australia */.si.Australia, "locationAu"), (0,_define_property/* default */.Z)(_obj, util/* COUNTRY.NewZealand */.si.NewZealand, "locationNz"), (0,_define_property/* default */.Z)(_obj, util/* COUNTRY.GreatBritain */.si.GreatBritain, "locationUk"), (0,_define_property/* default */.Z)(_obj, util/* COUNTRY.UnitedStates */.si.UnitedStates, "locationUs"), _obj)[util/* COUNTRY */.si[util/* envUtil.getCountry */.vK.getCountry()]];
    } else {
        return codename;
    }
}
function filterBy(filter) {
    return function(codename) {
        return function(param) {
            var cardList = param.cardList, current = param.current, sort = param.sort;
            // apply filter by codename of taxonomies
            var filterCardList = current.filter(function(param) {
                var presentation = param.presentation;
                var filterCodenameList = filter.elements.filter(function(param) {
                    var _parent = param.parent, cn = _parent.codename;
                    return cn === codename;
                }).map(function(param) {
                    var _$codename = param.codename;
                    return _$codename;
                });
                var presentationValueList = presentation && presentation[getPresentationCodename(codename)] ? presentation[getPresentationCodename(codename)].map(function(param) {
                    var _$codename = param.value.codename;
                    return _$codename;
                }) : [];
                return filterCodenameList.filter(function(codename) {
                    return presentationValueList.includes(codename);
                }).length > 0;
            });
            return {
                cardList: cardList,
                filter: filter,
                current: uniqueCardList(filterCardList) || [],
                sort: sort
            };
        };
    };
}
function filterCards(drainValue, filter) {
    var defaultFilterValue = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, drainValue), {
        current: drainValue.cardList
    });
    var filterList = filter.elements.length > 0 ? filter.elements.map(function(param) {
        var codename = param.parent.codename;
        return codename;
    }).filter(function(codename, index, list) {
        return list.indexOf(codename) === index;
    }) : [];
    return filterList.length > 0 ? flowList((0,_to_consumable_array/* default */.Z)(filterList.map(filterBy(filter))))(defaultFilterValue) : defaultFilterValue;
}
/**
 * @note: The Sort class is not static for the further improvement.
 *        Redefine the class as static in case of additional values absence
 */ var DrainSort = /*#__PURE__*/ function() {
    "use strict";
    function DrainSort() {
        _classCallCheck(this, DrainSort);
    }
    var _proto = DrainSort.prototype;
    _proto.literalUp = function literalUp(drainValue) {
        var _this = this;
        return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, drainValue), {
            current: drainValue.current.sort(function(next, prev) {
                var nextSortValue = DrainSort.literalCardValue(next);
                var prevSortValue = DrainSort.literalCardValue(prev);
                return nextSortValue.localeCompare(prevSortValue, _this.locale, {
                    ignorePunctuation: true
                });
            }) || this.emptyCardList
        });
    };
    _proto.literalDown = function literalDown(drainValue) {
        return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, drainValue), {
            current: this.literalUp(drainValue).current.reverse() || this.emptyCardList
        });
    };
    _proto.featured = function featured(drainValue) {
        return drainValue;
    };
    _proto.newArrivals = function newArrivals(drainValue) {
        return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, drainValue), {
            current: drainValue.current.sort(function(prev, next) {
                var prevSortValue = DrainSort.dateCardValue(prev);
                var nextSortValue = DrainSort.dateCardValue(next);
                return new Date(nextSortValue).getTime() - new Date(prevSortValue).getTime();
            }) || this.emptyCardList
        });
    };
    DrainSort.literalCardValue = function literalCardValue(card) {
        return card ? card.name : void 0;
    };
    DrainSort.dateCardValue = function dateCardValue(card) {
        // @ts-ignore
        return card ? card.createdAt : void 0;
    };
    return DrainSort;
}();
function sortCards(drainValue, sort) {
    var drainSort = new DrainSort();
    var _obj;
    return (_obj = {}, (0,_define_property/* default */.Z)(_obj, SortValue.LiteralUp, drainSort.literalUp), (0,_define_property/* default */.Z)(_obj, SortValue.LiteralDown, drainSort.literalDown), (0,_define_property/* default */.Z)(_obj, SortValue.Featured, drainSort.featured), (0,_define_property/* default */.Z)(_obj, SortValue.NewArrivals, drainSort.newArrivals), _obj)[sort].call(drainSort, drainValue);
}
/**
 * @todo: stabilise the search RegExp condition
 * @param search
 */ function searchCard(search) {
    var format = function format(str) {
        return str.replace(/\s/gi, string/* EMPTY_STRING */.v6).replace(new RegExp(Regex/* specialRegex */.$I, "g"), string/* EMPTY_STRING */.v6);
    };
    return function(param) {
        var searchableTerms = param.searchableTerms, similarTerms = param.similarTerms;
        var regExp = new RegExp(format(search), "gi");
        return regExp.test(format("".concat(searchableTerms).concat(similarTerms)));
    };
}
var DEFAULT_DRAIN_VALUE = {
    cardList: [],
    current: [],
    sort: SortValue.Featured,
    filter: {
        elements: []
    }
};
var DrainReducer;
(function(DrainReducer) {
    DrainReducer["Apply"] = "apply";
})(DrainReducer || (DrainReducer = {}));
var DrainSample;
(function(DrainSample) {
    DrainSample["Sort"] = "sort";
    DrainSample["Filter"] = "filter";
})(DrainSample || (DrainSample = {}));
function drainReducer(drain, action) {
    switch(action.type){
        case DrainReducer.Apply:
            return Object.assign({}, drain.value, action.value);
        default:
            return drain;
    }
}
var LOCAL_STORAGE_SORT_ITEM = "drain-sort-value";
var DrainContext = /*#__PURE__*/ (0,react.createContext)({
    page: DEFAULT_FILTER_PAGE,
    isOpen: false,
    setPage: function() {
        return void 0;
    },
    filter: Object.assign({}, DEFAULT_FILTER_CURRENT),
    applyFilter: function() {
        return void 0;
    },
    prevFilter: Object.assign({}, DEFAULT_FILTER_CURRENT),
    setPrevFilter: function() {
        return void 0;
    },
    setFilter: function() {
        return void 0;
    },
    switchFilter: function() {
        return void 0;
    },
    appendFilter: function() {
        return void 0;
    },
    search: string/* EMPTY_STRING */.v6,
    setSearch: function() {
        return void 0;
    },
    onSearchChange: function() {
        return void 0;
    },
    hasSearch: function() {
        return false;
    },
    currentType: DrainType.Filter,
    apply: false,
    applySearch: function() {
        return void 0;
    },
    hasFilter: function() {
        return false;
    },
    setSortValue: function() {
        return void 0;
    },
    sort: SortValue.Featured,
    prevSort: SortValue.Featured,
    applySort: function() {
        return void 0;
    },
    hasSort: function() {
        return false;
    },
    initValue: function() {
        return void 0;
    },
    clearFilter: function() {
        return void 0;
    },
    currentValue: void 0,
    trackDrainFilterSection: function() {
        return void 0;
    },
    restore: function() {
        return void 0;
    },
    setCurrentValue: function(drainValue) {
        return void 0;
    }
});
var DrainContextProvider = function(param) {
    var children = param.children, value = param.value;
    var switchFilter = function switchFilter(param) {
        var _clear = param.clear, clear = _clear === void 0 ? false : _clear, _apply = param.apply, apply = _apply === void 0 ? false : _apply, _close = param.close, close = _close === void 0 ? false : _close, _sorting = param.sorting, sorting = _sorting === void 0 ? {
            current: SortValue.Featured,
            previous: SortValue.Featured
        } : _sorting, _currentFilter = param.currentFilter, currentFilter = _currentFilter === void 0 ? DEFAULT_FILTER_CURRENT : _currentFilter, _display = param.display, display = _display === void 0 ? true : _display, _device = param.device, device = _device === void 0 ? Device.Mobile : _device;
        if (clear === true) {
            setFilter(function() {
                return DEFAULT_FILTER_CURRENT;
            });
        }
        if (close === true) {
            setFilter(prevFilter);
        } else {
            setPrevFilter(filter);
        }
        setPage(function() {
            return DEFAULT_FILTER_PAGE;
        });
        setApply(function() {
            return apply;
        });
        if (apply === true) {
            var filterValue = (0,lodash.isEqual)(currentFilter, DEFAULT_FILTER_CURRENT) ? filter : currentFilter;
            filterSortApplied({
                has_filter: (0,lodash.eq)(clear, true) ? false : filterValue.elements.length > 0,
                has_audience_filter: !clear ? filterValue.elements.filter(function(param) {
                    var codename = param.parent.codename;
                    return codename === "audience";
                }).length > 0 : false,
                has_interests_filter: !clear ? filterValue.elements.filter(function(param) {
                    var codename = param.parent.codename;
                    return codename === "interest";
                }).length > 0 : false,
                has_location_filter: !clear ? filterValue.elements.filter(function(param) {
                    var codename = param.parent.codename;
                    return codename === "location";
                }).length > 0 : false,
                has_occasion_filter: !clear ? filterValue.elements.filter(function(param) {
                    var codename = param.parent.codename;
                    return codename === "occasion";
                }).length > 0 : false,
                has_search: search !== string/* EMPTY_STRING */.v6,
                has_sort: sorting.current !== SortValue.Featured,
                audience_filter_tags: !clear ? filterValue.elements.filter(function(param) {
                    var codename = param.parent.codename;
                    return codename === "audience";
                }).map(function(param) {
                    var codename = param.codename;
                    return codename;
                }).join(string/* VERTICAL_LINE_SIGN */.RC) : string/* EMPTY_STRING */.v6,
                interests_filter_tags: !clear ? filterValue.elements.filter(function(param) {
                    var codename = param.parent.codename;
                    return codename === "interest";
                }).map(function(param) {
                    var codename = param.codename;
                    return codename;
                }).join(string/* VERTICAL_LINE_SIGN */.RC) : string/* EMPTY_STRING */.v6,
                location_filter_tags: !clear ? filterValue.elements.filter(function(param) {
                    var codename = param.parent.codename;
                    return codename === "location";
                }).map(function(param) {
                    var codename = param.codename;
                    return codename;
                }).join(string/* VERTICAL_LINE_SIGN */.RC) : string/* EMPTY_STRING */.v6,
                occasion_filter_tags: !clear ? filterValue.elements.filter(function(param) {
                    var codename = param.parent.codename;
                    return codename === "occasion";
                }).map(function(param) {
                    var codename = param.codename;
                    return codename;
                }).join(string/* VERTICAL_LINE_SIGN */.RC) : string/* EMPTY_STRING */.v6,
                current_sort_select: sorting.current,
                previous_sort_select: sorting.previous
            });
        }
        setOpen(function() {
            return device !== Device.Desktop ? (0,lodash.eq)(display, false) ? false : !isOpen : false;
        });
    };
    var clearFilter = function clearFilter(parentCodename) {
        setFilter({
            elements: filter.elements.map(function(item) {
                return item.parent.codename === parentCodename ? void 0 : item;
            }).filter(function(item) {
                return item !== void 0;
            })
        });
    };
    var hasFilter = function hasFilter() {
        return filter.elements.length > 0;
    };
    var setSortValue = function setSortValue(value, prevValue) {
        // TODO: remove when `localStorage.getItem(LOCAL_STORAGE_SORT_ITEM)` is confirmed can be removed
        // localStorage.setItem(LOCAL_STORAGE_SORT_ITEM, value);
        setPrevSort(prevValue);
        setSort(value);
    };
    var applyFilter = function applyFilter(drainValue) {
        // setApply(false);
        if (hasFilter()) {
            var value = filterCards(drainValue, filter);
            setCurrentValue(value);
            // dispatchDrain({
            //   type: DrainReducer.Apply,
            //   value,
            // });
            return value;
        } else {
            return drainValue;
        }
    };
    var applySort = function applySort(drainValue) {
        // setApply(false);
        if (hasSort()) {
            var value = sortCards(drainValue, sort);
            // dispatchDrain({
            //   type: DrainReducer.Apply,
            //   value,
            // });
            return value;
        } else {
            return drainValue;
        }
    };
    var hasSort = function hasSort() {
        return sort !== void 0 && sort !== SortValue.Featured;
    };
    var restore = function restore(drainValue) {
        setApply(false);
        return drainValue;
    };
    var hasSearch = function hasSearch() {
        // @note: apply search independently the search existing value
        return isSearchChange ? true : !(0,lodash.isEqual)(search, string/* EMPTY_STRING */.v6);
    };
    var applySearch = function applySearch(drainValue) {
        if (hasSearch()) {
            var value = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, drainValue), {
                current: drainValue.current.filter(searchCard(search))
            });
            setCurrentValue(value);
            return value;
        } else {
            return drainValue;
        }
    };
    var trackDrainFilterSection = function trackDrainFilterSection(filter, search) {
        var filterDrainValue = filterCards(currentValue, filter);
        var cardDrainValue = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, filterDrainValue), {
            current: filterDrainValue.current.filter(searchCard(search))
        });
        var products = cardDrainValue.current.filter(function(param) {
            var isSwappable = param.isSwappable;
            return !isSwappable;
        }).map((0,lodash.rearg)(Segment_bs/* cardToProductWithIndex */.bC, [
            1,
            0
        ]));
        productsSearched({
            query: search,
            search_count: cardDrainValue.current.length,
            products: products,
            search_location: "store",
            search_type: search && hasFilter() ? segment_model/* ProductSearchType.Both */.v.Both : hasFilter() ? segment_model/* ProductSearchType.Filter */.v.Filter : segment_model/* ProductSearchType.Keyword */.v.Keyword
        });
        (0,Segment_bs/* productListViewed */.ZX)({
            list_id: "catalogue-promo",
            category: "Featured",
            products: products
        });
    };
    var ref = (0,react.useState)(true), initial = ref[0], setInitial = ref[1];
    var ref1 = (0,react.useState)(DEFAULT_FILTER_PAGE), page = ref1[0], setPage = ref1[1];
    var ref2 = (0,react.useState)(Object.assign({}, DEFAULT_FILTER_CURRENT, value.filter)), filter = ref2[0], setFilter = ref2[1];
    var ref3 = (0,react.useState)(Object.assign({}, DEFAULT_FILTER_CURRENT)), prevFilter = ref3[0], setPrevFilter = ref3[1];
    var ref4 = (0,react.useState)(value.sort || SortValue.Featured), sort = ref4[0], setSort = ref4[1]; // @note: "Featured" is the default sorting value
    var ref5 = (0,react.useState)(SortValue.Featured), prevSort = ref5[0], setPrevSort = ref5[1]; // @note: "Featured" is the default sorting value
    var ref6 = (0,react.useState)(value.search || string/* EMPTY_STRING */.v6), search = ref6[0], setSearch = ref6[1];
    var ref7 = (0,react.useState)(false), isOpen = ref7[0], setOpen = ref7[1];
    var ref8 = (0,react.useState)(DrainType.Filter), currentType = ref8[0], setCurrentType = ref8[1];
    var ref9 = (0,react.useState)(false), apply = ref9[0], setApply = ref9[1];
    var ref10 = (0,react.useState)(value.currentValue), currentValue = ref10[0], setCurrentValue = ref10[1];
    var ref11 = (0,react.useState)(false), isSearchChange = ref11[0], onSearchChange = ref11[1];
    var ref12 = (0,useSegment/* default */.Z)(), filterSortApplied = ref12.filterSortApplied, productsSearched = ref12.productsSearched;
    (0,react.useEffect)(function() {
        setInitial(false);
        if ((0,lodash.differenceWith)((0,lodash.values)(filter), (0,lodash.values)(DEFAULT_FILTER_CURRENT), lodash.isEqual)) {
            var filterValue = filterCards(currentValue, filter);
            setCurrentValue(filterValue);
            filterSortApplied({
                has_filter: true,
                has_audience_filter: filter.elements.filter(function(param) {
                    var codename = param.parent.codename;
                    return codename === "audience";
                }).length > 0,
                has_interests_filter: filter.elements.filter(function(param) {
                    var codename = param.parent.codename;
                    return codename === "interest";
                }).length > 0,
                has_location_filter: filter.elements.filter(function(param) {
                    var codename = param.parent.codename;
                    return codename === "location";
                }).length > 0,
                has_occasion_filter: filter.elements.filter(function(param) {
                    var codename = param.parent.codename;
                    return codename === "occasion";
                }).length > 0,
                has_search: search !== string/* EMPTY_STRING */.v6,
                has_sort: sort !== SortValue.Featured,
                audience_filter_tags: filter.elements.filter(function(param) {
                    var codename = param.parent.codename;
                    return codename === "audience";
                }).map(function(param) {
                    var codename = param.codename;
                    return codename;
                }).join(string/* VERTICAL_LINE_SIGN */.RC),
                interests_filter_tags: filter.elements.filter(function(param) {
                    var codename = param.parent.codename;
                    return codename === "interest";
                }).map(function(param) {
                    var codename = param.codename;
                    return codename;
                }).join(string/* VERTICAL_LINE_SIGN */.RC),
                location_filter_tags: filter.elements.filter(function(param) {
                    var codename = param.parent.codename;
                    return codename === "location";
                }).map(function(param) {
                    var codename = param.codename;
                    return codename;
                }).join(string/* VERTICAL_LINE_SIGN */.RC),
                occasion_filter_tags: filter.elements.filter(function(param) {
                    var codename = param.parent.codename;
                    return codename === "occasion";
                }).map(function(param) {
                    var codename = param.codename;
                    return codename;
                }).join(string/* VERTICAL_LINE_SIGN */.RC),
                current_sort_select: sort,
                previous_sort_select: SortValue.Featured
            });
            trackDrainFilterSection(filter, search);
        }
    }, []);
    var ref13 = (0,react.useReducer)(drainReducer, DEFAULT_DRAIN_VALUE), drain = ref13[0], dispatchDrain = ref13[1];
    // @note: default sort has no confirmed effect with the Segment
    // useEffect(() => {
    //   const sort = localStorage.getItem(LOCAL_STORAGE_SORT_ITEM);
    //   setSortValue(!isUndefined(sort) && !isEqual(sort, 'null')
    //     ? sort as SortValue
    //     : SortValue.Featured
    //   );
    // }, []);
    /**
   * Composes the Drain Value from the card list
   * @param cardList
   */ var initValue = function(cardList) {
        var currentDrainValue = {
            cardList: cardList,
            current: cardList,
            sort: sort,
            filter: filter
        };
        // setCurrentValue(currentDrainValue);
        // dispatchDrain({
        //   type: DrainReducer.Apply,
        //   value: currentDrainValue,
        // });
        return currentDrainValue;
    };
    var appendFilter = function(filterAppend) {
        var shouldApply = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
        var currentFilter = (0,lodash.cloneDeep)(filter);
        if (currentFilter.elements.map(function(param) {
            var codename = param.codename;
            return codename;
        }).includes(filterAppend.codename)) {
            setFilter((0,lodash.cloneDeep)((0,lodash.assign)({}, {
                elements: (0,_to_consumable_array/* default */.Z)(currentFilter.elements.filter(function(param) {
                    var codename = param.codename;
                    return codename !== filterAppend.codename;
                }))
            })));
        } else {
            setFilter((0,lodash.cloneDeep)((0,lodash.assign)({}, {
                elements: (0,lodash.compact)((0,_to_consumable_array/* default */.Z)(currentFilter.elements).concat([
                    filterAppend
                ]))
            })));
        }
        if (shouldApply) {
            switchFilter({
                apply: true,
                close: false,
                device: Device.Desktop
            });
            trackDrainFilterSection(filter, search);
        }
    };
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(DrainContext.Provider, {
        value: {
            filter: filter,
            prevFilter: prevFilter,
            isOpen: isOpen,
            switchFilter: switchFilter,
            appendFilter: appendFilter,
            setPrevFilter: setPrevFilter,
            setFilter: setFilter,
            page: page,
            setPage: setPage,
            search: search,
            setSearch: setSearch,
            hasSearch: hasSearch,
            currentType: currentType,
            apply: apply,
            initValue: initValue,
            applyFilter: applyFilter,
            hasFilter: hasFilter,
            clearFilter: clearFilter,
            setSortValue: setSortValue,
            sort: sort,
            prevSort: prevSort,
            applySort: applySort,
            hasSort: hasSort,
            restore: restore,
            applySearch: applySearch,
            currentValue: currentValue,
            onSearchChange: onSearchChange,
            trackDrainFilterSection: trackDrainFilterSection,
            setCurrentValue: setCurrentValue
        },
        children: children
    });
};

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs
var _sliced_to_array = __webpack_require__(10253);
// EXTERNAL MODULE: ./node_modules/@emotion/css/dist/emotion-css.esm.js
var emotion_css_esm = __webpack_require__(97133);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./src/config/Localization.bs.js
var Localization_bs = __webpack_require__(98765);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(70655);
// EXTERNAL MODULE: ./src/api/helpers.ts + 72 modules
var helpers = __webpack_require__(60693);
// EXTERNAL MODULE: ./src/utils/logger.ts
var logger = __webpack_require__(31611);
;// CONCATENATED MODULE: ./src/api/queries/filter.ts











/**
 * Filter Taxonomy Options from the Filter Taxonomy object
 * @param filterList
 */ function getFilterTaxonomyOptions(filterList) {
    return (0,lodash.omit)(filterList, "elements");
}
var DEFAULT_ROOT_SECTION_TITLE = "Let's find the perfect gift";
function withNational(terms) {
    var NATIONAL_CODENAME = "national_or_online";
    var nationalValue = terms[(0,lodash.findIndex)(terms, [
        "codename",
        NATIONAL_CODENAME
    ])];
    return !(0,lodash.isUndefined)(nationalValue) ? (0,lodash.concat)([
        nationalValue
    ], (0,lodash.reject)(terms, {
        codename: NATIONAL_CODENAME
    })) : terms;
}
function getLocationFilterList(options, filterList) {
    var currentCounty = util/* envUtil.getCountry */.vK.getCountry();
    var _obj;
    return {
        root: {
            title: (0,lodash.get)(options, "root.title", DEFAULT_ROOT_SECTION_TITLE),
            clearAll: {
                title: (0,lodash.get)(options, "root.clearAll.title", "Clear All")
            },
            close: {
                title: (0,lodash.get)(options, "root.close.title", "Close")
            },
            viewResults: {
                title: (0,lodash.get)(options, "root.viewResults.title", "View Results")
            }
        },
        search: {
            title: (0,lodash.get)(options, "search.title", "Search Brands")
        },
        filter: {
            title: (0,lodash.get)(options, "filter.title", "Filter"),
            options: {
                interest: {
                    search: {
                        title: (0,lodash.get)(options, "filter.options.interest.search.title", "What's their interests?")
                    }
                },
                location: {
                    search: {
                        title: (0,lodash.get)(options, "filter.options.location.search.title", "Search State/Province")
                    }
                },
                audience: {
                    search: {
                        title: (0,lodash.get)(options, "filter.options.audience.search.title", "Who is it for?")
                    }
                },
                occasion: {
                    search: {
                        title: (0,lodash.get)(options, "filter.options.occasion.search.title", "What's the occasion?")
                    }
                }
            }
        },
        sort: {
            title: (0,lodash.get)(options, "sort.title", "Sort By"),
            switched: (0,lodash.get)(options, "sort.switched", false),
            options: (0,lodash.get)(options, "sort.options", void 0)
        },
        elements: {
            audience: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, filterList.audience), {
                terms: (0,lodash.sortBy)(filterList.audience.terms, function(param) {
                    var name = param.name;
                    return name;
                })
            }),
            occasion: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, filterList.occasion), {
                terms: (0,lodash.sortBy)(filterList.occasion.terms, function(param) {
                    var name = param.name;
                    return name;
                })
            }),
            interest: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, filterList.interest), {
                terms: (0,lodash.sortBy)(filterList.interest.terms, function(param) {
                    var name = param.name;
                    return name;
                })
            }),
            location: (_obj = {}, (0,_define_property/* default */.Z)(_obj, util/* COUNTRY.Australia */.si.Australia, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, filterList.locationAu), {
                terms: withNational((0,lodash.sortBy)(filterList.locationAu.terms, function(param) {
                    var name = param.name;
                    return name;
                }))
            })), (0,_define_property/* default */.Z)(_obj, util/* COUNTRY.GreatBritain */.si.GreatBritain, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, filterList.locationUk), {
                terms: withNational((0,lodash.sortBy)(filterList.locationUk.terms, function(param) {
                    var name = param.name;
                    return name;
                }))
            })), (0,_define_property/* default */.Z)(_obj, util/* COUNTRY.UnitedStates */.si.UnitedStates, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, filterList.locationUs), {
                terms: withNational((0,lodash.sortBy)(filterList.locationUs.terms, function(param) {
                    var name = param.name;
                    return name;
                }))
            })), (0,_define_property/* default */.Z)(_obj, util/* COUNTRY.NewZealand */.si.NewZealand, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, filterList.locationNz), {
                terms: withNational((0,lodash.sortBy)(filterList.locationNz.terms, function(param) {
                    var name = param.name;
                    return name;
                }))
            })), _obj)[currentCounty]
        }
    };
}
function getLocationStore(language, isPreview) {
    return _getLocationStore.apply(this, arguments);
}
function _getLocationStore() {
    _getLocationStore = (0,_async_to_generator/* default */.Z)(function(language, isPreview) {
        var client, ref, storeAu, storeNz, storeUk, storeUs, currentCountry, _obj;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    client = (0,helpers/* createDeliveryClient */.As)(language, isPreview);
                    return [
                        4,
                        Promise.all([
                            client.item("prezzee_classic_store_au").toPromise(),
                            client.item("prezzee_classic_store_nz").toPromise(),
                            client.item("prezzee_classic_store_uk").toPromise(),
                            client.item("prezzee_classic_store_us").toPromise()
                        ])
                    ];
                case 1:
                    ref = _sliced_to_array/* default.apply */.Z.apply(void 0, [
                        _state.sent(),
                        4
                    ]), storeAu = ref[0], storeNz = ref[1], storeUk = ref[2], storeUs = ref[3];
                    currentCountry = util/* envUtil.getCountry */.vK.getCountry();
                    return [
                        2,
                        (_obj = {}, (0,_define_property/* default */.Z)(_obj, util/* COUNTRY.Australia */.si.Australia, storeAu.data), (0,_define_property/* default */.Z)(_obj, util/* COUNTRY.GreatBritain */.si.GreatBritain, storeUk.data), (0,_define_property/* default */.Z)(_obj, util/* COUNTRY.UnitedStates */.si.UnitedStates, storeUs.data), (0,_define_property/* default */.Z)(_obj, util/* COUNTRY.NewZealand */.si.NewZealand, storeNz.data), _obj)[currentCountry]
                    ];
            }
        });
    });
    return _getLocationStore.apply(this, arguments);
}
// @todo: compose the sort options mapper
function getSortOptionFromStore(store) {
    return store.item.elemenets.sort_options.value;
}
/**
 * Returns the default Store Content type element value
 * @note: the localisation can be provided
 * @param path
 */ function defaultStoreValue(path) {
    return ({
        view_results_title: "View Results",
        close_title: "Close",
        clear_all_title: "Clear All"
    })[path];
}
var DEFAULT_SWITCHED_ON_FILTER_VALUE = "on";
function composeFilterListOptions(store) {
    return {
        root: {
            title: (0,lodash.get)(store, "item.elements.title.value", string/* EMPTY_STRING */.v6),
            viewResults: {
                title: (0,lodash.get)(store, "item.elements.view_results_title.value", defaultStoreValue("view_results_title"))
            },
            close: {
                title: (0,lodash.get)(store, "item.elements.close_title.value", defaultStoreValue("close_title"))
            },
            clearAll: {
                title: (0,lodash.get)(store, "item.elements.clear_all_title.value", defaultStoreValue("clear_all_title"))
            }
        },
        sort: {
            title: (0,lodash.get)(store, "item.elements.sort_placeholder.value", void 0),
            switched: (0,lodash.eq)((0,lodash.get)(store, "item.elements.sort_by_on_off.value[0].codename", void 0), DEFAULT_SWITCHED_ON_FILTER_VALUE),
            // @todo: the cms items management
            options: {
                newArrivals: {
                    title: "New Arrivals"
                },
                featured: {
                    title: "Featured"
                },
                literalDown: {
                    title: "Z - A"
                },
                literalUp: {
                    title: "A - Z"
                }
            }
        },
        filter: {
            title: (0,lodash.get)(store, "item.elements.filter_placeholder.value", void 0),
            options: {
                interest: {
                    search: {
                        title: (0,lodash.get)(store, "item.elements.interests_search_placeholder.value", "What's their interests?")
                    }
                },
                location: {
                    search: {
                        title: (0,lodash.get)(store, "item.elements.location_search_placeholder.value", "What's their interests?")
                    }
                },
                audience: {
                    search: {
                        title: (0,lodash.get)(store, "item.elements.audience_search_placeholder.value", "What's their interests?")
                    }
                },
                occasion: {
                    search: {
                        title: (0,lodash.get)(store, "item.elements.occasion_search_placeholder.value", "What's their interests?")
                    }
                }
            }
        },
        search: {
            title: (0,lodash.get)(store, "item.elements.search_placeholder.value", void 0)
        }
    };
}
// @todo: How to log the catch or then response local?
var getFilterList = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(language, isPreview) {
        var ref, ref1, ref2, ref3, ref4, ref5, ref6, client, ref7, interest, audience, occasion, locationAu, locationNz, locationUk, locationUs, store, list, e;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        3,
                        ,
                        4
                    ]);
                    client = (0,helpers/* createDeliveryClient */.As)(language, isPreview);
                    return [
                        4,
                        Promise.all([
                            // @todo: optimise location queries
                            client.taxonomy("interest").toPromise(),
                            client.taxonomy("audience").toPromise(),
                            client.taxonomy("occasion").toPromise(),
                            client.taxonomy("location___au").toPromise(),
                            client.taxonomy("location___nz").toPromise(),
                            client.taxonomy("location___uk").toPromise(),
                            client.taxonomy("location___us").toPromise()
                        ])
                    ];
                case 1:
                    ref7 = _sliced_to_array/* default.apply */.Z.apply(void 0, [
                        _state.sent(),
                        7
                    ]), interest = ref7[0], audience = ref7[1], occasion = ref7[2], locationAu = ref7[3], locationNz = ref7[4], locationUk = ref7[5], locationUs = ref7[6];
                    return [
                        4,
                        getLocationStore("100-en-US", isPreview)
                    ];
                case 2:
                    store = _state.sent();
                    list = getLocationFilterList(composeFilterListOptions(store), {
                        interest: {
                            name: "Interest",
                            switched: ((ref = store.item.elements.interests_on_off.value[0]) === null || ref === void 0 ? void 0 : ref.codename) === DEFAULT_SWITCHED_ON_FILTER_VALUE,
                            question: store.item.elements.interests_filter_title.value,
                            terms: interest.data.taxonomy.terms
                        },
                        audience: {
                            name: "Audience",
                            switched: ((ref1 = store.item.elements.audience_on_off.value[0]) === null || ref1 === void 0 ? void 0 : ref1.codename) === DEFAULT_SWITCHED_ON_FILTER_VALUE,
                            question: store.item.elements.audience_filter_title.value,
                            terms: audience.data.taxonomy.terms
                        },
                        occasion: {
                            name: "Occasion",
                            switched: ((ref2 = store.item.elements.occasion_on_off.value[0]) === null || ref2 === void 0 ? void 0 : ref2.codename) === DEFAULT_SWITCHED_ON_FILTER_VALUE,
                            question: store.item.elements.occasion_filter_title.value,
                            terms: occasion.data.taxonomy.terms
                        },
                        locationAu: {
                            name: "Location AU",
                            switched: ((ref3 = store.item.elements.location_on_off.value[0]) === null || ref3 === void 0 ? void 0 : ref3.codename) === DEFAULT_SWITCHED_ON_FILTER_VALUE,
                            question: store.item.elements.location_filter_title.value,
                            terms: locationAu.data.taxonomy.terms
                        },
                        locationNz: {
                            name: "Location NZ",
                            switched: ((ref4 = store.item.elements.location_on_off.value[0]) === null || ref4 === void 0 ? void 0 : ref4.codename) === DEFAULT_SWITCHED_ON_FILTER_VALUE,
                            question: store.item.elements.location_filter_title.value,
                            terms: locationNz.data.taxonomy.terms
                        },
                        locationUk: {
                            name: "Location UK",
                            switched: ((ref5 = store.item.elements.location_on_off.value[0]) === null || ref5 === void 0 ? void 0 : ref5.codename) === DEFAULT_SWITCHED_ON_FILTER_VALUE,
                            question: store.item.elements.location_filter_title.value,
                            terms: locationUk.data.taxonomy.terms
                        },
                        locationUs: {
                            name: "Location US",
                            switched: ((ref6 = store.item.elements.location_on_off.value[0]) === null || ref6 === void 0 ? void 0 : ref6.codename) === DEFAULT_SWITCHED_ON_FILTER_VALUE,
                            question: store.item.elements.location_filter_title.value,
                            terms: locationUs.data.taxonomy.terms
                        }
                    });
                    return [
                        2,
                        list
                    ];
                case 3:
                    e = _state.sent();
                    // datadogLogs.logger.info('getFilterList error: ', e);
                    logger/* default.info */.ZP.info({
                        err: e,
                        source: "Gift Finder",
                        journey: "Gift Open"
                    }, "error: Failed to fetch Gift Finder taxonomies");
                    console.log("getFilterList error: ", e);
                    return [
                        2,
                        null
                    ];
                case 4:
                    return [
                        2
                    ];
            }
        });
    // const conlog = new Logger(
    //   (logsMessage: LogsMessage, logger: Logger) =>
    //     logger.log(logsMessage.message, logsMessage)
    // );
    //
    // conlog.log('defaultTaxonomy: ', defaultTaxonomy);
    });
    return function getFilterList(language, isPreview) {
        return _ref.apply(this, arguments);
    };
}();
/* harmony default export */ var filter = ((/* unused pure expression or super */ null && (getFilterList)));

// EXTERNAL MODULE: ./src/components/library/CardSearchResults.bs.js
var CardSearchResults_bs = __webpack_require__(25843);
// EXTERNAL MODULE: ./src/components/enrichedTextSection/EnrichedTextSection.bs.js + 4 modules
var EnrichedTextSection_bs = __webpack_require__(94135);
// EXTERNAL MODULE: ./src/components/library/Card.tsx
var Card = __webpack_require__(54353);
// EXTERNAL MODULE: ./src/components/library/BrazeContentCards.bs.js
var BrazeContentCards_bs = __webpack_require__(85663);
// EXTERNAL MODULE: ./src/components/pages/store/WallOfCardsStyles.bs.js
var WallOfCardsStyles_bs = __webpack_require__(54098);
// EXTERNAL MODULE: ./node_modules/@prezzee/ribbon-ui/lib/theme/foundations/colors.js
var colors = __webpack_require__(85171);
// EXTERNAL MODULE: ./src/components/CmsImage.tsx
var CmsImage = __webpack_require__(73450);
;// CONCATENATED MODULE: ./src/components/library/NoSearchResults.tsx




var Styles = {
    container: /*#__PURE__*/ (0,emotion_css_esm/* css */.iv)("display:flex;align-items:center;padding:36px 0 24px;"),
    textContainer: /*#__PURE__*/ (0,emotion_css_esm/* css */.iv)("margin-left:16px;"),
    title: /*#__PURE__*/ (0,emotion_css_esm/* css */.iv)("font-size:27px;line-height:34px;font-weight:600;color:", colors["default"].gray[800], ";"),
    description: /*#__PURE__*/ (0,emotion_css_esm/* css */.iv)("font-size:16px;line-height:24px;margin-top:8px;color:", colors["default"].gray[600], ";"),
    image: /*#__PURE__*/ (0,emotion_css_esm/* css */.iv)("width:72px;")
};
var NoSearchResults = function(param) {
    var icon = param.icon, title = param.title, description = param.description;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)("div", {
        className: "mx-4",
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)("div", {
                className: Styles.container,
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(CmsImage/* default */.Z, {
                        src: icon.src,
                        alt: icon.src,
                        width: icon.width,
                        height: icon.height,
                        sizes: "".concat(icon.width, "px"),
                        className: Styles.image
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)("div", {
                        className: Styles.textContainer,
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("h2", {
                                className: Styles.title,
                                children: title
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("p", {
                                className: Styles.description,
                                children: description
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("hr", {})
        ]
    });
};
/* harmony default export */ var library_NoSearchResults = (NoSearchResults);

// EXTERNAL MODULE: ./src/contexts/LayoutDataContext.ts
var LayoutDataContext = __webpack_require__(25149);
// EXTERNAL MODULE: ./node_modules/@prezzee/components/lib/index.js
var lib = __webpack_require__(34906);
// EXTERNAL MODULE: ./node_modules/@fortawesome/react-fontawesome/index.es.js
var index_es = __webpack_require__(67814);
// EXTERNAL MODULE: ./src/utils/LayoutDataContext.bs.js
var LayoutDataContext_bs = __webpack_require__(37110);
// EXTERNAL MODULE: ./src/css/theme.ts
var theme = __webpack_require__(55374);
;// CONCATENATED MODULE: ./src/components/library/SearchInput.tsx










/**
 * Numeric search activity
 * @param value
 */ function alphaNumericSearch(value) {
    return value.replace(/[^\w\s]/g, "$&");
}
var DEFAULT_SEARCH_PLACEHOLDER = "Search Brands";
var classes = {
    root: /*#__PURE__*/ (0,emotion_css_esm/* css */.iv)("display:flex;flex-direction:row;justify-content:space-between;"),
    icon: /*#__PURE__*/ (0,emotion_css_esm/* css */.iv)("padding:20px;position:absolute;right:0;top:-9px;color:", theme/* Color.Gray800 */.Il.Gray800, ";"),
    placeholder: /*#__PURE__*/ (0,emotion_css_esm/* css */.iv)("::placeholder{color:", theme/* Color.Gray800 */.Il.Gray800, ";}"),
    input: /*#__PURE__*/ (0,emotion_css_esm/* css */.iv)("border:1px solid ", theme/* Color.Purple400 */.Il.Purple400, ";")
};
var SearchInput = function(param) {
    var setSearch = param.setSearch, defaultValue = param.defaultValue, className = param.className, placeholder = param.placeholder, trackSearchReset = param.trackSearchReset, filterList = param.filterList;
    var drain = (0,react.useContext)(DrainContext);
    var layoutData = LayoutDataContext_bs/* useContext */.qp();
    var ref = (0,react.useState)(defaultValue), searchTerm = ref[0], setSearchTerm = ref[1];
    (0,react.useEffect)(function() {
        drain.setSearch(searchTerm);
    }, [
        searchTerm
    ]);
    var configurablePlaceholder = (0,react.useMemo)(function() {
        return layoutData.searchBarPlaceholder.length > 0 ? layoutData.searchBarPlaceholder : placeholder || placeholder;
    }, [
        layoutData.searchBarPlaceholder,
        placeholder
    ]);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)("div", {
        className: classnames_default()([
            className,
            classes.root
        ]),
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("input", {
                name: "search",
                value: searchTerm,
                placeholder: !(0,lodash.isEmpty)(configurablePlaceholder) ? configurablePlaceholder : filterList.search.title || DEFAULT_SEARCH_PLACEHOLDER,
                className: classnames_default()([
                    "text-base bg-white h-12 pr-12 pl-6 lg:pl-6 sm:pl-6 outline-none focus:outline-none focus:shadow-sm w-full rounded-full",
                    classes.placeholder,
                    classes.input,
                    "search-input", 
                ]),
                onChange: function(event) {
                    var value = event.target.value;
                    var cleanValue = alphaNumericSearch(value);
                    drain.trackDrainFilterSection(drain.filter, cleanValue);
                    drain.onSearchChange(true);
                    setSearchTerm(value);
                    setSearch(cleanValue);
                }
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("div", {
                className: classes.icon,
                children: searchTerm.length > 0 ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(index_es.FontAwesomeIcon, {
                    icon: [
                        "far",
                        "times"
                    ],
                    className: classnames_default()({
                        "cursor-pointer": searchTerm.length > 0,
                        "clear-button": true
                    }),
                    onClick: function() {
                        if (searchTerm.length > 0) {
                            setSearchTerm(string/* EMPTY_STRING */.v6);
                            drain.setSearch(string/* EMPTY_STRING */.v6);
                            drain.trackDrainFilterSection(drain.filter, string/* EMPTY_STRING */.v6);
                            trackSearchReset();
                        }
                    }
                }) : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(index_es.FontAwesomeIcon, {
                    icon: [
                        "far",
                        "search"
                    ]
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/pages/store/sorting/SelectLabel.tsx





var SelectLabel_classes = {
    select: function(isOpen) {
        return /*#__PURE__*/ (0,emotion_css_esm/* css */.iv)("display:flex;flex-direction:row;justify-content:space-between;align-items:center;border-radius:100px;padding:13px 8px 13px 20px;cursor:pointer;background-color:", isOpen ? theme/* Color.Purple400 */.Il.Purple400 : theme/* Color.White */.Il.White, ";border:1px solid ", theme/* Color.Purple400 */.Il.Purple400, ";width:100%;@media (min-width:1288px){border:1px solid ", isOpen ? theme/* Color.Blue400 */.Il.Blue400 : theme/* Color.Purple400 */.Il.Purple400, ";background-color:", theme/* Color.White */.Il.White, ";:hover{background-color:", theme/* Color.Purple400 */.Il.Purple400, ";color:", theme/* Color.White */.Il.White, ";}}");
    },
    caret: function(isDropdownOpen) {
        return /*#__PURE__*/ (0,emotion_css_esm/* css */.iv)("font-size:14px;padding:0px 12px;box-sizing:content-box;transition:transform 0.3s;transform:rotate(", isDropdownOpen ? 180 : 0, "deg);@media (max-width:1288px){color:", isDropdownOpen ? theme/* Color.White */.Il.White : theme/* Color.Gray800 */.Il.Gray800, ";}");
    },
    label: function(isDropdownOpen) {
        return /*#__PURE__*/ (0,emotion_css_esm/* css */.iv)("font-size:14px;line-height:22px;@media (max-width:1288px){color:", isDropdownOpen ? theme/* Color.White */.Il.White : theme/* Color.Gray800 */.Il.Gray800, ";}");
    }
};
var DEFAULT_SORT_DISPLAY_VALUE = "Sort by";
var SelectLabel = function(param) {
    var _isOpen = param.isOpen, isOpen = _isOpen === void 0 ? false : _isOpen, activeOption = param.activeOption, setOpen = param.setOpen;
    var selectRef = (0,react.useRef)(null);
    (0,react.useEffect)(function() {
        var handleClick = function(event) {
            if (selectRef.current && !selectRef.current.contains(event.target)) {
                setOpen(false);
            }
        };
        document.addEventListener("click", handleClick);
        return function() {
            return document.removeEventListener("click", handleClick);
        };
    }, [
        selectRef
    ]);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(emotion_react_jsx_runtime_browser_esm.Fragment, {
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)("div", {
            ref: selectRef,
            onClick: function() {
                return setOpen(function(prev) {
                    return !prev;
                });
            },
            className: SelectLabel_classes.select(isOpen),
            children: [
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("div", {
                    className: SelectLabel_classes.label(isOpen),
                    children: activeOption ? activeOption.label : DEFAULT_SORT_DISPLAY_VALUE
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(index_es.FontAwesomeIcon, {
                    className: SelectLabel_classes.caret(isOpen),
                    icon: [
                        "fas",
                        "caret-down"
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var sorting_SelectLabel = (SelectLabel);

// EXTERNAL MODULE: ./node_modules/@prezzee/tokens/lib/index.js
var tokens_lib = __webpack_require__(53126);
;// CONCATENATED MODULE: ./src/components/pages/store/sorting/SelectItem.tsx





var SelectItem_classes = {
    item: function(isActive) {
        return /*#__PURE__*/ (0,emotion_css_esm/* css */.iv)("cursor:pointer;padding:", tokens_lib.spacing.spacing035, ";transition:0.3s;color:", isActive ? theme/* Color.Blue400 */.Il.Blue400 : "initial", ";font-size:14px;background-color:", isActive ? theme/* Color.Lilac50 */.Il.Lilac50 : "initial", ";:hover{background-color:", theme/* Color.Lilac50 */.Il.Lilac50, ";}");
    }
};
var SelectItem = function(param) {
    var option = param.option, activeOption = param.activeOption, setSortOption = param.setSortOption, onClose = param.onClose;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("li", {
        "aria-hidden": "true",
        onClick: function() {
            setSortOption(option);
            onClose();
        },
        className: SelectItem_classes.item(option && activeOption ? option.value === activeOption.value : false),
        children: option.label
    });
};
/* harmony default export */ var sorting_SelectItem = (SelectItem);

;// CONCATENATED MODULE: ./src/components/pages/store/sorting/SelectList.tsx






var style = {
    list: function(isDropdownOpen) {
        return /*#__PURE__*/ (0,emotion_css_esm/* css */.iv)("display:", isDropdownOpen ? "block" : "none", ";opacity:", isDropdownOpen ? 1 : 0, ";min-width:200px;position:absolute;right:0;margin-top:", tokens_lib.spacing.spacing02, ";width:100%;padding:4px 1px;border-radius:8px;box-shadow:0px 6px 12px rgba(0,0,0,0.11);transition:0.3s;z-index:999;background-color:", theme/* Color.White */.Il.White, ";border:1px solid #deddde;");
    }
};
var SelectList = function(param) {
    var options = param.options, isDropdownOpen = param.isDropdownOpen, activeOption = param.activeOption, onClose = param.onClose, setSortOption = param.setSortOption;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("ul", {
        className: style.list(isDropdownOpen),
        children: options ? options.map(function(el, idx) {
            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(sorting_SelectItem, {
                option: el,
                activeOption: activeOption,
                setSortOption: setSortOption,
                onClose: onClose
            }, idx);
        }) : utils_react/* EMPTY_ELEMENT */.O
    });
};
/* harmony default export */ var sorting_SelectList = (SelectList);

;// CONCATENATED MODULE: ./src/components/pages/store/sorting/index.tsx










var sorting_classes = {
    dropdown: /*#__PURE__*/ (0,emotion_css_esm/* css */.iv)("position:relative;//width:160px;@media (min-width:1288px){//width:200px;}")
};
var DEFAULT_SORT_OPTION_LIST = function(filterList) {
    return [
        {
            label: (0,lodash.get)(filterList, "sort.options.literalUp.title", "A - Z"),
            value: SortValue.LiteralUp
        },
        {
            label: (0,lodash.get)(filterList, "sort.options.literalDown.title", "Z - A"),
            value: SortValue.LiteralDown
        },
        {
            label: (0,lodash.get)(filterList, "sort.options.featured.title", "Featured"),
            value: SortValue.Featured
        },
        {
            label: (0,lodash.get)(filterList, "sort.options.newArrivals.title", "New Arrivals"),
            value: SortValue.NewArrivals
        }, 
    ];
};
var DEFAULT_SORT_LABEL = "Sort by";
var SelectSorting = function(param) {
    var className = param.className, filterList = param.filterList, hidden = param.hidden;
    var drain = (0,react.useContext)(DrainContext);
    var router = (0,next_router.useRouter)();
    var sortLabel = (0,lodash.find)(DEFAULT_SORT_OPTION_LIST(filterList), function(param) {
        var value = param.value;
        return value === drain.sort;
    }).label;
    var ref = (0,react.useState)(false), isDropdownOpen = ref[0], setDropdownOpen = ref[1];
    var ref1 = (0,react.useState)({
        value: drain.sort,
        label: drain.sort === SortValue.Featured ? DEFAULT_SORT_LABEL : sortLabel
    }), activeOption = ref1[0], setActiveOption = ref1[1];
    (0,react.useEffect)(function() {
        router.events.on("routeChangeStart", function() {
            drain.setSortValue(SortValue.Featured, SortValue.Featured);
        });
    }, []);
    var onClose = (0,react.useCallback)(function() {
        setDropdownOpen(false);
    }, []);
    var setSortOption = (0,react.useCallback)(function(option) {
        drain.setSortValue(option.value, activeOption.value);
        drain.switchFilter({
            sorting: {
                current: option.value,
                previous: activeOption.value
            },
            apply: true,
            display: false
        });
        var products = drain.currentValue.current.filter(function(param) {
            var isSwappable = param.isSwappable;
            return !isSwappable;
        }).map((0,lodash.rearg)(Segment_bs/* cardToProductWithIndex */.bC, [
            1,
            0
        ]));
        (0,Segment_bs/* productListViewed */.ZX)({
            list_id: "catalogue-promo",
            category: "Featured",
            products: products
        });
        setActiveOption(option);
    }, [
        activeOption,
        drain.filter,
        drain.search
    ]);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)("div", {
        className: classnames_default()([
            sorting_classes.dropdown,
            className,
            hidden ? "hidden" : void 0
        ]),
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(sorting_SelectLabel, {
                activeOption: activeOption,
                isOpen: isDropdownOpen,
                setOpen: setDropdownOpen
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(sorting_SelectList, {
                options: DEFAULT_SORT_OPTION_LIST(filterList),
                activeOption: activeOption || DEFAULT_SORT_OPTION_LIST(filterList)[2],
                isDropdownOpen: isDropdownOpen,
                setSortOption: setSortOption,
                onClose: onClose
            })
        ]
    });
};
/* harmony default export */ var sorting = (SelectSorting);

;// CONCATENATED MODULE: ./src/components/library/FilterInput.tsx










var DEFAULT_FILTER_PLACEHOLDER = "Filter";
var FilterInput_classes = {
    root: /*#__PURE__*/ (0,emotion_css_esm/* css */.iv)("position:relative;display:flex;flex-direction:row;"),
    icon: /*#__PURE__*/ (0,emotion_css_esm/* css */.iv)("padding:20px;position:absolute;right:0;top:-9px;color:", theme/* Color.Gray800 */.Il.Gray800, ";"),
    placeholder: /*#__PURE__*/ (0,emotion_css_esm/* css */.iv)("::placeholder{color:", theme/* Color.Gray800 */.Il.Gray800, ";}"),
    input: /*#__PURE__*/ (0,emotion_css_esm/* css */.iv)("border:1px solid ", theme/* Color.Purple400 */.Il.Purple400, ";")
};
var FilterInput = function(param) {
    var className = param.className, filterList = param.filterList, type = param.type;
    var drain = (0,react.useContext)(DrainContext);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)("div", {
        className: classnames_default()([
            FilterInput_classes.root
        ]),
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("div", {
                className: classnames_default()([
                    className
                ]),
                children: type === DrainType.Filter ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("input", {
                    name: "search",
                    value: void 0,
                    placeholder: filterList.filter.title || DEFAULT_FILTER_PLACEHOLDER,
                    className: classnames_default()([
                        "text-base bg-white h-12 pr-12 pl-6 lg:pl-6 sm:pl-6 outline-none focus:outline-none focus:shadow-sm w-full rounded-full",
                        FilterInput_classes.placeholder,
                        FilterInput_classes.input, 
                    ]),
                    autoComplete: "off",
                    onClick: function(event) {
                        event.currentTarget.blur();
                        document.body.style.overflow = "hidden";
                        drain.switchFilter({
                            apply: false
                        });
                    }
                }) : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(sorting, {
                    hidden: !getFilterTaxonomyOptions(filterList).sort.switched,
                    filterList: filterList,
                    className: "flex-1 relative"
                })
            }),
            type === DrainType.Filter ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("div", {
                className: FilterInput_classes.icon,
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(index_es.FontAwesomeIcon, {
                    icon: [
                        "far",
                        "sliders-h"
                    ],
                    onClick: function(event) {
                        event.currentTarget.blur();
                        document.body.style.overflow = "hidden";
                        drain.switchFilter({
                            apply: false
                        });
                    }
                })
            }) : utils_react/* EMPTY_ELEMENT */.O
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/pages/store/FilterGroupMobile.tsx









var FilterGroupMobile_classes = {
    filter: {
        element: function(hasFilter, hasSorting) {
            return /*#__PURE__*/ (0,emotion_css_esm/* css */.iv)("position:relative;width:", hasFilter && hasSorting ? "50%" : "100%", ";margin-right:12px;&:last-child{margin-right:0;}");
        },
        marker: {
            root: /*#__PURE__*/ (0,emotion_css_esm/* css */.iv)("position:absolute;top:-4px;right:3px;background-color:#276ef1;height:12px;width:12px;border-radius:50%;margin-top:4px;"),
            item: /*#__PURE__*/ (0,emotion_css_esm/* css */.iv)("font-size:14px;padding-left:5px;padding-top:0;color:#ffffff;font-weight:600;line-height:100%;")
        }
    }
};
var FilterGroupMobile = function(param) {
    var className = param.className, filterList = param.filterList;
    var drain = (0,react.useContext)(DrainContext);
    var hasFilter = (0,lodash.sum)((0,lodash.map)(filterList.elements, function(param) {
        var terms = param.terms;
        return terms.length;
    })) > 0;
    var hasSorting = getFilterTaxonomyOptions(filterList).sort.switched;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)("div", {
        className: className,
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)("div", {
                className: classnames_default()([
                    FilterGroupMobile_classes.filter.element(hasFilter, hasSorting)
                ]),
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(FilterInput, {
                        filterList: filterList,
                        className: "flex-1 relative",
                        type: DrainType.Filter
                    }),
                    drain.filter.elements.length > 0 ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("div", {
                        className: FilterGroupMobile_classes.filter.marker.root
                    }) : utils_react/* EMPTY_ELEMENT */.O
                ]
            }),
            hasSorting ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("div", {
                className: FilterGroupMobile_classes.filter.element(hasFilter, hasSorting),
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(FilterInput, {
                    filterList: filterList,
                    className: "flex-1 relative",
                    type: DrainType.Sorting
                })
            }) : utils_react/* EMPTY_ELEMENT */.O
        ]
    });
};
/* harmony default export */ var store_FilterGroupMobile = (FilterGroupMobile);

// EXTERNAL MODULE: ./node_modules/@prezzee/ribbon-ui/lib/components/icons/CaretDownIcon.js
var CaretDownIcon = __webpack_require__(34708);
// EXTERNAL MODULE: ./node_modules/@prezzee/ribbon-ui/lib/components/Typography/index.js
var Typography = __webpack_require__(43543);
;// CONCATENATED MODULE: ./node_modules/@chakra-ui/react/node_modules/@chakra-ui/checkbox/dist/chunk-2TOCDA5N.mjs
'use client'

// src/use-initial-animation-state.tsx
;
function useInitialAnimationState(isChecked) {
  const [previousIsChecked, setPreviousIsChecked] = (0,react.useState)(isChecked);
  const [shouldAnimate, setShouldAnimate] = (0,react.useState)(false);
  if (isChecked !== previousIsChecked) {
    setShouldAnimate(true);
    setPreviousIsChecked(isChecked);
  }
  return shouldAnimate;
}


//# sourceMappingURL=chunk-2TOCDA5N.mjs.map
;// CONCATENATED MODULE: ./node_modules/@chakra-ui/react-context/dist/index.mjs
'use client'

// src/index.ts
;
function getErrorMessage(hook, provider) {
  return `${hook} returned \`undefined\`. Seems you forgot to wrap component within ${provider}`;
}
function createContext(options = {}) {
  const {
    name,
    strict = true,
    hookName = "useContext",
    providerName = "Provider",
    errorMessage,
    defaultValue
  } = options;
  const Context = (0,react.createContext)(defaultValue);
  Context.displayName = name;
  function useContext() {
    var _a;
    const context = (0,react.useContext)(Context);
    if (!context && strict) {
      const error = new Error(
        errorMessage != null ? errorMessage : getErrorMessage(hookName, providerName)
      );
      error.name = "ContextError";
      (_a = Error.captureStackTrace) == null ? void 0 : _a.call(Error, error, useContext);
      throw error;
    }
    return context;
  }
  return [Context.Provider, useContext, Context];
}

//# sourceMappingURL=index.mjs.map
;// CONCATENATED MODULE: ./node_modules/@chakra-ui/react/node_modules/@chakra-ui/checkbox/dist/chunk-LYGBQ47X.mjs
'use client'

// src/checkbox-context.ts
;
var [CheckboxGroupProvider, useCheckboxGroupContext] = createContext({
  name: "CheckboxGroupContext",
  strict: false
});


//# sourceMappingURL=chunk-LYGBQ47X.mjs.map
// EXTERNAL MODULE: ./node_modules/@chakra-ui/system/dist/chunk-ZHQNHOQS.mjs + 3 modules
var chunk_ZHQNHOQS = __webpack_require__(65548);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./node_modules/@chakra-ui/react/node_modules/@chakra-ui/checkbox/dist/chunk-ULEC7HZU.mjs
'use client'

// src/checkbox-icon.tsx
;

function CheckIcon(props) {
  return /* @__PURE__ */ (0,jsx_runtime.jsx)(
    chunk_ZHQNHOQS/* chakra.svg */.m.svg,
    {
      width: "1.2em",
      viewBox: "0 0 12 10",
      style: {
        fill: "none",
        strokeWidth: 2,
        stroke: "currentColor",
        strokeDasharray: 16
      },
      ...props,
      children: /* @__PURE__ */ (0,jsx_runtime.jsx)("polyline", { points: "1.5 6 4.5 9 10.5 1" })
    }
  );
}
function IndeterminateIcon(props) {
  return /* @__PURE__ */ (0,jsx_runtime.jsx)(
    chunk_ZHQNHOQS/* chakra.svg */.m.svg,
    {
      width: "1.2em",
      viewBox: "0 0 24 24",
      style: { stroke: "currentColor", strokeWidth: 4 },
      ...props,
      children: /* @__PURE__ */ (0,jsx_runtime.jsx)("line", { x1: "21", x2: "3", y1: "12", y2: "12" })
    }
  );
}
function CheckboxIcon(props) {
  const { isIndeterminate, isChecked, ...rest } = props;
  const BaseIcon = isIndeterminate ? IndeterminateIcon : CheckIcon;
  return isChecked || isIndeterminate ? /* @__PURE__ */ (0,jsx_runtime.jsx)(
    chunk_ZHQNHOQS/* chakra.div */.m.div,
    {
      style: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        height: "100%"
      },
      children: /* @__PURE__ */ (0,jsx_runtime.jsx)(BaseIcon, { ...rest })
    }
  ) : null;
}


//# sourceMappingURL=chunk-ULEC7HZU.mjs.map
;// CONCATENATED MODULE: ./node_modules/@chakra-ui/react-use-merge-refs/dist/index.mjs
'use client'

// src/index.ts
;
function assignRef(ref, value) {
  if (ref == null)
    return;
  if (typeof ref === "function") {
    ref(value);
    return;
  }
  try {
    ref.current = value;
  } catch (error) {
    throw new Error(`Cannot assign value '${value}' to ref '${ref}'`);
  }
}
function mergeRefs(...refs) {
  return (node) => {
    refs.forEach((ref) => {
      assignRef(ref, node);
    });
  };
}
function useMergeRefs(...refs) {
  return useMemo(() => mergeRefs(...refs), refs);
}

//# sourceMappingURL=index.mjs.map
// EXTERNAL MODULE: ./node_modules/@chakra-ui/system/dist/chunk-ZJJGQIVY.mjs
var chunk_ZJJGQIVY = __webpack_require__(16554);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/system/dist/chunk-TKWR62NH.mjs + 2 modules
var chunk_TKWR62NH = __webpack_require__(12575);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/styled-system/dist/index.mjs
var dist = __webpack_require__(33179);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/shared-utils/dist/index.mjs
var shared_utils_dist = __webpack_require__(25432);
;// CONCATENATED MODULE: ./node_modules/@chakra-ui/form-control/dist/chunk-R42ZB7PB.mjs
'use client'

// src/form-control.tsx
;





var [FormControlStylesProvider, useFormControlStyles] = createContext({
  name: `FormControlStylesContext`,
  errorMessage: `useFormControlStyles returned is 'undefined'. Seems you forgot to wrap the components in "<FormControl />" `
});
var [FormControlProvider, useFormControlContext] = createContext({
  strict: false,
  name: "FormControlContext"
});
function useFormControlProvider(props) {
  const {
    id: idProp,
    isRequired,
    isInvalid,
    isDisabled,
    isReadOnly,
    ...htmlProps
  } = props;
  const uuid = (0,react.useId)();
  const id = idProp || `field-${uuid}`;
  const labelId = `${id}-label`;
  const feedbackId = `${id}-feedback`;
  const helpTextId = `${id}-helptext`;
  const [hasFeedbackText, setHasFeedbackText] = (0,react.useState)(false);
  const [hasHelpText, setHasHelpText] = (0,react.useState)(false);
  const [isFocused, setFocus] = (0,react.useState)(false);
  const getHelpTextProps = (0,react.useCallback)(
    (props2 = {}, forwardedRef = null) => ({
      id: helpTextId,
      ...props2,
      /**
       * Notify the field context when the help text is rendered on screen,
       * so we can apply the correct `aria-describedby` to the field (e.g. input, textarea).
       */
      ref: mergeRefs(forwardedRef, (node) => {
        if (!node)
          return;
        setHasHelpText(true);
      })
    }),
    [helpTextId]
  );
  const getLabelProps = (0,react.useCallback)(
    (props2 = {}, forwardedRef = null) => ({
      ...props2,
      ref: forwardedRef,
      "data-focus": (0,shared_utils_dist/* dataAttr */.PB)(isFocused),
      "data-disabled": (0,shared_utils_dist/* dataAttr */.PB)(isDisabled),
      "data-invalid": (0,shared_utils_dist/* dataAttr */.PB)(isInvalid),
      "data-readonly": (0,shared_utils_dist/* dataAttr */.PB)(isReadOnly),
      id: props2.id !== void 0 ? props2.id : labelId,
      htmlFor: props2.htmlFor !== void 0 ? props2.htmlFor : id
    }),
    [id, isDisabled, isFocused, isInvalid, isReadOnly, labelId]
  );
  const getErrorMessageProps = (0,react.useCallback)(
    (props2 = {}, forwardedRef = null) => ({
      id: feedbackId,
      ...props2,
      /**
       * Notify the field context when the error message is rendered on screen,
       * so we can apply the correct `aria-describedby` to the field (e.g. input, textarea).
       */
      ref: mergeRefs(forwardedRef, (node) => {
        if (!node)
          return;
        setHasFeedbackText(true);
      }),
      "aria-live": "polite"
    }),
    [feedbackId]
  );
  const getRootProps = (0,react.useCallback)(
    (props2 = {}, forwardedRef = null) => ({
      ...props2,
      ...htmlProps,
      ref: forwardedRef,
      role: "group"
    }),
    [htmlProps]
  );
  const getRequiredIndicatorProps = (0,react.useCallback)(
    (props2 = {}, forwardedRef = null) => ({
      ...props2,
      ref: forwardedRef,
      role: "presentation",
      "aria-hidden": true,
      children: props2.children || "*"
    }),
    []
  );
  return {
    isRequired: !!isRequired,
    isInvalid: !!isInvalid,
    isReadOnly: !!isReadOnly,
    isDisabled: !!isDisabled,
    isFocused: !!isFocused,
    onFocus: () => setFocus(true),
    onBlur: () => setFocus(false),
    hasFeedbackText,
    setHasFeedbackText,
    hasHelpText,
    setHasHelpText,
    id,
    labelId,
    feedbackId,
    helpTextId,
    htmlProps,
    getHelpTextProps,
    getErrorMessageProps,
    getRootProps,
    getLabelProps,
    getRequiredIndicatorProps
  };
}
var FormControl = (0,chunk_ZJJGQIVY/* forwardRef */.G)(
  function FormControl2(props, ref) {
    const styles = (0,chunk_TKWR62NH/* useMultiStyleConfig */.jC)("Form", props);
    const ownProps = (0,dist/* omitThemingProps */.Lr)(props);
    const {
      getRootProps,
      htmlProps: _,
      ...context
    } = useFormControlProvider(ownProps);
    const className = (0,shared_utils_dist.cx)("chakra-form-control", props.className);
    return /* @__PURE__ */ (0,jsx_runtime.jsx)(FormControlProvider, { value: context, children: /* @__PURE__ */ (0,jsx_runtime.jsx)(FormControlStylesProvider, { value: styles, children: /* @__PURE__ */ (0,jsx_runtime.jsx)(
      chunk_ZHQNHOQS/* chakra.div */.m.div,
      {
        ...getRootProps({}, ref),
        className,
        __css: styles["container"]
      }
    ) }) });
  }
);
FormControl.displayName = "FormControl";
var FormHelperText = (0,chunk_ZJJGQIVY/* forwardRef */.G)(
  function FormHelperText2(props, ref) {
    const field = useFormControlContext();
    const styles = useFormControlStyles();
    const className = (0,shared_utils_dist.cx)("chakra-form__helper-text", props.className);
    return /* @__PURE__ */ (0,jsx_runtime.jsx)(
      chunk_ZHQNHOQS/* chakra.div */.m.div,
      {
        ...field == null ? void 0 : field.getHelpTextProps(props, ref),
        __css: styles.helperText,
        className
      }
    );
  }
);
FormHelperText.displayName = "FormHelperText";


//# sourceMappingURL=chunk-R42ZB7PB.mjs.map
;// CONCATENATED MODULE: ./node_modules/@chakra-ui/form-control/dist/chunk-XRMX4GAI.mjs
'use client'
;

// src/use-form-control.ts

function useFormControl(props) {
  const { isDisabled, isInvalid, isReadOnly, isRequired, ...rest } = useFormControlProps(props);
  return {
    ...rest,
    disabled: isDisabled,
    readOnly: isReadOnly,
    required: isRequired,
    "aria-invalid": ariaAttr(isInvalid),
    "aria-required": ariaAttr(isRequired),
    "aria-readonly": ariaAttr(isReadOnly)
  };
}
function useFormControlProps(props) {
  var _a, _b, _c;
  const field = useFormControlContext();
  const {
    id,
    disabled,
    readOnly,
    required,
    isRequired,
    isInvalid,
    isReadOnly,
    isDisabled,
    onFocus,
    onBlur,
    ...rest
  } = props;
  const labelIds = props["aria-describedby"] ? [props["aria-describedby"]] : [];
  if ((field == null ? void 0 : field.hasFeedbackText) && (field == null ? void 0 : field.isInvalid)) {
    labelIds.push(field.feedbackId);
  }
  if (field == null ? void 0 : field.hasHelpText) {
    labelIds.push(field.helpTextId);
  }
  return {
    ...rest,
    "aria-describedby": labelIds.join(" ") || void 0,
    id: id != null ? id : field == null ? void 0 : field.id,
    isDisabled: (_a = disabled != null ? disabled : isDisabled) != null ? _a : field == null ? void 0 : field.isDisabled,
    isReadOnly: (_b = readOnly != null ? readOnly : isReadOnly) != null ? _b : field == null ? void 0 : field.isReadOnly,
    isRequired: (_c = required != null ? required : isRequired) != null ? _c : field == null ? void 0 : field.isRequired,
    isInvalid: isInvalid != null ? isInvalid : field == null ? void 0 : field.isInvalid,
    onFocus: (0,shared_utils_dist/* callAllHandlers */.v0)(field == null ? void 0 : field.onFocus, onFocus),
    onBlur: (0,shared_utils_dist/* callAllHandlers */.v0)(field == null ? void 0 : field.onBlur, onBlur)
  };
}


//# sourceMappingURL=chunk-XRMX4GAI.mjs.map
;// CONCATENATED MODULE: ./node_modules/@chakra-ui/react-use-safe-layout-effect/dist/index.mjs
'use client'

// src/index.ts
;
var useSafeLayoutEffect = Boolean(globalThis == null ? void 0 : globalThis.document) ? react.useLayoutEffect : react.useEffect;

//# sourceMappingURL=index.mjs.map
;// CONCATENATED MODULE: ./node_modules/@chakra-ui/react-use-update-effect/dist/index.mjs
'use client'

// src/index.ts
;
function useUpdateEffect(callback, deps) {
  const renderCycleRef = (0,react.useRef)(false);
  const effectCycleRef = (0,react.useRef)(false);
  (0,react.useEffect)(() => {
    const mounted = renderCycleRef.current;
    const run = mounted && effectCycleRef.current;
    if (run) {
      return callback();
    }
    effectCycleRef.current = true;
  }, deps);
  (0,react.useEffect)(() => {
    renderCycleRef.current = true;
    return () => {
      renderCycleRef.current = false;
    };
  }, []);
}

//# sourceMappingURL=index.mjs.map
;// CONCATENATED MODULE: ./node_modules/@chakra-ui/react-use-callback-ref/dist/index.mjs
'use client'

// src/index.ts
;
function dist_useCallbackRef(callback, deps = []) {
  const callbackRef = (0,react.useRef)(callback);
  (0,react.useEffect)(() => {
    callbackRef.current = callback;
  });
  return (0,react.useCallback)((...args) => {
    var _a;
    return (_a = callbackRef.current) == null ? void 0 : _a.call(callbackRef, ...args);
  }, deps);
}

//# sourceMappingURL=index.mjs.map
;// CONCATENATED MODULE: ./node_modules/@chakra-ui/visually-hidden/dist/chunk-3JHDQ75O.mjs
'use client'

// src/visually-hidden.style.ts
var visuallyHiddenStyle = {
  border: "0",
  clip: "rect(0, 0, 0, 0)",
  height: "1px",
  width: "1px",
  margin: "-1px",
  padding: "0",
  overflow: "hidden",
  whiteSpace: "nowrap",
  position: "absolute"
};


//# sourceMappingURL=chunk-3JHDQ75O.mjs.map
;// CONCATENATED MODULE: ./node_modules/@zag-js/dom-query/dist/platform.mjs
const isDom = () => typeof document !== "undefined";
function getPlatform() {
  const agent = navigator.userAgentData;
  return agent?.platform ?? navigator.platform;
}
const pt = (v) => isDom() && v.test(getPlatform());
const ua = (v) => isDom() && v.test(navigator.userAgent);
const vn = (v) => isDom() && v.test(navigator.vendor);
const isTouchDevice = () => isDom() && !!navigator.maxTouchPoints;
const isMac = () => pt(/^Mac/) && !isTouchDevice();
const isIPhone = () => pt(/^iPhone/);
const isSafari = () => isApple() && vn(/apple/i);
const isFirefox = () => ua(/firefox\//i);
const isApple = () => pt(/mac|iphone|ipad|ipod/i);
const isIos = () => isApple() && !isMac();



;// CONCATENATED MODULE: ./node_modules/@zag-js/focus-visible/dist/index.mjs


let hasSetup = false;
let modality = null;
let hasEventBeforeFocus = false;
let hasBlurredWindowRecently = false;
const handlers = /* @__PURE__ */ new Set();
function trigger(modality2, event) {
  handlers.forEach((handler) => handler(modality2, event));
}
const dist_isMac = typeof window !== "undefined" && window.navigator != null ? /^Mac/.test(window.navigator.platform) : false;
function isValidKey(e) {
  return !(e.metaKey || !dist_isMac && e.altKey || e.ctrlKey || e.key === "Control" || e.key === "Shift" || e.key === "Meta");
}
function onKeyboardEvent(event) {
  hasEventBeforeFocus = true;
  if (isValidKey(event)) {
    modality = "keyboard";
    trigger("keyboard", event);
  }
}
function onPointerEvent(event) {
  modality = "pointer";
  if (event.type === "mousedown" || event.type === "pointerdown") {
    hasEventBeforeFocus = true;
    const target = event.composedPath ? event.composedPath()[0] : event.target;
    let matches = false;
    try {
      matches = target.matches(":focus-visible");
    } catch {
    }
    if (matches)
      return;
    trigger("pointer", event);
  }
}
function isVirtualClick(event) {
  if (event.mozInputSource === 0 && event.isTrusted)
    return true;
  return event.detail === 0 && !event.pointerType;
}
function onClickEvent(e) {
  if (isVirtualClick(e)) {
    hasEventBeforeFocus = true;
    modality = "virtual";
  }
}
function onWindowFocus(event) {
  if (event.target === window || event.target === document) {
    return;
  }
  if (!hasEventBeforeFocus && !hasBlurredWindowRecently) {
    modality = "virtual";
    trigger("virtual", event);
  }
  hasEventBeforeFocus = false;
  hasBlurredWindowRecently = false;
}
function onWindowBlur() {
  hasEventBeforeFocus = false;
  hasBlurredWindowRecently = true;
}
function isFocusVisible() {
  return modality !== "pointer";
}
function setupGlobalFocusEvents() {
  if (!isDom() || hasSetup) {
    return;
  }
  const { focus } = HTMLElement.prototype;
  HTMLElement.prototype.focus = function focusElement(...args) {
    hasEventBeforeFocus = true;
    focus.apply(this, args);
  };
  document.addEventListener("keydown", onKeyboardEvent, true);
  document.addEventListener("keyup", onKeyboardEvent, true);
  document.addEventListener("click", onClickEvent, true);
  window.addEventListener("focus", onWindowFocus, true);
  window.addEventListener("blur", onWindowBlur, false);
  if (typeof PointerEvent !== "undefined") {
    document.addEventListener("pointerdown", onPointerEvent, true);
    document.addEventListener("pointermove", onPointerEvent, true);
    document.addEventListener("pointerup", onPointerEvent, true);
  } else {
    document.addEventListener("mousedown", onPointerEvent, true);
    document.addEventListener("mousemove", onPointerEvent, true);
    document.addEventListener("mouseup", onPointerEvent, true);
  }
  hasSetup = true;
}
function trackFocusVisible(fn) {
  setupGlobalFocusEvents();
  fn(isFocusVisible());
  const handler = () => fn(isFocusVisible());
  handlers.add(handler);
  return () => {
    handlers.delete(handler);
  };
}
function trackInteractionModality(fn) {
  setupGlobalFocusEvents();
  fn(modality);
  const handler = () => fn(modality);
  handlers.add(handler);
  return () => {
    handlers.delete(handler);
  };
}
function setInteractionModality(value) {
  modality = value;
  trigger(value, null);
}
function getInteractionModality() {
  return modality;
}



;// CONCATENATED MODULE: ./node_modules/@chakra-ui/react/node_modules/@chakra-ui/checkbox/dist/chunk-7D6N5TE5.mjs
'use client'

// src/use-checkbox.ts
;






// ../../utilities/object-utils/src/omit.ts
function omit(object, keysToOmit = []) {
  const clone = Object.assign({}, object);
  for (const key of keysToOmit) {
    if (key in clone) {
      delete clone[key];
    }
  }
  return clone;
}

// src/use-checkbox.ts



function useCheckbox(props = {}) {
  const formControlProps = useFormControlProps(props);
  const {
    isDisabled,
    isReadOnly,
    isRequired,
    isInvalid,
    id,
    onBlur,
    onFocus,
    "aria-describedby": ariaDescribedBy
  } = formControlProps;
  const {
    defaultChecked,
    isChecked: checkedProp,
    isFocusable,
    onChange,
    isIndeterminate,
    name,
    value,
    tabIndex = void 0,
    "aria-label": ariaLabel,
    "aria-labelledby": ariaLabelledBy,
    "aria-invalid": ariaInvalid,
    ...rest
  } = props;
  const htmlProps = omit(rest, [
    "isDisabled",
    "isReadOnly",
    "isRequired",
    "isInvalid",
    "id",
    "onBlur",
    "onFocus",
    "aria-describedby"
  ]);
  const onChangeProp = dist_useCallbackRef(onChange);
  const onBlurProp = dist_useCallbackRef(onBlur);
  const onFocusProp = dist_useCallbackRef(onFocus);
  const [isFocusVisible, setIsFocusVisible] = (0,react.useState)(false);
  const [isFocused, setFocused] = (0,react.useState)(false);
  const [isHovered, setHovered] = (0,react.useState)(false);
  const [isActive, setActive] = (0,react.useState)(false);
  (0,react.useEffect)(() => {
    return trackFocusVisible(setIsFocusVisible);
  }, []);
  const inputRef = (0,react.useRef)(null);
  const [rootIsLabelElement, setRootIsLabelElement] = (0,react.useState)(true);
  const [checkedState, setCheckedState] = (0,react.useState)(!!defaultChecked);
  const isControlled = checkedProp !== void 0;
  const isChecked = isControlled ? checkedProp : checkedState;
  const handleChange = (0,react.useCallback)(
    (event) => {
      if (isReadOnly || isDisabled) {
        event.preventDefault();
        return;
      }
      if (!isControlled) {
        if (isChecked) {
          setCheckedState(event.target.checked);
        } else {
          setCheckedState(isIndeterminate ? true : event.target.checked);
        }
      }
      onChangeProp == null ? void 0 : onChangeProp(event);
    },
    [
      isReadOnly,
      isDisabled,
      isChecked,
      isControlled,
      isIndeterminate,
      onChangeProp
    ]
  );
  useSafeLayoutEffect(() => {
    if (inputRef.current) {
      inputRef.current.indeterminate = Boolean(isIndeterminate);
    }
  }, [isIndeterminate]);
  useUpdateEffect(() => {
    if (isDisabled) {
      setFocused(false);
    }
  }, [isDisabled, setFocused]);
  useSafeLayoutEffect(() => {
    const el = inputRef.current;
    if (!(el == null ? void 0 : el.form))
      return;
    const formResetListener = () => {
      setCheckedState(!!defaultChecked);
    };
    el.form.addEventListener("reset", formResetListener);
    return () => {
      var _a;
      return (_a = el.form) == null ? void 0 : _a.removeEventListener("reset", formResetListener);
    };
  }, []);
  const trulyDisabled = isDisabled && !isFocusable;
  const onKeyDown = (0,react.useCallback)(
    (event) => {
      if (event.key === " ") {
        setActive(true);
      }
    },
    [setActive]
  );
  const onKeyUp = (0,react.useCallback)(
    (event) => {
      if (event.key === " ") {
        setActive(false);
      }
    },
    [setActive]
  );
  useSafeLayoutEffect(() => {
    if (!inputRef.current)
      return;
    const notInSync = inputRef.current.checked !== isChecked;
    if (notInSync) {
      setCheckedState(inputRef.current.checked);
    }
  }, [inputRef.current]);
  const getCheckboxProps = (0,react.useCallback)(
    (props2 = {}, forwardedRef = null) => {
      const onPressDown = (event) => {
        if (isFocused) {
          event.preventDefault();
        }
        setActive(true);
      };
      return {
        ...props2,
        ref: forwardedRef,
        "data-active": (0,shared_utils_dist/* dataAttr */.PB)(isActive),
        "data-hover": (0,shared_utils_dist/* dataAttr */.PB)(isHovered),
        "data-checked": (0,shared_utils_dist/* dataAttr */.PB)(isChecked),
        "data-focus": (0,shared_utils_dist/* dataAttr */.PB)(isFocused),
        "data-focus-visible": (0,shared_utils_dist/* dataAttr */.PB)(isFocused && isFocusVisible),
        "data-indeterminate": (0,shared_utils_dist/* dataAttr */.PB)(isIndeterminate),
        "data-disabled": (0,shared_utils_dist/* dataAttr */.PB)(isDisabled),
        "data-invalid": (0,shared_utils_dist/* dataAttr */.PB)(isInvalid),
        "data-readonly": (0,shared_utils_dist/* dataAttr */.PB)(isReadOnly),
        "aria-hidden": true,
        onMouseDown: (0,shared_utils_dist/* callAllHandlers */.v0)(props2.onMouseDown, onPressDown),
        onMouseUp: (0,shared_utils_dist/* callAllHandlers */.v0)(props2.onMouseUp, () => setActive(false)),
        onMouseEnter: (0,shared_utils_dist/* callAllHandlers */.v0)(
          props2.onMouseEnter,
          () => setHovered(true)
        ),
        onMouseLeave: (0,shared_utils_dist/* callAllHandlers */.v0)(
          props2.onMouseLeave,
          () => setHovered(false)
        )
      };
    },
    [
      isActive,
      isChecked,
      isDisabled,
      isFocused,
      isFocusVisible,
      isHovered,
      isIndeterminate,
      isInvalid,
      isReadOnly
    ]
  );
  const getIndicatorProps = (0,react.useCallback)(
    (props2 = {}, forwardedRef = null) => ({
      ...props2,
      ref: forwardedRef,
      "data-active": (0,shared_utils_dist/* dataAttr */.PB)(isActive),
      "data-hover": (0,shared_utils_dist/* dataAttr */.PB)(isHovered),
      "data-checked": (0,shared_utils_dist/* dataAttr */.PB)(isChecked),
      "data-focus": (0,shared_utils_dist/* dataAttr */.PB)(isFocused),
      "data-focus-visible": (0,shared_utils_dist/* dataAttr */.PB)(isFocused && isFocusVisible),
      "data-indeterminate": (0,shared_utils_dist/* dataAttr */.PB)(isIndeterminate),
      "data-disabled": (0,shared_utils_dist/* dataAttr */.PB)(isDisabled),
      "data-invalid": (0,shared_utils_dist/* dataAttr */.PB)(isInvalid),
      "data-readonly": (0,shared_utils_dist/* dataAttr */.PB)(isReadOnly)
    }),
    [
      isActive,
      isChecked,
      isDisabled,
      isFocused,
      isFocusVisible,
      isHovered,
      isIndeterminate,
      isInvalid,
      isReadOnly
    ]
  );
  const getRootProps = (0,react.useCallback)(
    (props2 = {}, forwardedRef = null) => ({
      ...htmlProps,
      ...props2,
      ref: mergeRefs(forwardedRef, (node) => {
        if (!node)
          return;
        setRootIsLabelElement(node.tagName === "LABEL");
      }),
      onClick: (0,shared_utils_dist/* callAllHandlers */.v0)(props2.onClick, () => {
        var _a;
        if (!rootIsLabelElement) {
          (_a = inputRef.current) == null ? void 0 : _a.click();
          requestAnimationFrame(() => {
            var _a2;
            (_a2 = inputRef.current) == null ? void 0 : _a2.focus({ preventScroll: true });
          });
        }
      }),
      "data-disabled": (0,shared_utils_dist/* dataAttr */.PB)(isDisabled),
      "data-checked": (0,shared_utils_dist/* dataAttr */.PB)(isChecked),
      "data-invalid": (0,shared_utils_dist/* dataAttr */.PB)(isInvalid)
    }),
    [htmlProps, isDisabled, isChecked, isInvalid, rootIsLabelElement]
  );
  const getInputProps = (0,react.useCallback)(
    (props2 = {}, forwardedRef = null) => {
      return {
        ...props2,
        ref: mergeRefs(inputRef, forwardedRef),
        type: "checkbox",
        name,
        value,
        id,
        tabIndex,
        onChange: (0,shared_utils_dist/* callAllHandlers */.v0)(props2.onChange, handleChange),
        onBlur: (0,shared_utils_dist/* callAllHandlers */.v0)(
          props2.onBlur,
          onBlurProp,
          () => setFocused(false)
        ),
        onFocus: (0,shared_utils_dist/* callAllHandlers */.v0)(
          props2.onFocus,
          onFocusProp,
          () => setFocused(true)
        ),
        onKeyDown: (0,shared_utils_dist/* callAllHandlers */.v0)(props2.onKeyDown, onKeyDown),
        onKeyUp: (0,shared_utils_dist/* callAllHandlers */.v0)(props2.onKeyUp, onKeyUp),
        required: isRequired,
        checked: isChecked,
        disabled: trulyDisabled,
        readOnly: isReadOnly,
        "aria-label": ariaLabel,
        "aria-labelledby": ariaLabelledBy,
        "aria-invalid": ariaInvalid ? Boolean(ariaInvalid) : isInvalid,
        "aria-describedby": ariaDescribedBy,
        "aria-disabled": isDisabled,
        style: visuallyHiddenStyle
      };
    },
    [
      name,
      value,
      id,
      handleChange,
      onBlurProp,
      onFocusProp,
      onKeyDown,
      onKeyUp,
      isRequired,
      isChecked,
      trulyDisabled,
      isReadOnly,
      ariaLabel,
      ariaLabelledBy,
      ariaInvalid,
      isInvalid,
      ariaDescribedBy,
      isDisabled,
      tabIndex
    ]
  );
  const getLabelProps = (0,react.useCallback)(
    (props2 = {}, forwardedRef = null) => ({
      ...props2,
      ref: forwardedRef,
      onMouseDown: (0,shared_utils_dist/* callAllHandlers */.v0)(props2.onMouseDown, stopEvent),
      "data-disabled": (0,shared_utils_dist/* dataAttr */.PB)(isDisabled),
      "data-checked": (0,shared_utils_dist/* dataAttr */.PB)(isChecked),
      "data-invalid": (0,shared_utils_dist/* dataAttr */.PB)(isInvalid)
    }),
    [isChecked, isDisabled, isInvalid]
  );
  const state = {
    isInvalid,
    isFocused,
    isChecked,
    isActive,
    isHovered,
    isIndeterminate,
    isDisabled,
    isReadOnly,
    isRequired
  };
  return {
    state,
    getRootProps,
    getCheckboxProps,
    getIndicatorProps,
    getInputProps,
    getLabelProps,
    htmlProps
  };
}
function stopEvent(event) {
  event.preventDefault();
  event.stopPropagation();
}


//# sourceMappingURL=chunk-7D6N5TE5.mjs.map
// EXTERNAL MODULE: ./node_modules/@emotion/react/dist/emotion-react.browser.esm.js + 1 modules
var emotion_react_browser_esm = __webpack_require__(43234);
;// CONCATENATED MODULE: ./node_modules/@chakra-ui/react/node_modules/@chakra-ui/checkbox/dist/chunk-P675YKMR.mjs
'use client'
;




// src/checkbox.tsx




var controlStyles = {
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
  verticalAlign: "top",
  userSelect: "none",
  flexShrink: 0
};
var rootStyles = {
  cursor: "pointer",
  display: "inline-flex",
  alignItems: "center",
  verticalAlign: "top",
  position: "relative"
};
var checkAnim = (0,emotion_react_browser_esm.keyframes)({
  from: {
    opacity: 0,
    strokeDashoffset: 16,
    transform: "scale(0.95)"
  },
  to: {
    opacity: 1,
    strokeDashoffset: 0,
    transform: "scale(1)"
  }
});
var indeterminateOpacityAnim = (0,emotion_react_browser_esm.keyframes)({
  from: {
    opacity: 0
  },
  to: {
    opacity: 1
  }
});
var indeterminateScaleAnim = (0,emotion_react_browser_esm.keyframes)({
  from: {
    transform: "scaleX(0.65)"
  },
  to: {
    transform: "scaleX(1)"
  }
});
var Checkbox = (0,chunk_ZJJGQIVY/* forwardRef */.G)(function Checkbox2(props, ref) {
  const group = useCheckboxGroupContext();
  const mergedProps = { ...group, ...props };
  const styles = (0,chunk_TKWR62NH/* useMultiStyleConfig */.jC)("Checkbox", mergedProps);
  const ownProps = (0,dist/* omitThemingProps */.Lr)(props);
  const {
    spacing = "0.5rem",
    className,
    children,
    iconColor,
    iconSize,
    icon = /* @__PURE__ */ (0,jsx_runtime.jsx)(CheckboxIcon, {}),
    isChecked: isCheckedProp,
    isDisabled = group == null ? void 0 : group.isDisabled,
    onChange: onChangeProp,
    inputProps,
    ...rest
  } = ownProps;
  let isChecked = isCheckedProp;
  if ((group == null ? void 0 : group.value) && ownProps.value) {
    isChecked = group.value.includes(ownProps.value);
  }
  let onChange = onChangeProp;
  if ((group == null ? void 0 : group.onChange) && ownProps.value) {
    onChange = (0,shared_utils_dist/* callAll */.PP)(group.onChange, onChangeProp);
  }
  const {
    state,
    getInputProps,
    getCheckboxProps,
    getLabelProps,
    getRootProps
  } = useCheckbox({
    ...rest,
    isDisabled,
    isChecked,
    onChange
  });
  const shouldAnimate = useInitialAnimationState(state.isChecked);
  const iconStyles = (0,react.useMemo)(
    () => ({
      animation: !shouldAnimate ? void 0 : state.isIndeterminate ? `${indeterminateOpacityAnim} 20ms linear, ${indeterminateScaleAnim} 200ms linear` : `${checkAnim} 200ms linear`,
      fontSize: iconSize,
      color: iconColor,
      ...styles.icon
    }),
    [iconColor, iconSize, shouldAnimate, state.isIndeterminate, styles.icon]
  );
  const clonedIcon = (0,react.cloneElement)(icon, {
    __css: iconStyles,
    isIndeterminate: state.isIndeterminate,
    isChecked: state.isChecked
  });
  return /* @__PURE__ */ (0,jsx_runtime.jsxs)(
    chunk_ZHQNHOQS/* chakra.label */.m.label,
    {
      __css: { ...rootStyles, ...styles.container },
      className: (0,shared_utils_dist.cx)("chakra-checkbox", className),
      ...getRootProps(),
      children: [
        /* @__PURE__ */ (0,jsx_runtime.jsx)(
          "input",
          {
            className: "chakra-checkbox__input",
            ...getInputProps(inputProps, ref)
          }
        ),
        /* @__PURE__ */ (0,jsx_runtime.jsx)(
          chunk_ZHQNHOQS/* chakra.span */.m.span,
          {
            __css: { ...controlStyles, ...styles.control },
            className: "chakra-checkbox__control",
            ...getCheckboxProps(),
            children: clonedIcon
          }
        ),
        children && /* @__PURE__ */ (0,jsx_runtime.jsx)(
          chunk_ZHQNHOQS/* chakra.span */.m.span,
          {
            className: "chakra-checkbox__label",
            ...getLabelProps(),
            __css: {
              marginStart: spacing,
              ...styles.label
            },
            children
          }
        )
      ]
    }
  );
});
Checkbox.displayName = "Checkbox";


//# sourceMappingURL=chunk-P675YKMR.mjs.map
;// CONCATENATED MODULE: ./src/components/selectFilter/SelectFilterCheckboxGroup.tsx






var SelectFilterCheckboxGroup_Styles = {
    container: /*#__PURE__*/ (0,emotion_css_esm/* css */.iv)("display:flex;flex-direction:column;margin:15px 16px 25px 0;padding:0 0 2px 16px;max-height:288px;overflow-y:auto;&::-webkit-scrollbar{width:4px;}&::-webkit-scrollbar-track{background-color:", colors["default"].gray[100], ";border-radius:2px;}&::-webkit-scrollbar-thumb{background-color:", colors["default"].purple[400], ";border-radius:2px;}"),
    checkbox: /*#__PURE__*/ (0,emotion_css_esm/* css */.iv)("margin:21px 0 0;&:first-child{margin:0;}"),
    label: /*#__PURE__*/ (0,emotion_css_esm/* css */.iv)("font-size:14px;line-height:14px;")
};
var SelectFilterCheckboxGroup = function(param) {
    var items = param.items, itemsStatus = param.itemsStatus, onChange = param.onChange, title = param.title, parentCodename = param.parentCodename;
    var drain = (0,react.useContext)(DrainContext);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("div", {
        className: SelectFilterCheckboxGroup_Styles.container,
        children: items.map(function(param) {
            var codename = param.codename, name = param.name;
            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(Checkbox, {
                size: "lg",
                name: name,
                className: SelectFilterCheckboxGroup_Styles.checkbox,
                isChecked: itemsStatus[codename],
                onChange: function(e) {
                    drain.appendFilter({
                        codename: codename,
                        name: name,
                        parent: {
                            parent: void 0,
                            name: title,
                            codename: parentCodename
                        }
                    });
                    onChange(e, codename, name);
                },
                isFocusable: false,
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("span", {
                    className: SelectFilterCheckboxGroup_Styles.label,
                    children: name
                })
            }, codename);
        })
    });
};
/* harmony default export */ var selectFilter_SelectFilterCheckboxGroup = (SelectFilterCheckboxGroup);

;// CONCATENATED MODULE: ./src/components/selectFilter/SelectFilterSearch.tsx






var SelectFilterSearch_Styles = {
    container: /*#__PURE__*/ (0,emotion_css_esm/* css */.iv)("position:relative;padding:12px 0;margin:0 16px;"),
    search: /*#__PURE__*/ (0,emotion_css_esm/* css */.iv)("border:1px solid ", colors["default"].purple[400], ";border-radius:25px;padding:13px 18px 13px 24px;color:", colors["default"].gray[600], ";width:100%;font-size:16px;line-height:24px;&:focus{outline:none;}&::placeholder{color:", colors["default"].gray[600], ";}"),
    icon: function(hidden) {
        return /*#__PURE__*/ (0,emotion_css_esm/* css */.iv)(hidden ? "display: none;" : "", "    position:absolute;top:50%;transform:translateY(-50%);right:18px;cursor:pointer;");
    }
};
var SelectFilterSearch = function(param) {
    var placeholder = param.placeholder, handleSearchChange = param.handleSearchChange;
    var ref = (0,react.useState)(string/* EMPTY_STRING */.v6), value = ref[0], setValue = ref[1];
    var isIconHidden = value !== string/* EMPTY_STRING */.v6;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)("div", {
        className: SelectFilterSearch_Styles.container,
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("input", {
                value: value,
                className: SelectFilterSearch_Styles.search,
                type: "search",
                placeholder: placeholder,
                onChange: function(e) {
                    var searchValue = e.target.value;
                    setValue(searchValue);
                    handleSearchChange(searchValue);
                }
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(index_es.FontAwesomeIcon, {
                icon: [
                    "far",
                    "search"
                ],
                className: SelectFilterSearch_Styles.icon(isIconHidden),
                size: "sm"
            })
        ]
    });
};
/* harmony default export */ var selectFilter_SelectFilterSearch = (SelectFilterSearch);

;// CONCATENATED MODULE: ./src/components/selectFilter/SelectFilterPopup.tsx















var SelectFilterPopup_Styles = {
    container: function(isOpen, isFourColumns, popupRight) {
        return /*#__PURE__*/ (0,emotion_css_esm/* css */.iv)("position:absolute;top:60px;", popupRight ? "right: 0;" : "left: 0;", "    border-radius:8px;background:#ffffff;box-shadow:0px 10px 30px rgba(0,0,0,0.2);padding:16px 0 0 0;z-index:21;width:", isFourColumns ? "440px" : "334px", ";opacity:", isOpen ? "1" : "0", ";visibility:", isOpen ? "visible" : "hidden", ";transition:visibility 200ms linear,opacity 150ms linear;");
    },
    textButton: /*#__PURE__*/ (0,emotion_css_esm/* css */.iv)("color:", colors["default"].purple[400], ";"),
    titleContainer: /*#__PURE__*/ (0,emotion_css_esm/* css */.iv)("display:flex;justify-content:space-between;padding:0 16px;"),
    bottonContorls: /*#__PURE__*/ (0,emotion_css_esm/* css */.iv)("display:flex;align-items:center;justify-content:flex-end;padding:12px 16px 0;border-top:1px solid #d9d9d9;"),
    clearButton: /*#__PURE__*/ (0,emotion_css_esm/* css */.iv)("margin-right:30px;"),
    checkboxGroup: /*#__PURE__*/ (0,emotion_css_esm/* css */.iv)("display:flex;flex-direction:column;"),
    checkbox: /*#__PURE__*/ (0,emotion_css_esm/* css */.iv)()
};
var SEARCH_FILTER_ITEM_COUNT = 8;
var SelectFilterPopup = function(param) {
    var filterOptions = param.filterOptions, items = param.items, title = param.title, isOpen = param.isOpen, iconsGrid = param.iconsGrid, _popupRight = param.popupRight, popupRight = _popupRight === void 0 ? false : _popupRight, searchLabel = param.searchLabel, closePopup = param.closePopup, onApply = param.onApply, parentCodename = param.parentCodename, isSearchBar = param.isSearchBar;
    var drain = (0,react.useContext)(DrainContext);
    var ref = (0,react.useState)(Object.fromEntries(items.map(function(param) {
        var codename = param.codename;
        return [
            codename,
            !(0,lodash.isUndefined)(drain.filter.elements[drain.filter.elements.findIndex(function(value) {
                return value.codename === codename;
            })]) || !(0,lodash.isUndefined)((0,lodash.find)(drain.currentValue.filter.elements, function(param) {
                var cn = param.codename;
                return (0,lodash.eq)(codename, cn);
            })), 
        ];
    }))), itemsStatus = ref[0], setItemsStatus = ref[1];
    var ref1 = (0,react.useState)(itemsStatus), prevItemList = ref1[0], setPrevItemList = ref1[1];
    var ref2 = (0,react.useState)(string/* EMPTY_STRING */.v6), search = ref2[0], setSearch = ref2[1];
    var isFourColumns = iconsGrid && items.length > 9;
    var isSearchVisible = isSearchBar && !iconsGrid && items.length > SEARCH_FILTER_ITEM_COUNT;
    var ref3 = (0,react.useState)(items), filterList = ref3[0], setFilterList = ref3[1];
    (0,react.useEffect)(function() {
        setFilterList(items.filter(function(param) {
            var name = param.name;
            var value = search.toLocaleLowerCase();
            return name.search(new RegExp(value, "gi")) !== -1;
        }));
    }, [
        search
    ]);
    var clear = function() {
        var itemStatusList = Object.fromEntries(items.map(function(param) {
            var codename = param.codename;
            return [
                codename,
                false
            ];
        }));
        setItemsStatus(itemStatusList);
        var itemList = items.filter(function(item) {
            return itemStatusList[item.codename];
        });
        drain.clearFilter(parentCodename);
        onApply(drain.filter, itemList);
        closePopup();
    };
    var onCancelClick = function() {
        closePopup();
    };
    var onChange = (0,react.useCallback)(function(e, codename, name) {
        var checked = e.target.checked;
        setItemsStatus((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, itemsStatus), (0,_define_property/* default */.Z)({}, codename, checked)));
        onApplyClick(name, codename, checked);
    }, [
        drain.filter,
        drain.sort,
        drain.search
    ]);
    var onApplyClick = (0,react.useCallback)(function(name, codename, checked) {
        var checkedItems = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, itemsStatus), (0,_define_property/* default */.Z)({}, codename, checked));
        var itemList = items.filter(function(item) {
            return checkedItems[item.codename];
        });
        setPrevItemList(itemsStatus);
        var filter = drain.filter.elements.map(function(param) {
            var _$codename = param.codename;
            return _$codename;
        }).includes(codename) ? (0,lodash.cloneDeep)((0,lodash.assign)({}, {
            elements: (0,_to_consumable_array/* default */.Z)(drain.filter.elements.filter(function(param) {
                var cn = param.codename;
                return cn !== codename;
            }))
        })) : (0,lodash.cloneDeep)((0,lodash.assign)({}, {
            elements: (0,lodash.compact)((0,_to_consumable_array/* default */.Z)(drain.filter.elements).concat([
                {
                    codename: codename,
                    name: name,
                    parent: {
                        parent: void 0,
                        name: title,
                        codename: parentCodename
                    }
                }, 
            ]))
        }));
        onApply(filter, itemList);
    }, [
        drain.filter,
        drain.search,
        drain.sort,
        prevItemList,
        itemsStatus
    ]);
    var onSearchChange = function(value) {
        setSearch(value);
    };
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)("div", {
        className: SelectFilterPopup_Styles.container(isOpen, isFourColumns, popupRight),
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)("div", {
                className: SelectFilterPopup_Styles.titleContainer,
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(Typography["default"], {
                        variant: "body2",
                        as: "h3",
                        children: title
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("button", {
                        className: SelectFilterPopup_Styles.textButton,
                        onClick: clear,
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(Typography["default"], {
                            variant: "body2",
                            as: "span",
                            children: filterOptions.root.clearAll.title
                        })
                    })
                ]
            }),
            isSearchVisible ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(selectFilter_SelectFilterSearch, {
                placeholder: searchLabel,
                handleSearchChange: onSearchChange
            }) : null,
            iconsGrid ? utils_react/* EMPTY_ELEMENT */.O : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(selectFilter_SelectFilterCheckboxGroup, {
                items: filterList,
                itemsStatus: itemsStatus,
                onChange: onChange,
                parentCodename: parentCodename,
                title: title
            })
        ]
    });
};
/* harmony default export */ var selectFilter_SelectFilterPopup = (SelectFilterPopup);

;// CONCATENATED MODULE: ./src/components/selectFilter/SelectFilter.tsx









var SelectFilter_Styles = {
    container: /*#__PURE__*/ (0,emotion_css_esm/* css */.iv)("display:inline-block;position:relative;"),
    caret: function(isOpen) {
        return /*#__PURE__*/ (0,emotion_css_esm/* css */.iv)("position:absolute;right:20px;top:50%;transform:", !isOpen ? "translateY(-50%)" : "translateY(-50%) rotate(-180deg)", ";transform-origin:center;transition:transform 200ms ease;&:hover{color:", isOpen ? theme/* Color.White */.Il.White : colors["default"].gray[800], ";}");
    },
    button: function(isOpen, isActiveFilter) {
        return /*#__PURE__*/ (0,emotion_css_esm/* css */.iv)("width:100%;position:relative;display:inline-block;border-radius:100px;padding:12px 40px 12px 20px;border:1px solid ", colors["default"].purple[400], ";cursor:pointer;background:#ffffff;white-space:nowrap;text-align:left;color:", isOpen ? theme/* Color.White */.Il.White : theme/* Color.Gray800 */.Il.Gray800, ";&:hover{background-color:", colors["default"].purple[400], ";color:", theme/* Color.White */.Il.White, ";}&::after{content:'';width:12px;height:12px;border-radius:50%;background-color:", colors["default"].notification.blue, ";position:absolute;top:1px;right:1px;opacity:", isActiveFilter ? "1" : "0", ";transition:opacity 150ms ease;}", isOpen ? "background-color: ".concat(colors["default"].purple[400], ";\n      color: #FFFFFF") : "");
    }
};
var SelectFilter = function(param) {
    var filterOptions = param.filterOptions, className = param.className, title = param.title, parentCodename = param.parentCodename, items = param.items, _searchLabel = param.searchLabel, searchLabel = _searchLabel === void 0 ? "" : _searchLabel, _iconsGrid = param.iconsGrid, iconsGrid = _iconsGrid === void 0 ? false : _iconsGrid, _popupRight = param.popupRight, popupRight = _popupRight === void 0 ? false : _popupRight, applyCallback = param.applyCallback, isSearchBar = param.isSearchBar;
    var drain = (0,react.useContext)(DrainContext);
    var isActive = !(0,lodash.isUndefined)((0,lodash.find)(drain.currentValue.filter.elements, function(param) {
        var codename = param.parent.codename;
        return (0,lodash.eq)(codename, parentCodename);
    }));
    var ref = (0,react.useState)(false), isOpen = ref[0], setOpen = ref[1];
    var ref1 = (0,react.useState)(isActive), isActiveFilter = ref1[0], setActiveFilter = ref1[1];
    var wrapperRef = (0,react.useRef)(null);
    var closePopup = function() {
        setOpen(false);
    };
    var closeOnOutsideClick = (0,react.useCallback)(function(e) {
        if (wrapperRef.current && wrapperRef.current !== e.target && !wrapperRef.current.contains(e.target)) {
            closePopup();
        }
    }, []);
    (0,react.useEffect)(function() {
        if (isOpen) {
            document.addEventListener("click", closeOnOutsideClick);
        } else {
            document.removeEventListener("click", closeOnOutsideClick);
        }
        return function() {
            document.removeEventListener("click", closeOnOutsideClick);
        };
    }, [
        isOpen
    ]);
    var toggleOpen = function() {
        setOpen(!isOpen);
    };
    var onApply = (0,react.useCallback)(function(filter, activeItems) {
        setActiveFilter((0,lodash.size)(activeItems) > 0);
        applyCallback(filter, activeItems);
    }, [
        drain.filter,
        drain.sort,
        drain.search
    ]);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)("div", {
        className: "select-filter ".concat(SelectFilter_Styles.container, " ").concat(className),
        ref: wrapperRef,
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)("button", {
                className: SelectFilter_Styles.button(isOpen, isActiveFilter),
                onClick: toggleOpen,
                children: [
                    title,
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(CaretDownIcon["default"], {
                        className: SelectFilter_Styles.caret(isOpen)
                    })
                ]
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(selectFilter_SelectFilterPopup, {
                filterOptions: filterOptions,
                title: title,
                iconsGrid: iconsGrid,
                isOpen: isOpen,
                closePopup: closePopup,
                items: items,
                onApply: onApply,
                popupRight: popupRight,
                searchLabel: searchLabel,
                parentCodename: parentCodename,
                isSearchBar: isSearchBar
            })
        ]
    });
};
/* harmony default export */ var selectFilter_SelectFilter = (SelectFilter);

;// CONCATENATED MODULE: ./src/components/pages/store/FilterGroupDesktop.tsx







var FilterGroupDesktop_Styles = {
    container: /*#__PURE__*/ (0,emotion_css_esm/* css */.iv)("flex:1;.select-filter{margin-right:12px;&:last-child{margin-right:0;}}"),
    item: function(list) {
        var count = Object.values(list).length;
        return /*#__PURE__*/ (0,emotion_css_esm/* css */.iv)("flex-basis:100%;");
    },
    audience: /*#__PURE__*/ (0,emotion_css_esm/* css */.iv)("flex-basis:20%;"),
    other: /*#__PURE__*/ (0,emotion_css_esm/* css */.iv)("flex-basis:26%;"),
    from: /*#__PURE__*/ (0,emotion_css_esm/* css */.iv)("flex-basis:28%;")
};
var FilterGroupDesktop = function(param) {
    var filterList = param.filterList, className = param.className;
    var drain = (0,react.useContext)(DrainContext);
    var applyCallback = (0,react.useCallback)(function(filter) {
        drain.switchFilter({
            apply: true,
            device: Device.Desktop,
            sorting: {
                current: drain.sort,
                previous: drain.prevSort
            },
            currentFilter: filter
        });
        drain.trackDrainFilterSection(filter, drain.search);
    }, [
        drain.apply,
        drain.filter,
        drain.search,
        drain.sort
    ]);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("div", {
        className: "".concat(className, " ").concat(FilterGroupDesktop_Styles.container),
        children: filterList ? Object.keys(filterList.elements).filter(function(taxonomyCode) {
            return filterList.elements[taxonomyCode].switched;
        }).map(function(taxonomyCode, idx, codes) {
            var taxonomy = filterList.elements[taxonomyCode];
            var isSearchBar = taxonomyCode === "location";
            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(selectFilter_SelectFilter, {
                filterOptions: getFilterTaxonomyOptions(filterList),
                className: FilterGroupDesktop_Styles.item(filterList),
                title: taxonomy.question,
                parentCodename: taxonomyCode,
                items: taxonomy.terms,
                applyCallback: applyCallback,
                searchLabel: filterList.filter.options[taxonomyCode].search.title,
                popupRight: idx === codes.length - 1,
                isSearchBar: isSearchBar
            }, idx);
        }) : utils_react/* EMPTY_ELEMENT */.O
    });
};
/* harmony default export */ var store_FilterGroupDesktop = (FilterGroupDesktop);

;// CONCATENATED MODULE: ./src/components/pages/store/FilterSection.tsx












var FilterSection_classes = {
    root: /*#__PURE__*/ (0,emotion_css_esm/* css */.iv)("display:flex;flex-direction:column;justify-content:space-between;background-color:", theme/* Color.Lilac400 */.Il.Lilac400, ";width:100%;color:#1e1e1e;padding-bottom:20px;height:250px;align-items:center;@media (max-width:1023px){flex-direction:column;height:300px;}@media (max-width:592px){height:350px;},z-index:999;"),
    title: /*#__PURE__*/ (0,emotion_css_esm/* css */.iv)("font-size:42px;line-height:52px;font-weight:700;text-align:center;padding:20px;color:#1e1e1e;width:100%;@media (min-width:1023px){padding-top:20px;}"),
    search: {
        root: function(count) {
            return /*#__PURE__*/ (0,emotion_css_esm/* css */.iv)("display:flex;flex-direction:row;flex-basis:", {
                0: "100%",
                1: "80%",
                2: "60%",
                3: "40%",
                4: "49%"
            }[count], ";width:50%;margin:0 12px 0 0;@media (max-width:1287px){flex-basis:50%;}@media (max-width:1023px){margin:0;width:100%;}");
        },
        item: /*#__PURE__*/ (0,emotion_css_esm/* css */.iv)("width:100%;")
    },
    filter: {
        root: function(count) {
            return /*#__PURE__*/ (0,emotion_css_esm/* css */.iv)("display:flex;flex-direction:row;@media (max-width:1023px){flex-direction:column;}");
        },
        rootFilter: function(count) {
            return /*#__PURE__*/ (0,emotion_css_esm/* css */.iv)("display:flex;flex-direction:row;justify-content:space-between;flex-basis:", {
                0: "0",
                1: "20%",
                2: "40%",
                3: "60%",
                4: "80%"
            }[count], ";@media (max-width:1287px){flex-basis:50%;}@media (max-width:1023px){flex-basis:100%;width:100%;margin:20px 0 0;}");
        },
        desktop: /*#__PURE__*/ (0,emotion_css_esm/* css */.iv)("display:flex;@media (max-width:1287px){display:none;}"),
        mobile: /*#__PURE__*/ (0,emotion_css_esm/* css */.iv)("display:none;flex:1;@media (max-width:1287px){display:flex;}")
    },
    sort: {
        section: /*#__PURE__*/ (0,emotion_css_esm/* css */.iv)("position:relative;display:flex;justify-content:flex-end;align-items:flex-end;padding-top:140px;width:200px;margin-left:auto;@media (max-width:1287px){display:none;}"),
        item: /*#__PURE__*/ (0,emotion_css_esm/* css */.iv)()
    }
};
var FilterSection = function(param) {
    var className = param.className, filterList = param.filterList;
    var drain = (0,react.useContext)(DrainContext);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(emotion_react_jsx_runtime_browser_esm.Fragment, {
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("div", {
            className: classnames_default()([
                FilterSection_classes.root,
                className
            ]),
            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)("div", {
                className: classnames_default()([
                    "container",
                    "px-4"
                ]),
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("div", {
                        className: FilterSection_classes.title,
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(lib.Typography, {
                            variant: "h2",
                            className: FilterSection_classes.title,
                            children: filterList.root.title
                        })
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)("div", {
                        className: FilterSection_classes.filter.root(Object.values(filterList.elements).filter(function(param) {
                            var switched = param.switched;
                            return switched;
                        }).length),
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("div", {
                                className: FilterSection_classes.search.root(Object.values(filterList.elements).filter(function(param) {
                                    var switched = param.switched;
                                    return switched;
                                }).length),
                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("div", {
                                    className: FilterSection_classes.search.item,
                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(SearchInput, {
                                        className: "flex-1 relative",
                                        filterList: filterList,
                                        setSearch: drain.setSearch,
                                        defaultValue: drain.search || string/* EMPTY_STRING */.v6,
                                        trackSearchReset: function() {
                                            return (0,Segment_bs/* customElementInteraction */.pA)({
                                                element: "clear_search",
                                                journey: "classic_product_search"
                                            });
                                        }
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)("div", {
                                className: FilterSection_classes.filter.rootFilter(Object.values(filterList.elements).filter(function(param) {
                                    var switched = param.switched;
                                    return switched;
                                }).length),
                                children: [
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(store_FilterGroupMobile, {
                                        className: FilterSection_classes.filter.mobile,
                                        filterList: filterList
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(store_FilterGroupDesktop, {
                                        className: FilterSection_classes.filter.desktop,
                                        filterList: filterList
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        })
    });
};

// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./node_modules/@prezzee/ribbon-ui/lib/components/Button/index.js
var Button = __webpack_require__(43515);
;// CONCATENATED MODULE: ./src/components/pages/store/filter/FilterDefault.tsx







var FilterDefault_classes = {
    root: /*#__PURE__*/ (0,emotion_css_esm/* css */.iv)("display:flex;flex-direction:column;justify-content:flex-start;width:100%;"),
    rootItem: /*#__PURE__*/ (0,emotion_css_esm/* css */.iv)("display:flex;flex-direction:column;justify-content:space-between;min-height:57px;height:auto;padding:13px 20px 10px 20px;border:1px solid #f0eded;"),
    item: /*#__PURE__*/ (0,emotion_css_esm/* css */.iv)("display:flex;flex-direction:row;justify-content:space-between;width:100%;"),
    comment: /*#__PURE__*/ (0,emotion_css_esm/* css */.iv)("display:flex;flex-direction:row;justify-content:space-between;width:100%;"),
    default: {
        root: /*#__PURE__*/ (0,emotion_css_esm/* css */.iv)("display:flex;flex-direction:row;justify-content:space-between;width:100%;"),
        title: /*#__PURE__*/ (0,emotion_css_esm/* css */.iv)("font-weight:400;"),
        action: /*#__PURE__*/ (0,emotion_css_esm/* css */.iv)("color:#48096c;cursor:pointer;padding-top:3px;")
    },
    prompt: {
        root: /*#__PURE__*/ (0,emotion_css_esm/* css */.iv)("display:flex;flex-direction:row;justify-content:space-between;"),
        item: /*#__PURE__*/ (0,emotion_css_esm/* css */.iv)("color:#276ef1;font-size:14px;padding-right:5px;:nth-child(2){padding-right:0;}"),
        comment: /*#__PURE__*/ (0,emotion_css_esm/* css */.iv)("padding-left:10px;")
    }
};
var FilterDefault = function(param) {
    var list = param.list;
    var drain = (0,react.useContext)(DrainContext);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("div", {
        className: FilterDefault_classes.root,
        children: Object.keys(list.elements).map(function(taxonomyCodeName) {
            var filterLength = drain.filter.elements.filter(function(param) {
                var codename = param.parent.codename;
                return codename === taxonomyCodeName;
            }).length;
            var displayValueCount = 0;
            return list.elements[taxonomyCodeName].switched ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)("div", {
                className: FilterDefault_classes.rootItem,
                onClick: function() {
                    drain.setPage({
                        code: taxonomyCodeName,
                        parent: DEFAULT_FILTER_PAGE
                    });
                },
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("div", {
                        className: FilterDefault_classes.item,
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)("div", {
                            className: FilterDefault_classes.default.root,
                            children: [
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("div", {
                                    className: FilterDefault_classes.default.title,
                                    children: list.elements[taxonomyCodeName].question
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("div", {
                                    className: FilterDefault_classes.default.action,
                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(index_es.FontAwesomeIcon, {
                                        icon: [
                                            "fas",
                                            "angle-right"
                                        ]
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("div", {
                        className: FilterDefault_classes.comment,
                        children: filterLength > 0 ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)("div", {
                            className: FilterDefault_classes.prompt.root,
                            children: [
                                displayValueCount === 0 && drain.filter.elements.map(function(param) {
                                    var parent = param.parent, name = param.name;
                                    if (parent.codename === taxonomyCodeName && displayValueCount < 2) {
                                        displayValueCount++;
                                        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("div", {
                                            className: FilterDefault_classes.prompt.item,
                                            children: "".concat(name).concat(displayValueCount < 2 && filterLength !== 1 ? "," : string/* EMPTY_STRING */.v6)
                                        }, name);
                                    }
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("div", {
                                    className: FilterDefault_classes.prompt.comment,
                                    children: filterLength > 2 ? "+".concat(filterLength - 2, " other") : void 0
                                })
                            ]
                        }) : utils_react/* EMPTY_ELEMENT */.O
                    })
                ]
            }) : utils_react/* EMPTY_ELEMENT */.O;
        })
    });
};

;// CONCATENATED MODULE: ./src/components/pages/store/filter/FilterItem.tsx










var FilterItem_classes = {
    root: /*#__PURE__*/ (0,emotion_css_esm/* css */.iv)("display:flex;flex-direction:column;justify-content:flex-start;width:100%;"),
    taxonomy: {
        root: /*#__PURE__*/ (0,emotion_css_esm/* css */.iv)("display:flex;flex-direction:column;justify-content:flex-start;width:100%;")
    },
    rootItem: /*#__PURE__*/ (0,emotion_css_esm/* css */.iv)("display:flex;flex-direction:row;justify-content:space-between;height:57px;padding:13px 20px 10px 20px;border:1px solid ", theme/* Color.Gray100 */.Il.Gray100, ";"),
    title: /*#__PURE__*/ (0,emotion_css_esm/* css */.iv)("display:flex;flex-direction:row;justify-content:flex-start;width:100%;height:57px;padding:13px 20px 10px 20px;font-weight:600;"),
    search: {
        root: /*#__PURE__*/ (0,emotion_css_esm/* css */.iv)("position:relative;padding:0 20px 0 20px;"),
        placeholder: /*#__PURE__*/ (0,emotion_css_esm/* css */.iv)("::placeholder{color:", theme/* Color.Gray800 */.Il.Gray800, ";}"),
        input: /*#__PURE__*/ (0,emotion_css_esm/* css */.iv)("border:1px solid ", theme/* Color.Purple400 */.Il.Purple400, ";"),
        icon: /*#__PURE__*/ (0,emotion_css_esm/* css */.iv)("padding:20px;position:absolute;right:20px;top:-9px;color:", theme/* Color.Gray800 */.Il.Gray800, ";")
    },
    item: {
        section: /*#__PURE__*/ (0,emotion_css_esm/* css */.iv)("height:100%;overflow-y:auto;"),
        root: /*#__PURE__*/ (0,emotion_css_esm/* css */.iv)("display:flex;flex-direction:row;justify-content:flex-start;width:100%;height:57px;padding:13px 20px 10px 20px;//border:1px solid #F0EDED;"),
        label: /*#__PURE__*/ (0,emotion_css_esm/* css */.iv)("font-weight:400;padding-top:2px;padding-left:3px;// @note:11px is required,Chakra returns 8px margin left\n      font-size:16px;"),
        action: /*#__PURE__*/ (0,emotion_css_esm/* css */.iv)("color:", theme/* Color.Purple400 */.Il.Purple400, ";cursor:pointer;padding-top:3px;"),
        checkbox: /*#__PURE__*/ (0,emotion_css_esm/* css */.iv)()
    },
    noResult: /*#__PURE__*/ (0,emotion_css_esm/* css */.iv)("font-weight:bold;font-size:16px;padding:13px 20px 10px 20px;width:100%;text-align:center;")
};
function getSearchPlaceholder(filterList, code) {
    return ({
        interest: filterList.filter.options.interest.search.title || "What's their interests?",
        audience: filterList.filter.options.audience.search.title || "Who is it for?",
        occasion: filterList.filter.options.occasion.search.title || "What's the occasion?",
        location: filterList.filter.options.location.search.title || "Search State/Province"
    })[code] || "Search...";
}
var FilterItem_SEARCH_FILTER_ITEM_COUNT = 8;
var FilterItem = function(param) {
    var code = param.code, list = param.list;
    var drain = (0,react.useContext)(DrainContext);
    var ref = (0,react.useState)(string/* EMPTY_STRING */.v6), search = ref[0], setSearch = ref[1];
    var ref1 = (0,react.useState)(list.elements[code].terms), filterList = ref1[0], setFilterList = ref1[1];
    var rootRef = (0,react.useRef)(null);
    (0,react.useEffect)(function() {
        setFilterList(list.elements[code].terms.filter(function(param) {
            var name = param.name;
            var value = search.toLocaleLowerCase();
            return name.search(new RegExp(value, "gi")) !== -1;
        }));
    }, [
        search
    ]);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)("div", {
        className: FilterItem_classes.root,
        ref: rootRef,
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("div", {
                className: FilterItem_classes.title,
                children: list.elements[code].name
            }),
            list.elements[code].terms.length >= FilterItem_SEARCH_FILTER_ITEM_COUNT ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)("div", {
                className: FilterItem_classes.search.root,
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("input", {
                        name: "search",
                        value: search,
                        placeholder: getSearchPlaceholder(list, code),
                        className: classnames_default()([
                            "text-base bg-white h-12 pr-12 pl-6 lg:pl-6 sm:pl-6 outline-none focus:outline-none focus:shadow-sm w-full rounded-full",
                            FilterItem_classes.search.placeholder,
                            FilterItem_classes.search.input, 
                        ]),
                        onChange: function(event) {
                            var value = event.target.value;
                            setSearch(value);
                        }
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("div", {
                        className: FilterItem_classes.search.icon,
                        children: search.length > 0 ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(index_es.FontAwesomeIcon, {
                            icon: [
                                "far",
                                "times"
                            ],
                            className: classnames_default()({
                                "cursor-pointer": search.length > 0
                            }),
                            onClick: function() {
                                if (search.length > 0) {
                                    setSearch(string/* EMPTY_STRING */.v6);
                                }
                            }
                        }) : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(index_es.FontAwesomeIcon, {
                            icon: [
                                "far",
                                "search"
                            ]
                        })
                    })
                ]
            }) : utils_react/* EMPTY_ELEMENT */.O,
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("div", {
                className: FilterItem_classes.item.section,
                children: filterList.map(function(param, index) {
                    var name = param.name, codename = param.codename;
                    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("div", {
                        className: FilterItem_classes.item.root,
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("div", {
                            className: FilterItem_classes.item.checkbox,
                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(Checkbox, {
                                size: "lg",
                                name: name,
                                isChecked: drain.filter.elements.map(function(param) {
                                    var codename = param.codename;
                                    return codename;
                                })// @todo: the problem with the equal codeNames,
                                // codeName mapper is required as (codename: string) => `${parent.codename}_${codename}
                                .includes(codename),
                                onChange: function() {
                                    drain.appendFilter({
                                        parent: {
                                            parent: void 0,
                                            name: list.elements[code].name,
                                            codename: code
                                        },
                                        name: name,
                                        codename: codename
                                    });
                                },
                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("div", {
                                    className: FilterItem_classes.item.label,
                                    children: name
                                })
                            }, codename)
                        })
                    }, index);
                })
            }),
            filterList.length === 0 ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("div", {
                className: FilterItem_classes.noResult,
                children: "No search result"
            }) : utils_react/* EMPTY_ELEMENT */.O
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/pages/store/DrainSection.tsx














var DrainSection_classes = {
    root: function(open) {
        return /*#__PURE__*/ (0,emotion_css_esm/* css */.iv)("position:fixed;overflow-y:scroll;inset:0;height:100%;width:100%;top:0;left:0;background-color:#ffffff;display:flex;visibility:", open ? "visible" : "hidden", ";flex-direction:column;justify-content:space-between;z-index:999;color:", theme/* Color.Gray800 */.Il.Gray800, ";font-size:15px;transition:transform 0.5s ease,visibility 0.5s ease;transform:translateY(100%);");
    },
    activeRoot: /*#__PURE__*/ (0,emotion_css_esm/* css */.iv)("transform:translateY(0) !important;transition:transform 0.5s ease,visibility 0.5s ease;visibility:visible;"),
    overlay: function(open) {
        return /*#__PURE__*/ (0,emotion_css_esm/* css */.iv)("width:100%;height:100%;z-index:", open ? 99 : 0, ";position:fixed;top:", open ? 0 : "auto", ";left:", open ? 0 : "auto", ";background-color:rgba(0,0,0,", open ? 0.4 : 0, ");");
    },
    header: {
        root: /*#__PURE__*/ (0,emotion_css_esm/* css */.iv)("display:flex;flex-direction:column;justify-content:space-between;height:57px;padding:13px 20px 10px 20px;border:1px solid ", theme/* Color.Gray100 */.Il.Gray100, ";"),
        back: {
            root: /*#__PURE__*/ (0,emotion_css_esm/* css */.iv)("display:flex;flex-direction:row;justify-content:flex-start;"),
            image: /*#__PURE__*/ (0,emotion_css_esm/* css */.iv)("margin-top:5px;"),
            text: /*#__PURE__*/ (0,emotion_css_esm/* css */.iv)("padding-left:10px;")
        },
        default: {
            root: /*#__PURE__*/ (0,emotion_css_esm/* css */.iv)("display:flex;flex-direction:row;justify-content:space-between;"),
            title: /*#__PURE__*/ (0,emotion_css_esm/* css */.iv)("display:flex;flex-direction:row;font-weight:600;"),
            action: {
                item: /*#__PURE__*/ (0,emotion_css_esm/* css */.iv)("color:", theme/* Color.Purple400 */.Il.Purple400, ";cursor:pointer;"),
                title: /*#__PURE__*/ (0,emotion_css_esm/* css */.iv)("cursor:pointer;")
            },
            marker: {
                root: /*#__PURE__*/ (0,emotion_css_esm/* css */.iv)("background-color:", theme/* Color.Blue400 */.Il.Blue400, ";height:18px;width:18px;border-radius:50%;margin-left:10px;margin-top:4px;"),
                item: /*#__PURE__*/ (0,emotion_css_esm/* css */.iv)("font-size:14px;padding-left:5px;padding-top:0;color:#ffffff;font-weight:600;line-height:100%;")
            }
        }
    },
    content: {
        root: /*#__PURE__*/ (0,emotion_css_esm/* css */.iv)("display:flex;flex-direction:row;justify-content:space-between;height:100%;overflow-y:auto;")
    },
    footer: {
        root: /*#__PURE__*/ (0,emotion_css_esm/* css */.iv)("display:flex;flex-direction:row;justify-content:space-between;box-shadow:0px -2px 40px rgba(0,0,0,0.29);padding-top:15px;"),
        close: /*#__PURE__*/ (0,emotion_css_esm/* css */.iv)("width:50%;padding:0 5px 10px 10px;"),
        view: /*#__PURE__*/ (0,emotion_css_esm/* css */.iv)("width:50%;padding:0 10px 10px 5px;")
    }
};
var DrainSection = function(param) {
    var filterList = param.filterList, open = param.open;
    var drain = (0,react.useContext)(DrainContext);
    var router = (0,next_router.useRouter)();
    (0,react.useEffect)(function() {
        if (open) {
            document.body.style.overflow = "hidden";
            document.body.style.touchAction = "hidden";
        }
        router.events.on("routeChangeStart", function() {
            document.body.style.overflow = "auto";
            document.body.style.touchAction = "";
        });
        return function() {
            if (!open) {
                document.body.style.overflow = "auto";
                document.body.style.touchAction = "";
            }
        };
    }, [
        open
    ]);
    var _obj;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)(emotion_react_jsx_runtime_browser_esm.Fragment, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)((head_default()), {
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("style", {
                    children: "@media (max-width: 1287px) {\n            #ada-button-frame {\n              bottom: ".concat(open ? "52px" : "0", " !important;\n            }\n          }")
                })
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("div", {
                className: DrainSection_classes.overlay(open)
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)("div", {
                className: classnames_default()([
                    DrainSection_classes.root(open),
                    open ? DrainSection_classes.activeRoot : void 0
                ]),
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("div", {
                        className: DrainSection_classes.header.root,
                        children: drain.page.parent ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)("div", {
                            className: DrainSection_classes.header.back.root,
                            children: [
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(index_es.FontAwesomeIcon, {
                                    icon: [
                                        "fas",
                                        "angle-left"
                                    ],
                                    className: DrainSection_classes.header.back.image
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("span", {
                                    className: DrainSection_classes.header.back.text,
                                    onClick: function() {
                                        drain.setPage(drain.page.parent);
                                    },
                                    children: "Back to Filters"
                                })
                            ]
                        }) : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)("div", {
                            className: DrainSection_classes.header.default.root,
                            children: [
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)("div", {
                                    className: DrainSection_classes.header.default.title,
                                    children: [
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("span", {
                                            children: (_obj = {}, (0,_define_property/* default */.Z)(_obj, DrainType.Filter, "Filters"), (0,_define_property/* default */.Z)(_obj, DrainType.Sorting, "Sorting"), _obj)[drain.currentType]
                                        }),
                                        drain.filter.elements.length > 0 ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("div", {
                                            className: DrainSection_classes.header.default.marker.root,
                                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("div", {
                                                className: DrainSection_classes.header.default.marker.item,
                                                children: drain.filter.elements.length
                                            })
                                        }) : utils_react/* EMPTY_ELEMENT */.O
                                    ]
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("div", {
                                    className: DrainSection_classes.header.default.action.item,
                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("span", {
                                        className: DrainSection_classes.header.default.action.title,
                                        onClick: function() {
                                            document.body.style.overflow = "unset";
                                            drain.switchFilter({
                                                clear: true,
                                                apply: true,
                                                sorting: {
                                                    current: drain.sort,
                                                    previous: drain.prevSort
                                                }
                                            });
                                            drain.trackDrainFilterSection(DEFAULT_FILTER_CURRENT, drain.search);
                                        },
                                        children: filterList.root.clearAll.title
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("div", {
                        className: DrainSection_classes.content.root,
                        children: drain.currentType === DrainType.Filter ? drain.page.code === "default" ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(FilterDefault, {
                            list: filterList
                        }) : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(FilterItem, {
                            code: drain.page.code,
                            list: filterList
                        }) : utils_react/* EMPTY_ELEMENT */.O //
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)("div", {
                        className: DrainSection_classes.footer.root,
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("div", {
                                className: DrainSection_classes.footer.close,
                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(Button["default"], {
                                    type: "submit",
                                    variant: "secondary",
                                    fullWidth: true,
                                    onClick: function() {
                                        document.body.style.overflow = "unset";
                                        drain.switchFilter({
                                            apply: false,
                                            close: true
                                        });
                                    },
                                    children: filterList.root.close.title
                                })
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("div", {
                                className: DrainSection_classes.footer.view,
                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(Button["default"], {
                                    type: "submit",
                                    fullWidth: true,
                                    onClick: function() {
                                        document.body.style.overflow = "unset";
                                        drain.switchFilter({
                                            apply: true,
                                            sorting: {
                                                current: drain.sort,
                                                previous: drain.prevSort
                                            }
                                        });
                                        drain.trackDrainFilterSection(drain.filter, drain.search);
                                    },
                                    children: filterList.root.viewResults.title
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
};

// EXTERNAL MODULE: ./src/common/storeSmartCardContent.tsx + 1 modules
var storeSmartCardContent = __webpack_require__(31290);
// EXTERNAL MODULE: ./src/common/utils/array.ts
var array = __webpack_require__(18802);
;// CONCATENATED MODULE: ./src/components/pages/store/WallOfCards.tsx




























var removeHiddenCards = function(cards) {
    return cards.filter(function(card) {
        return !card.isPcCategoryHidden;
    });
};
function getCardLists(param) {
    var search = param.search, cards = param.cards;
    var format = function format(str) {
        return str.replace(/\s/gi, string/* EMPTY_STRING */.v6).replace(new RegExp(Regex/* specialRegex */.$I, "g"), string/* EMPTY_STRING */.v6);
    };
    var regExp = new RegExp(format(search), "i");
    var ref = (0,_sliced_to_array/* default */.Z)((0,lodash.partition)(cards, function(card) {
        return regExp.test(format(card.searchableTerms));
    }), 2), filteredCards = ref[0], similarCards = ref[1];
    return {
        filteredCards: filteredCards,
        similarCards: similarCards
    };
}
function formatCardAmount(amount) {
    return amount < 10 ? "0".concat(amount) : amount > 999 ? amount.toLocaleString("en-US") : (0,lodash.toString)(amount);
}
/**
 * Appends SKU Presentation dictionary to the Card
 * @param dict
 */ function appendDict(dict) {
    return function(cardList) {
        return cardList.map(function(card) {
            var cardDictIndex = dict.findIndex(function(value) {
                return value[0] === card.cmsId;
            });
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, card), {
                presentation: cardDictIndex !== -1 ? dict[cardDictIndex][1] : void 0
            });
        });
    };
}
var WallOfCards_classes = {
    root: /*#__PURE__*/ (0,emotion_css_esm/* css */.iv)("display:flex;flex-direction:column;"),
    filter: /*#__PURE__*/ (0,emotion_css_esm/* css */.iv)(),
    smartContainer: {
        root: /*#__PURE__*/ (0,emotion_css_esm/* css */.iv)("display:flex;flex-direction:row;justify-content:space-between;"),
        item: /*#__PURE__*/ (0,emotion_css_esm/* css */.iv)("width:100%;&:first-child{@media (max-width:1279px){width:100% !important;}width:70%;}&:last-child{@media (max-width:1279px){display:none;}display:flex;width:200px;padding-right:20px;}")
    },
    sortSection: /*#__PURE__*/ (0,emotion_css_esm/* css */.iv)("position:absolute;top:330px;right:20px;"),
    smartLabel: /*#__PURE__*/ (0,emotion_css_esm/* css */.iv)("width:70%;"),
    cards: /*#__PURE__*/ (0,emotion_css_esm/* css */.iv)("padding-top:30px;@media (max-width:592px){padding-top:30px;}")
};
var WallOfCards = function(param) {
    var inventoryProps = param.inventoryProps, storeContent = param.storeContent, topContent = param.topContent, skuDict = param.skuDict, filterList = param.filterList;
    var ref;
    var drain = (0,react.useContext)(DrainContext);
    var router = (0,next_router.useRouter)();
    var searchTerm = (ref = router.query) === null || ref === void 0 ? void 0 : ref.search;
    var ref1 = (0,react.useState)(function() {
        return true;
    }), firstLoad = ref1[0], setFirstLoad = ref1[1];
    var drainScrollRef = (0,react.useRef)(null);
    var ref2 = (0,react.useState)(function() {
        var searchTermTmp = typeof searchTerm === "object" ? searchTerm[0] : searchTerm || string/* EMPTY_STRING */.v6;
        return searchTermTmp.split(string/* EMPTY_STRING */.v6).map(function(value) {
            var str = decodeURIComponent(value);
            return str.replace(/([^\w\s\d])/g, "$1");
        }).join(string/* EMPTY_STRING */.v6);
    }), search = ref2[0], setSearch = ref2[1];
    var layoutData = (0,LayoutDataContext/* useLayoutData */.Q)();
    var noSearchResultsData = layoutData.noSearchResults ? layoutData.noSearchResults : {
        title: "Oops, No Results Found.",
        description: "Your search has yielded no results. Try again with a different brand to find the best gift you are looking for.",
        icon: {
            src: "/images/no_search_icon.png",
            alt: "magnifying glass icon",
            width: 72,
            height: 72
        },
        scp_title: "Why not gift the choice with a Smart eGift Card?",
        scp_description: "It's the ideal swap card that lets your recipient turn it into all the big brand retailer cards. Personalise it with your own photo and a video message. Perfect gift done!"
    };
    var ref3 = flowList([
        drain.restore,
        drain.applySort,
        // drain.applySearch,
        // drain.applyFilter,
        drain.initValue,
        appendDict(skuDict),
        removeHiddenCards, 
    ])(inventoryProps), currentInventory = ref3.current;
    var ref4 = (0,react.useState)(function() {
        return getCardLists({
            search: search,
            cards: currentInventory
        });
    }), cardLists = ref4[0], setCardLists = ref4[1];
    // @todo: is it necessary?
    var noSearchWords = search === string/* EMPTY_STRING */.v6 && currentInventory.length === cardLists.filteredCards.length;
    var allSwapCards = currentInventory.filter(function(param) {
        var isSwappable = param.isSwappable;
        return isSwappable;
    });
    var otherCards = currentInventory.filter(function(param) {
        var isSwappable = param.isSwappable;
        return !isSwappable;
    });
    var ref5 = (0,_sliced_to_array/* default */.Z)(react.useState(false), 2), filterPanelOpen = ref5[0], toggleFilterPanel = ref5[1];
    var closeFilterPanel = function() {
        toggleFilterPanel(false);
    };
    (0,react.useEffect)(function() {
        setFirstLoad(false);
    }, []);
    (0,react.useEffect)(function() {
        closeFilterPanel();
        var ref = flowList([
            drain.applySearch,
            drain.restore,
            drain.applySort,
            drain.applyFilter,
            drain.initValue,
            appendDict(skuDict),
            removeHiddenCards, 
        ])(inventoryProps), currentInventory = ref.current;
        var lists = getCardLists({
            search: drain.search,
            cards: currentInventory
        });
        setCardLists(lists);
    }, [
        drain.apply,
        drain.search
    ]);
    var hasSwapCards = allSwapCards.length > 0;
    var hasCards = cardLists.filteredCards.length > 0;
    var shouldRemoveSmartCards = !drain.search && !drain.hasSort() && !drain.hasFilter();
    var displayedCards = shouldRemoveSmartCards ? cardLists.filteredCards.filter(function(param) {
        var isSwappable = param.isSwappable;
        return !isSwappable;
    }) : cardLists.filteredCards;
    var defaultStoreContent = {
        smart_card_content: void 0,
        retailer_card_content: void 0,
        end_of_page_content: void 0
    };
    var storeContentDef = (storeContent === null || storeContent === void 0 ? void 0 : storeContent.VAL) || defaultStoreContent;
    var retailerContent = storeContentDef.retailer_card_content ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(EnrichedTextSection_bs/* make */.Sy, {
        block: storeContentDef.retailer_card_content,
        wallOfCards: true
    }) : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("h1", {
        className: "text-2xl sm:text-32px leading-8 font-semibold pt-4 mx-4 pb-2 sm:pb-3",
        children: "See eGift Cards from top brands"
    });
    var smartCardHeroSection = storeContentDef.smart_card_content ? (0,storeSmartCardContent/* getSmartCardHeroSection */.Xi)(storeContentDef.smart_card_content) : null;
    var defaultSmartCardStoreContent = /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)(emotion_react_jsx_runtime_browser_esm.Fragment, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("h2", {
                className: "text-2xl sm:text-32px leading-8 font-semibold pt-4 mx-4 pb-2 sm:pb-3",
                children: "Prezzee Smart eGift Cards"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)("h3", {
                className: "text-base mx-4 text-gray-600",
                children: [
                    "For the ultimate shopping spree wrapped up in one great eGift Card, send a Prezzee Smart eGift Card. It's",
                    " ",
                    "the ideal swap card that lets your recipient turn it into all the big brand retailer cards.",
                    " ",
                    (0,Localization_bs/* getLocalizedString */.Z)("Personalise"),
                    " it with your own photo and a video message. Perfect gift done!"
                ]
            })
        ]
    });
    var smartCardStoreContent = storeContentDef.smart_card_content ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(emotion_react_jsx_runtime_browser_esm.Fragment, {
        children: (0,storeSmartCardContent/* getEnrichedTextSection */.Nn)(storeContentDef.smart_card_content) || defaultSmartCardStoreContent
    }) : defaultSmartCardStoreContent;
    var endOfPageStoreContent = storeContentDef.end_of_page_content ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(EnrichedTextSection_bs/* make */.Sy, {
        block: storeContentDef.end_of_page_content,
        wallOfCards: true
    }) : void 0;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)(emotion_react_jsx_runtime_browser_esm.Fragment, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(DrainSection, {
                open: drain.isOpen,
                filterList: filterList,
                scrollRef: drainScrollRef
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)("div", {
                className: classnames_default()({
                    "overflow-hidden bg-white": filterPanelOpen,
                    "relative bg-white": true
                }),
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("div", {
                        className: "flex flex-nowrap w-full text-gray-600",
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(FilterSection, {
                            className: WallOfCards_classes.filter,
                            filterList: filterList
                        })
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("div", {
                        className: classnames_default()({
                            // "hidden": drain.isOpen,
                            // If Filter panel is open then overflow-scroll sm:overflow-visible
                            // "overflow-hidden": filterPanelOpen,
                            "w-full h-full z-20 sm:relative sm:block pt-1 mb-4 xl:px-10 bg-white shadow-lg": true
                        }),
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)("div", {
                            className: WallOfCardsStyles_bs/* rootContainerWall */.lE,
                            children: [
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("div", {
                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)("div", {
                                        className: WallOfCards_classes.cards,
                                        children: [
                                            noSearchWords ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(BrazeContentCards_bs/* make */.Sy, {}) : void 0,
                                            !noSearchWords && hasSwapCards && hasCards ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)("div", {
                                                className: WallOfCards_classes.smartContainer.root,
                                                children: [
                                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("div", {
                                                        className: WallOfCards_classes.smartContainer.item,
                                                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("h2", {
                                                            className: WallOfCardsStyles_bs/* title */.TN,
                                                            ref: drainScrollRef,
                                                            children: "We found ".concat(formatCardAmount(cardLists.filteredCards.length), " ").concat(cardLists.filteredCards.length > 1 ? "gifts" : "gift", " for you")
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("div", {
                                                        className: WallOfCards_classes.smartContainer.item,
                                                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(sorting, {
                                                            hidden: !getFilterTaxonomyOptions(filterList).sort.switched,
                                                            filterList: filterList,
                                                            className: classnames_default()([
                                                                "flex-1",
                                                                "relative"
                                                            ])
                                                        })
                                                    })
                                                ]
                                            }) : !noSearchWords && hasSwapCards && !hasCards ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)(emotion_react_jsx_runtime_browser_esm.Fragment, {
                                                children: [
                                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(library_NoSearchResults, {
                                                        icon: noSearchResultsData.icon,
                                                        title: noSearchResultsData.title,
                                                        description: noSearchResultsData.description
                                                    }),
                                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("h2", {
                                                        className: WallOfCardsStyles_bs/* title */.TN,
                                                        children: noSearchResultsData.scp_title
                                                    }),
                                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("h3", {
                                                        className: WallOfCardsStyles_bs/* description */.WL,
                                                        children: noSearchResultsData.scp_description
                                                    }),
                                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("div", {
                                                        className: WallOfCardsStyles_bs/* cardsContainer */.VV,
                                                        children: allSwapCards.map(function(card, index) {
                                                            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(Card/* default */.Z, {
                                                                card: card,
                                                                position: index + 1,
                                                                skuDict: skuDict || array/* EMPTY_ARRAY */.L
                                                            }, card.uid);
                                                        })
                                                    })
                                                ]
                                            }) : noSearchWords && hasSwapCards && hasCards ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)("div", {
                                                children: [
                                                    !drain.hasSort() && smartCardHeroSection,
                                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)("div", {
                                                        className: WallOfCards_classes.smartContainer.root,
                                                        children: [
                                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("div", {
                                                                className: WallOfCards_classes.smartContainer.item,
                                                                children: drain.sort === SortValue.Featured ? smartCardStoreContent : void 0
                                                            }),
                                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("div", {
                                                                className: WallOfCards_classes.smartContainer.item,
                                                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(sorting, {
                                                                    hidden: !getFilterTaxonomyOptions(filterList).sort.switched,
                                                                    filterList: filterList,
                                                                    className: classnames_default()([
                                                                        "flex-1",
                                                                        "relative"
                                                                    ])
                                                                })
                                                            })
                                                        ]
                                                    }),
                                                    drain.sort === SortValue.Featured ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("div", {
                                                        className: WallOfCardsStyles_bs/* cardsContainer */.VV,
                                                        children: allSwapCards.map(function(card, index) {
                                                            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(Card/* default */.Z, {
                                                                card: card,
                                                                position: index + 1,
                                                                skuDict: skuDict || array/* EMPTY_ARRAY */.L
                                                            }, card.uid);
                                                        })
                                                    }) : void 0
                                                ]
                                            }) : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)(emotion_react_jsx_runtime_browser_esm.Fragment, {
                                                children: [
                                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(library_NoSearchResults, {
                                                        icon: noSearchResultsData.icon,
                                                        title: noSearchResultsData.title,
                                                        description: noSearchResultsData.description
                                                    }),
                                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("h2", {
                                                        className: WallOfCardsStyles_bs/* title */.TN,
                                                        children: noSearchResultsData.scp_title
                                                    }),
                                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("h3", {
                                                        className: WallOfCardsStyles_bs/* description */.WL,
                                                        children: noSearchResultsData.scp_description
                                                    }),
                                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("div", {
                                                        className: WallOfCardsStyles_bs/* cardsContainer */.VV,
                                                        children: allSwapCards.map(function(card, index) {
                                                            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(Card/* default */.Z, {
                                                                card: card,
                                                                position: index + 1,
                                                                skuDict: skuDict || array/* EMPTY_ARRAY */.L
                                                            }, card.uid);
                                                        })
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)("div", {
                                    children: [
                                        (0,lodash.eq)(search, string/* EMPTY_STRING */.v6) && (0,lodash.size)(currentInventory) === (0,lodash.size)(cardLists.filteredCards) ? retailerContent : void 0,
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("div", {
                                            className: WallOfCardsStyles_bs/* cardsContainer */.VV,
                                            children: displayedCards.map(function(card, index) {
                                                return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(Card/* default */.Z, {
                                                    card: card,
                                                    position: index + 1,
                                                    skuDict: skuDict || array/* EMPTY_ARRAY */.L
                                                }, card.uid);
                                            })
                                        }),
                                        drain.hasSearch() ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("div", {
                                            className: WallOfCardsStyles_bs/* similarResultsContainer */.Ro,
                                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(CardSearchResults_bs/* SimilarResults.make */.I2.make, {
                                                cardLists: cardLists,
                                                className: "mt-4"
                                            })
                                        }) : utils_react/* EMPTY_ELEMENT */.O
                                    ]
                                }),
                                endOfPageStoreContent,
                                noSearchWords ? void 0 : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(BrazeContentCards_bs/* make */.Sy, {})
                            ]
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var store_WallOfCards = (WallOfCards);

;// CONCATENATED MODULE: ./src/components/pages/store/StorePage.tsx














function hasFilterQuery(query, filterList) {
    return (0,lodash.size)((0,lodash.intersection)((0,lodash.keys)(filterList.elements), (0,lodash.keys)(query))) > 0;
}
function findParentFilter(filterValue, filterList) {
    var parent = void 0;
    (0,lodash.each)((0,lodash.keys)(filterList.elements), function(key) {
        var isContainer = (0,lodash.size)((0,lodash.filter)(filterList.elements[key].terms, function(param) {
            var codename = param.codename;
            return (0,lodash.includes)(filterValue, codename);
        })) > 0;
        if (isContainer) {
            parent = filterList.elements[key];
        }
    });
    return parent;
}
function findFilterTerm(parentKey, filterCodename, filterList) {
    return (0,lodash.find)(filterList.elements[parentKey].terms, function(param) {
        var codename = param.codename;
        return (0,lodash.eq)(codename, filterCodename);
    });
}
function parseQueryFilter(query, filterList) {
    if (hasFilterQuery(query, filterList)) {
        var currentFilter = {
            elements: (0,lodash.compact)((0,lodash.flatten)((0,lodash.map)((0,lodash.keys)(filterList.elements), function(parentKey, key) {
                var filter = (0,lodash.split)(query[parentKey], string/* COMMA */.OC);
                // const filter = query[filterKey] as string;
                if (!(0,lodash.isUndefined)(findParentFilter(filter[0], filterList))) {
                    return (0,lodash.map)(filter, function(filterValue, valueKey) {
                        return {
                            codename: filterValue,
                            name: findFilterTerm(parentKey, filterValue, filterList).name,
                            parent: {
                                codename: parentKey,
                                name: findParentFilter(filterValue, filterList).name,
                                parent: void 0
                            }
                        };
                    });
                } else {
                    return void 0;
                }
            })))
        };
        return currentFilter;
    } else {
        return void 0;
    }
}
function parseQuerySort(query) {
    return (query === null || query === void 0 ? void 0 : query.sort) && (0,lodash.includes)((0,lodash.values)(SortValue), query === null || query === void 0 ? void 0 : query.sort) ? query === null || query === void 0 ? void 0 : query.sort : SortValue.Featured;
}
var StorePage = function(param) {
    var inventory = param.inventory, categories = param.categories, content = param.content, skuList = param.skuList, filterList = param.filterList;
    var ref, ref1, ref2, ref3;
    var currentInventory = (inventory === null || inventory === void 0 ? void 0 : (ref = inventory.skus) === null || ref === void 0 ? void 0 : ref.map(function(sku) {
        return Models_bs/* Card.skuToCard */.Zb.skuToCard((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, sku), {
            isPbCategoryHidden: sku.hideFromAllBusinessCategories,
            isPcCategoryHidden: sku.hideFromAllClassicCategories
        }));
    })) || [];
    var skuDict = (ref1 = (0,Gql_SkuPresentation_Decoder_List_bs/* parse */.Qc)(skuList)) === null || ref1 === void 0 ? void 0 : ref1.map(function(dict) {
        return [
            dict.codename,
            dict
        ];
    });
    var seoMetaContent = (ref2 = (0,PageContentResolver_bs/* parse */.Qc)(content)) === null || ref2 === void 0 ? void 0 : ref2.seo_meta;
    var seoMeta = seoMetaContent ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(SeoMeta/* default */.Z, {
        meta: seoMetaContent
    }) : utils_react/* EMPTY_ELEMENT */.O;
    var storeContent = (ref3 = (0,PageContentResolver_bs/* parse */.Qc)(content)) === null || ref3 === void 0 ? void 0 : ref3.store_content;
    var store = storeContent || void 0;
    var router = (0,next_router.useRouter)();
    var initDefaultDrainContextProviderValue = function(inventory, skuDict) {
        var ref;
        var cardList = appendDict(skuDict)(inventory);
        return {
            filter: parseQueryFilter(router.query, filterList),
            prevFilter: void 0,
            isOpen: false,
            currentType: DrainType.Filter,
            // @note: router query param can be an array
            search: ((ref = router.query) === null || ref === void 0 ? void 0 : ref.search) || string/* EMPTY_STRING */.v6,
            setPage: function() {
                return void 0;
            },
            appendFilter: function() {
                return void 0;
            },
            setSearch: function() {
                return void 0;
            },
            onSearchChange: function() {
                return void 0;
            },
            hasSearch: function() {
                return false;
            },
            switchFilter: function() {
                return void 0;
            },
            page: void 0,
            applyFilter: function() {
                return void 0;
            },
            setFilter: function() {
                return void 0;
            },
            apply: hasFilterQuery(router.query, filterList),
            hasFilter: function() {
                return false;
            },
            setSortValue: function() {
                return void 0;
            },
            applySort: function() {
                return void 0;
            },
            sort: parseQuerySort(router.query),
            prevSort: SortValue.Featured,
            initValue: function() {
                return void 0;
            },
            hasSort: function() {
                return false;
            },
            currentValue: {
                current: cardList,
                cardList: cardList,
                filter: (0,_object_spread/* default */.Z)({}, parseQueryFilter(router.query, filterList)),
                sort: SortValue.Featured
            },
            clearFilter: function() {
                return void 0;
            },
            restore: function() {
                return void 0;
            },
            applySearch: function() {
                return void 0;
            },
            setCurrentValue: function() {
                return void 0;
            },
            setPrevFilter: function() {
                return void 0;
            },
            trackDrainFilterSection: function() {
                return void 0;
            }
        };
    };
    /**
   * Init Drain Context Value
   */ var drainContextValue = initDefaultDrainContextProviderValue(currentInventory, skuDict);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(emotion_react_jsx_runtime_browser_esm.Fragment, {
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)(DrainContextProvider, {
            value: drainContextValue,
            children: [
                seoMeta,
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(store_WallOfCards, {
                    inventoryProps: currentInventory,
                    storeContent: store,
                    skuDict: skuDict,
                    filterList: filterList
                })
            ]
        })
    });
};

// EXTERNAL MODULE: ./src/components/pages/store/zag/ZagExplanationModal.tsx + 1 modules
var ZagExplanationModal = __webpack_require__(78056);
;// CONCATENATED MODULE: ./node_modules/@chakra-ui/hooks/dist/chunk-EGV7XMQK.mjs
// src/use-id.ts

function useId(idProp, prefix) {
  const id = (0,react.useId)();
  return (0,react.useMemo)(
    () => idProp || [prefix, id].filter(Boolean).join("-"),
    [idProp, prefix, id]
  );
}
function useIds(idProp, ...prefixes) {
  const id = useId(idProp);
  return useMemo(() => {
    return prefixes.map((prefix) => `${prefix}-${id}`);
  }, [id, prefixes]);
}
function useOptionalPart(partId) {
  const [id, setId] = useState(null);
  const ref = useCallback(
    (node) => {
      setId(node ? partId : null);
    },
    [partId]
  );
  return { ref, id, isRendered: Boolean(id) };
}



;// CONCATENATED MODULE: ./node_modules/@chakra-ui/hooks/dist/chunk-NUQE4USX.mjs


// src/use-controllable.ts


function useControllableProp(prop, state) {
  const isControlled = prop !== void 0;
  const value = isControlled && typeof prop !== "undefined" ? prop : state;
  return [isControlled, value];
}
function useControllableState(props) {
  const {
    value: valueProp,
    defaultValue,
    onChange,
    shouldUpdate = (prev, next) => prev !== next
  } = props;
  const onChangeProp = useCallbackRef(onChange);
  const shouldUpdateProp = useCallbackRef(shouldUpdate);
  const [valueState, setValue] = useState(defaultValue);
  const isControlled = valueProp !== void 0;
  const value = isControlled ? valueProp : valueState;
  const updateValue = useCallback(
    (next) => {
      const nextValue = runIfFn(next, value);
      if (!shouldUpdateProp(value, nextValue)) {
        return;
      }
      if (!isControlled) {
        setValue(nextValue);
      }
      onChangeProp(nextValue);
    },
    [isControlled, onChangeProp, value, shouldUpdateProp]
  );
  return [value, updateValue];
}



;// CONCATENATED MODULE: ./node_modules/@chakra-ui/utils/dist/chunk-O3SWHQEE.mjs
// src/dom.ts
function isElement(el) {
  return el != null && typeof el == "object" && "nodeType" in el && el.nodeType === Node.ELEMENT_NODE;
}
function isHTMLElement(el) {
  var _a;
  if (!isElement(el)) {
    return false;
  }
  const win = (_a = el.ownerDocument.defaultView) != null ? _a : window;
  return el instanceof win.HTMLElement;
}
function getOwnerWindow(node) {
  var _a, _b;
  return isElement(node) ? (_b = (_a = getOwnerDocument(node)) == null ? void 0 : _a.defaultView) != null ? _b : window : window;
}
function getOwnerDocument(node) {
  var _a;
  return isElement(node) ? (_a = node.ownerDocument) != null ? _a : document : document;
}
function getEventWindow(event) {
  var _a;
  return (_a = event.view) != null ? _a : window;
}
function canUseDOM() {
  return !!(typeof window !== "undefined" && window.document && window.document.createElement);
}
var isBrowser = /* @__PURE__ */ canUseDOM();
var dataAttr = (condition) => condition ? "" : void 0;
var chunk_O3SWHQEE_ariaAttr = (condition) => condition ? true : void 0;
var cx = (...classNames) => classNames.filter(Boolean).join(" ");
function getActiveElement(node) {
  const doc = getOwnerDocument(node);
  return doc == null ? void 0 : doc.activeElement;
}
function contains(parent, child) {
  if (!parent)
    return false;
  return parent === child || parent.contains(child);
}
function addDomEvent(target, eventName, handler, options) {
  target.addEventListener(eventName, handler, options);
  return () => {
    target.removeEventListener(eventName, handler, options);
  };
}
function normalizeEventKey(event) {
  const { key, keyCode } = event;
  const isArrowKey = keyCode >= 37 && keyCode <= 40 && key.indexOf("Arrow") !== 0;
  const eventKey = isArrowKey ? `Arrow${key}` : key;
  return eventKey;
}
function getRelatedTarget(event) {
  var _a, _b;
  const target = (_a = event.target) != null ? _a : event.currentTarget;
  const activeElement = getActiveElement(target);
  return (_b = event.relatedTarget) != null ? _b : activeElement;
}
function isRightClick(event) {
  return event.button !== 0;
}



;// CONCATENATED MODULE: ./node_modules/@chakra-ui/hooks/dist/chunk-IYF65QR3.mjs
// src/use-safe-layout-effect.ts


var chunk_IYF65QR3_useSafeLayoutEffect = isBrowser ? react.useLayoutEffect : react.useEffect;



;// CONCATENATED MODULE: ./node_modules/@chakra-ui/hooks/dist/chunk-TFWETJDV.mjs


// src/use-callback-ref.ts

function chunk_TFWETJDV_useCallbackRef(fn, deps = []) {
  const ref = (0,react.useRef)(fn);
  chunk_IYF65QR3_useSafeLayoutEffect(() => {
    ref.current = fn;
  });
  return (0,react.useCallback)((...args) => {
    var _a;
    return (_a = ref.current) == null ? void 0 : _a.call(ref, ...args);
  }, deps);
}



// EXTERNAL MODULE: ./node_modules/@chakra-ui/utils/dist/chunk-M3TFMUOL.mjs + 1 modules
var chunk_M3TFMUOL = __webpack_require__(36597);
;// CONCATENATED MODULE: ./node_modules/@chakra-ui/hooks/dist/chunk-CHB4ZXZG.mjs




// src/use-disclosure.ts


function useDisclosure(props = {}) {
  const {
    onClose: onCloseProp,
    onOpen: onOpenProp,
    isOpen: isOpenProp,
    id: idProp
  } = props;
  const onOpenPropCallbackRef = chunk_TFWETJDV_useCallbackRef(onOpenProp);
  const onClosePropCallbackRef = chunk_TFWETJDV_useCallbackRef(onCloseProp);
  const [isOpenState, setIsOpen] = (0,react.useState)(props.defaultIsOpen || false);
  const [isControlled, isOpen] = useControllableProp(isOpenProp, isOpenState);
  const id = useId(idProp, "disclosure");
  const onClose = (0,react.useCallback)(() => {
    if (!isControlled) {
      setIsOpen(false);
    }
    onClosePropCallbackRef == null ? void 0 : onClosePropCallbackRef();
  }, [isControlled, onClosePropCallbackRef]);
  const onOpen = (0,react.useCallback)(() => {
    if (!isControlled) {
      setIsOpen(true);
    }
    onOpenPropCallbackRef == null ? void 0 : onOpenPropCallbackRef();
  }, [isControlled, onOpenPropCallbackRef]);
  const onToggle = (0,react.useCallback)(() => {
    const action = isOpen ? onClose : onOpen;
    action();
  }, [isOpen, onOpen, onClose]);
  return {
    isOpen: !!isOpen,
    onOpen,
    onClose,
    onToggle,
    isControlled,
    getButtonProps: (props2 = {}) => ({
      ...props2,
      "aria-expanded": isOpen,
      "aria-controls": id,
      onClick: (0,chunk_M3TFMUOL/* callAllHandlers */.v0)(props2.onClick, onToggle)
    }),
    getDisclosureProps: (props2 = {}) => ({
      ...props2,
      hidden: !isOpen,
      id
    })
  };
}



// EXTERNAL MODULE: ./src/contexts/NavVisibilityContext.tsx
var NavVisibilityContext = __webpack_require__(28750);
;// CONCATENATED MODULE: ./src/async-pages/store.tsx









// @ts-ignore
var RemoteWoc = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 2825).then(__webpack_require__.t.bind(__webpack_require__, 62825, 23));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(62825)
            ];
        }
    },
    loading: function() {
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("span", {});
    },
    ssr: false
});
var RemoteHeroBanner = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 9806).then(__webpack_require__.bind(__webpack_require__, 82030));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(82030)
            ];
        }
    },
    loading: function() {
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("span", {});
    },
    ssr: false
});
var store_StorePage = function(_param) {
    var inventory = _param.inventory, store = _param.store, presentationList = _param.presentationList, storePageContentItems = _param.storePageContentItems, smartCardContent = _param.smartCardContent, config = _param.config, rest = (0,_object_without_properties/* default */.Z)(_param, [
        "inventory",
        "store",
        "presentationList",
        "storePageContentItems",
        "smartCardContent",
        "config"
    ]);
    var zagModal = useDisclosure();
    var router = (0,next_router.useRouter)();
    var navIsVisible = (0,NavVisibilityContext/* useNavVisibilty */.K3)();
    if (!config.featureLayerBuyingWeb) {
        // @ts-ignore
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(StorePage, (0,_object_spread/* default */.Z)({
            inventory: inventory
        }, rest));
    }
    var onClickBannerCta = function(btn) {
        //TODO: Remove after christmas 2024
        if ((btn === null || btn === void 0 ? void 0 : btn.ctaText) && (btn === null || btn === void 0 ? void 0 : btn.ctaUrl)) {
            window.location.assign(btn.ctaUrl);
        } else {
            zagModal.onOpen();
        }
    };
    var onClickSmartCardContentLink = function(link) {
        switch(link){
            case "#modal_prezzee-plus-explanation":
                {
                    zagModal.onOpen();
                    break;
                }
            default:
                {
                    router.push(link);
                }
        }
    };
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)(emotion_react_jsx_runtime_browser_esm.Fragment, {
        children: [
            storePageContentItems.map(function(item, index) {
                // @ts-ignore
                switch(item.__typename){
                    case "Cms_HeroBanner":
                        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(RemoteHeroBanner, {
                            data: item,
                            onClickBannerCta: function(btn) {
                                return onClickBannerCta(btn);
                            },
                            marginTop: "40px",
                            paddingX: "16px"
                        }, item.__typename + index.toString());
                }
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(RemoteWoc, {
                // @ts-ignore
                inventory: inventory,
                store: store,
                presentationList: presentationList,
                smartCardContent: smartCardContent,
                onClickSmartCardContentLink: onClickSmartCardContentLink,
                navIsVisible: navIsVisible
            }),
            zagModal.isOpen && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(ZagExplanationModal/* default */.Z, {
                onClose: zagModal.onClose
            })
        ]
    });
};
/* harmony default export */ var store = (store_StorePage);


/***/ }),

/***/ 47800:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "p5": function() { return /* binding */ ssr_page_cache; },
/* harmony export */   "yN": function() { return /* binding */ no_cache; }
/* harmony export */ });
/* unused harmony export product_ssr_page_cache */
// Generated by ReScript, PLEASE EDIT WITH CARE
var ssr_page_cache = "public, max-age=600, stale-while-revalidate=300, stale-if-error=1800";
var product_ssr_page_cache = "public, max-age=60, stale-while-revalidate=300, stale-if-error=1800";
var no_cache = "private, no-cache, no-store, max-age=0, must-revalidate";
 /* No side effect */ 


/***/ }),

/***/ 31290:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Nn": function() { return /* binding */ getEnrichedTextSection; },
  "Xi": function() { return /* binding */ getSmartCardHeroSection; }
});

// UNUSED EXPORTS: ContentBlockName

// EXTERNAL MODULE: ./node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(35944);
// EXTERNAL MODULE: ./src/components/enrichedTextSection/EnrichedTextSection.bs.js + 4 modules
var EnrichedTextSection_bs = __webpack_require__(94135);
// EXTERNAL MODULE: ./node_modules/@emotion/css/dist/emotion-css.esm.js
var emotion_css_esm = __webpack_require__(97133);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./src/components/CmsImage.tsx
var CmsImage = __webpack_require__(73450);
// EXTERNAL MODULE: ./node_modules/@prezzee/ribbon-ui/lib/theme/foundations/colors.js
var colors = __webpack_require__(85171);
// EXTERNAL MODULE: ./node_modules/@prezzee/ribbon-ui/lib/theme/foundations/breakpoints.js
var breakpoints = __webpack_require__(72486);
// EXTERNAL MODULE: ./node_modules/@prezzee/ribbon/src/theme/Theme__Responsive.bs.js
var Theme_Responsive_bs = __webpack_require__(70965);
// EXTERNAL MODULE: ./node_modules/@prezzee/ribbon/src/components/personal/Button/Button.bs.js + 1 modules
var Button_bs = __webpack_require__(10573);
;// CONCATENATED MODULE: ./src/components/library/smartCardHeroSection.tsx








var style = {
    container: /*#__PURE__*/ (0,emotion_css_esm/* css */.iv)("background-color:", colors["default"].lilac[50], ";border-radius:8px;display:flex;align-items:center;justify-content:space-between;margin:0 0 44px;@media ", Theme_Responsive_bs/* tabletSm */.FV, "{align-items:center;flex-direction:column-reverse;padding:0 16px 16px;}"),
    content: /*#__PURE__*/ (0,emotion_css_esm/* css */.iv)("width:60%;padding:0 0 0 57px;@media (max-width:", breakpoints["default"].lg, "){width:54%;padding:41px 0 32px 32px;}@media ", Theme_Responsive_bs/* tabletSm */.FV, "{width:100%;padding:0;}"),
    title: /*#__PURE__*/ (0,emotion_css_esm/* css */.iv)("font-size:27px;line-height:32px;font-weight:600;"),
    description: /*#__PURE__*/ (0,emotion_css_esm/* css */.iv)("margin-top:12px;"),
    primaryBtn: /*#__PURE__*/ (0,emotion_css_esm/* css */.iv)("margin:0 12px 0 0;@media ", Theme_Responsive_bs/* tabletSm */.FV, "{margin:0 0 12px 0;}"),
    buttonContainer: /*#__PURE__*/ (0,emotion_css_esm/* css */.iv)("display:flex;margin-top:24px;@media ", Theme_Responsive_bs/* tabletSm */.FV, "{flex-flow:column;button{width:100%;}}"),
    image: /*#__PURE__*/ (0,emotion_css_esm/* css */.iv)("width:35%;@media ", Theme_Responsive_bs/* tabletSm */.FV, "{display:none;}"),
    mobileImage: /*#__PURE__*/ (0,emotion_css_esm/* css */.iv)("display:none;width:100%;@media ", Theme_Responsive_bs/* tabletSm */.FV, "{display:block;}")
};
var SmartCardHeroSection = function(param) {
    var _block = param.block, title = _block.title, description = _block.description, primaryButton = _block.primaryButton, secondaryButton = _block.secondaryButton, image = _block.image, mobileImage = _block.mobileImage;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)("div", {
        className: "".concat(style.container, " mx-4"),
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)("div", {
                className: style.content,
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("h2", {
                        className: style.title,
                        children: title
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("p", {
                        className: style.description,
                        children: description
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)("div", {
                        className: style.buttonContainer,
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(Button_bs.make, {
                                variant: primaryButton.variant,
                                colour: primaryButton.colour,
                                fill: primaryButton.fill,
                                className: style.primaryBtn,
                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)((link_default()), {
                                    href: primaryButton.cta_url,
                                    passHref: true,
                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("a", {
                                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("button", {
                                            children: primaryButton.cta_text
                                        })
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(Button_bs.make, {
                                variant: secondaryButton.variant,
                                colour: secondaryButton.colour,
                                fill: secondaryButton.fill,
                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)((link_default()), {
                                    href: secondaryButton.cta_url,
                                    passHref: true,
                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("a", {
                                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("button", {
                                            children: secondaryButton.cta_text
                                        })
                                    })
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(CmsImage/* default */.Z, {
                src: image.url,
                alt: image.description,
                width: image.width,
                height: image.height,
                className: style.image,
                sizes: "".concat(Theme_Responsive_bs/* smallScreenOrMobile */.HH, " 220px, ").concat(Theme_Responsive_bs/* tabletOrMobile */.k$, " 260px, ").concat(Theme_Responsive_bs/* belowLargeScreen */.Qo, " 350px, 500px")
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(CmsImage/* default */.Z, {
                src: mobileImage.url,
                alt: mobileImage.description,
                width: mobileImage.width,
                height: mobileImage.height,
                className: style.mobileImage,
                sizes: "48vw"
            })
        ]
    });
};
/* harmony default export */ var smartCardHeroSection = (SmartCardHeroSection);

;// CONCATENATED MODULE: ./src/common/storeSmartCardContent.tsx



var ContentBlockName;
(function(ContentBlockName) {
    ContentBlockName["EnrichedTextBlock"] = "EnrichedTextBlock";
    ContentBlockName["SmartCardHeroBlock"] = "SmartCardHeroBlock";
})(ContentBlockName || (ContentBlockName = {}));
var getEnrichedTextSection = function(storeContent) {
    var data = storeContent.find(function(param) {
        var NAME = param.NAME;
        return NAME === ContentBlockName.EnrichedTextBlock;
    });
    return data ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(EnrichedTextSection_bs/* make */.Sy, {
        block: data.VAL,
        wallOfCards: true
    }) : null;
};
var getSmartCardHeroSection = function(storeContent) {
    var data = storeContent.find(function(param) {
        var NAME = param.NAME;
        return NAME === ContentBlockName.SmartCardHeroBlock;
    });
    return data ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(smartCardHeroSection, {
        block: data.VAL
    }) : null;
};


/***/ }),

/***/ 85663:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Sy": function() { return /* binding */ make; }
/* harmony export */ });
/* unused harmony exports ContentCard, TopContainer, BottomContainer, Title, Description, DeviceSizeImage, Carousel, Slide, SlideContent, Styles */
/* harmony import */ var _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(71863);
/* harmony import */ var _rescript_std_lib_es6_curry_js__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(92592);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _rescript_std_lib_es6_belt_Array_js__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(96533);
/* harmony import */ var _rescript_std_lib_es6_belt_Option_js__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(72491);
/* harmony import */ var _rescript_std_lib_es6_caml_option_js__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(25400);
/* harmony import */ var swiper_react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(48929);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(85893);
/* harmony import */ var _prezzee_ribbon_src_components_common_ContentCard_ContentCard_bs_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(29627);
/* harmony import */ var _prezzee_ribbon_src_theme_Theme_Color_bs_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(17845);
/* harmony import */ var _prezzee_ribbon_src_components_common_DeviceSizeImage_DeviceSizeImage_bs_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(81343);
/* harmony import */ var _prezzee_ribbon_src_components_common_FullWidthCarousel_FullWidthCarousel_bs_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(96020);
/* harmony import */ var _prezzee_ribbon_src_theme_Theme_Typography_bs_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(32567);
/* harmony import */ var _prezzee_ribbon_src_components_common_ContentCard_ContentCard_Title_bs_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(53973);
/* harmony import */ var _prezzee_ribbon_src_components_common_ContentCard_ContentCard_Description_bs_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(8266);
/* harmony import */ var _prezzee_ribbon_src_components_common_FullWidthCarousel_FullWidthCarousel_Slide_bs_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(29261);
/* harmony import */ var _prezzee_ribbon_src_components_common_ContentCard_ContentCard_TopContainer_bs_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(5926);
/* harmony import */ var _prezzee_ribbon_src_components_common_ContentCard_ContentCard_BottomContainer_bs_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(70945);
/* harmony import */ var _prezzee_ribbon_src_components_common_FullWidthCarousel_FullWidthCarousel_SlideContent_bs_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(32426);
// Generated by ReScript, PLEASE EDIT WITH CARE



















var image = _rescript_std_lib_es6_curry_js__WEBPACK_IMPORTED_MODULE_15__._1(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .style */ .oBv, {
    hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .display */ .jfB("block"),
    tl: {
        hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .width */ .bf$(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .pct */ .hdZ(100)),
        tl: {
            hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .borderTopLeftRadius */ .orU(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__.px(8)),
            tl: {
                hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .borderTopRightRadius */ .E$t(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__.px(8)),
                tl: /* [] */ 0
            }
        }
    }
});
var description = _rescript_std_lib_es6_curry_js__WEBPACK_IMPORTED_MODULE_15__._1(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .merge */ .TSy, {
    hd: _prezzee_ribbon_src_theme_Theme_Typography_bs_js__WEBPACK_IMPORTED_MODULE_8__/* .Styles.style4 */ .z.style4,
    tl: {
        hd: _rescript_std_lib_es6_curry_js__WEBPACK_IMPORTED_MODULE_15__._1(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .style */ .oBv, {
            hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .color */ .$_Y(_prezzee_ribbon_src_theme_Theme_Color_bs_js__WEBPACK_IMPORTED_MODULE_5__/* .Business.charcoal */ .e.charcoal),
            tl: /* [] */ 0
        }),
        tl: /* [] */ 0
    }
});
var slide = _rescript_std_lib_es6_curry_js__WEBPACK_IMPORTED_MODULE_15__._1(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .style */ .oBv, {
    hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .important */ .efO(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .height */ .Cb8("auto")),
    tl: {
        hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .display */ .jfB("flex"),
        tl: /* [] */ 0
    }
});
var slideContent = _rescript_std_lib_es6_curry_js__WEBPACK_IMPORTED_MODULE_15__._1(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .style */ .oBv, {
    hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .important */ .efO(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .padding2 */ .BLt(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__.px(10), _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__.px(13))),
    tl: /* [] */ 0
});
var $$global = _rescript_std_lib_es6_curry_js__WEBPACK_IMPORTED_MODULE_15__._1(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .merge */ .TSy, {
    hd: _prezzee_ribbon_src_theme_Theme_Typography_bs_js__WEBPACK_IMPORTED_MODULE_8__/* .Styles.body */ .z.body,
    tl: {
        hd: _rescript_std_lib_es6_curry_js__WEBPACK_IMPORTED_MODULE_15__._1(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .style */ .oBv, {
            hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .width */ .bf$(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .pct */ .hdZ(100)),
            tl: {
                hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .important */ .efO(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .marginTop */ .E9m(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .rem */ .hOB(1.5))),
                tl: /* [] */ 0
            }
        }),
        tl: /* [] */ 0
    }
});
var Styles = {
    image: image,
    description: description,
    slide: slide,
    slideContent: slideContent,
    $$global: $$global
};
function BrazeContentCards(props) {
    var match = react__WEBPACK_IMPORTED_MODULE_1__.useState(function() {});
    var setCardData = match[1];
    var cardData = match[0];
    var match$1 = react__WEBPACK_IMPORTED_MODULE_1__.useState(function() {
        return 0;
    });
    var setTotalCards = match$1[1];
    var totalCards = match$1[0];
    react__WEBPACK_IMPORTED_MODULE_1__.useEffect(function() {
        var timeout = setTimeout(function(param) {
            var hasLoaded = window.appboy !== undefined;
            if (hasLoaded) {
                window.appboy.openSession();
                window.appboy.requestContentCardsRefresh();
                return window.appboy.subscribeToContentCardsUpdates(function(updates) {
                    var cards = updates.cards;
                    var totalCards = cards.length;
                    if (totalCards > 0) {
                        _rescript_std_lib_es6_curry_js__WEBPACK_IMPORTED_MODULE_15__._1(setCardData, function(param) {
                            return cards;
                        });
                        return _rescript_std_lib_es6_curry_js__WEBPACK_IMPORTED_MODULE_15__._1(setTotalCards, function(param) {
                            return totalCards;
                        });
                    }
                });
            }
        }, 1000);
        return function(param) {
            clearTimeout(timeout);
        };
    }, []);
    var contentCardComponent = cardData !== undefined ? _rescript_std_lib_es6_belt_Array_js__WEBPACK_IMPORTED_MODULE_16__/* .mapWithIndex */ .Su(cardData, function(idx, card) {
        var key = String(idx);
        var extras = card.extras;
        var title = card.title;
        if (extras == null) {
            return null;
        }
        var card_type = _rescript_std_lib_es6_belt_Option_js__WEBPACK_IMPORTED_MODULE_17__/* .getWithDefault */ .tj(extras.card_type, "");
        var $$location = _rescript_std_lib_es6_belt_Option_js__WEBPACK_IMPORTED_MODULE_17__/* .getWithDefault */ .tj(extras.location, "");
        if ($$location !== "wall_of_cards_web") {
            return null;
        }
        if (card_type !== "slider") {
            return null;
        }
        var image_desktop = _rescript_std_lib_es6_belt_Option_js__WEBPACK_IMPORTED_MODULE_17__/* .getWithDefault */ .tj(extras.image_desktop, "");
        var image_tablet = _rescript_std_lib_es6_belt_Option_js__WEBPACK_IMPORTED_MODULE_17__/* .getWithDefault */ .tj(extras.image_tablet, "");
        var image_mobile = _rescript_std_lib_es6_belt_Option_js__WEBPACK_IMPORTED_MODULE_17__/* .getWithDefault */ .tj(extras.image_mobile, "");
        var desktopImage = _rescript_std_lib_es6_caml_option_js__WEBPACK_IMPORTED_MODULE_18__/* .some */ .G(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx("img", {
            className: image,
            alt: title,
            src: image_desktop
        }));
        var tabletImage = _rescript_std_lib_es6_caml_option_js__WEBPACK_IMPORTED_MODULE_18__/* .some */ .G(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx("img", {
            className: image,
            alt: title,
            src: image_tablet
        }));
        var mobileImage = _rescript_std_lib_es6_caml_option_js__WEBPACK_IMPORTED_MODULE_18__/* .some */ .G(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx("img", {
            className: image,
            alt: title,
            src: image_mobile
        }));
        var image$1 = react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx(_prezzee_ribbon_src_components_common_DeviceSizeImage_DeviceSizeImage_bs_js__WEBPACK_IMPORTED_MODULE_6__/* .make */ .S, {
            desktop: desktopImage,
            smallScreen: tabletImage,
            tablet: undefined,
            mobile: mobileImage
        });
        var slideContent$1 = react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx(_prezzee_ribbon_src_components_common_FullWidthCarousel_FullWidthCarousel_Slide_bs_js__WEBPACK_IMPORTED_MODULE_11__/* .make */ .Sy, {
            children: react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx(_prezzee_ribbon_src_components_common_FullWidthCarousel_FullWidthCarousel_SlideContent_bs_js__WEBPACK_IMPORTED_MODULE_14__/* .make */ .S, {
                children: react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs(_prezzee_ribbon_src_components_common_ContentCard_ContentCard_bs_js__WEBPACK_IMPORTED_MODULE_4__/* .make */ .S, {
                    children: [
                        react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx(_prezzee_ribbon_src_components_common_ContentCard_ContentCard_TopContainer_bs_js__WEBPACK_IMPORTED_MODULE_12__/* .make */ .S, {
                            children: image$1
                        }),
                        react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs(_prezzee_ribbon_src_components_common_ContentCard_ContentCard_BottomContainer_bs_js__WEBPACK_IMPORTED_MODULE_13__/* .make */ .S, {
                            children: [
                                react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx(_prezzee_ribbon_src_components_common_ContentCard_ContentCard_Title_bs_js__WEBPACK_IMPORTED_MODULE_9__/* .make */ .S, {
                                    children: title
                                }),
                                react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx(_prezzee_ribbon_src_components_common_ContentCard_ContentCard_Description_bs_js__WEBPACK_IMPORTED_MODULE_10__/* .make */ .S, {
                                    children: card.description
                                })
                            ]
                        })
                    ]
                }),
                className: slideContent
            })
        });
        var href = _rescript_std_lib_es6_belt_Option_js__WEBPACK_IMPORTED_MODULE_17__/* .getWithDefault */ .tj(card.url, "");
        var slide$1 = href === "" ? react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.Fragment, {
            children: _rescript_std_lib_es6_caml_option_js__WEBPACK_IMPORTED_MODULE_18__/* .some */ .G(slideContent$1)
        }) : react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx("a", {
            children: slideContent$1,
            href: href
        });
        if (totalCards !== 1) {
            return react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx(swiper_react__WEBPACK_IMPORTED_MODULE_2__/* .SwiperSlide */ .o5, {
                className: slide,
                children: slide$1
            }, key);
        } else {
            return slide$1;
        }
    }) : null;
    if (totalCards !== 0) {
        return react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx(_prezzee_ribbon_src_components_common_FullWidthCarousel_FullWidthCarousel_bs_js__WEBPACK_IMPORTED_MODULE_7__/* .make */ .Sy, {
            children: contentCardComponent,
            autoplay: true,
            className: $$global
        });
    } else {
        return null;
    }
}
var ContentCard;
var TopContainer;
var BottomContainer;
var Title;
var Description;
var DeviceSizeImage;
var Carousel;
var Slide;
var SlideContent;
var make = BrazeContentCards;
 /* image Not a pure module */ 


/***/ }),

/***/ 54098:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ro": function() { return /* binding */ similarResultsContainer; },
/* harmony export */   "TN": function() { return /* binding */ title; },
/* harmony export */   "VV": function() { return /* binding */ cardsContainer; },
/* harmony export */   "WL": function() { return /* binding */ description; },
/* harmony export */   "lE": function() { return /* binding */ rootContainerWall; }
/* harmony export */ });
/* unused harmony export aboutGrid */
/* harmony import */ var _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(71863);
/* harmony import */ var _rescript_std_lib_es6_curry_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(92592);
// Generated by ReScript, PLEASE EDIT WITH CARE


var similarResultsContainer = _rescript_std_lib_es6_curry_js__WEBPACK_IMPORTED_MODULE_1__._1(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .style */ .oBv, {
    hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .selector */ .nZE("> h3", {
        hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .marginLeft */ .oIA(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .rem */ .hOB(0.8)),
        tl: /* [] */ 0
    }),
    tl: /* [] */ 0
});
var rootContainerWall = "container mx-auto p-0";
var cardsContainer = "flex mt-4 flex-wrap";
var title = "text-2xl sm:text-32px leading-8 font-semibold pt-4 mx-4 pb-2 sm:pb-3";
var description = "text-base mx-4 text-gray-600";
var aboutGrid = "flex flex-wrap pt-10 -mx-6 text-sm text-gray-600 mx-auto";
 /* similarResultsContainer Not a pure module */ 


/***/ }),

/***/ 78056:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ zag_ZagExplanationModal; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(35944);
// EXTERNAL MODULE: ./node_modules/@prezzee/ribbon-ui/lib/components/Modal/index.js
var Modal = __webpack_require__(15115);
// EXTERNAL MODULE: ./node_modules/@prezzee/ribbon-ui/lib/components/Typography/index.js
var Typography = __webpack_require__(43543);
// EXTERNAL MODULE: ./node_modules/@prezzee/ribbon-ui/lib/components/Button/index.js
var Button = __webpack_require__(43515);
// EXTERNAL MODULE: ./node_modules/@prezzee/ribbon-ui/lib/components/Box/index.js
var Box = __webpack_require__(18636);
// EXTERNAL MODULE: ./node_modules/@prezzee/ribbon-ui/lib/components/Stack/index.js
var Stack = __webpack_require__(72406);
// EXTERNAL MODULE: ./node_modules/@prezzee/ribbon-ui/lib/hooks/useDisclosure.js
var useDisclosure = __webpack_require__(18500);
// EXTERNAL MODULE: ./node_modules/@prezzee/ribbon-ui/lib/components/icons/ChevronLeftIcon.js
var ChevronLeftIcon = __webpack_require__(50256);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/components/pages/store/RetailerListModal.tsx
var RetailerListModal = __webpack_require__(99725);
// EXTERNAL MODULE: ./node_modules/@tanstack/react-query/build/lib/useQuery.mjs + 6 modules
var useQuery = __webpack_require__(67848);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(70655);
// EXTERNAL MODULE: ./src/api/helpers.ts + 72 modules
var helpers = __webpack_require__(60693);
;// CONCATENATED MODULE: ./src/api/queries/zagInfoModal.ts



var zagInfoModal = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(language, isPreview) {
        var client, data;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    client = (0,helpers/* createDeliveryClient */.As)(language, isPreview);
                    return [
                        4,
                        client.item("zag_explanation_modal").toPromise()
                    ];
                case 1:
                    return [
                        4,
                        _state.sent().data
                    ];
                case 2:
                    data = _state.sent();
                    return [
                        2,
                        data
                    ];
            }
        });
    });
    return function zagInfoModal(language, isPreview) {
        return _ref.apply(this, arguments);
    };
}();
/* harmony default export */ var queries_zagInfoModal = (zagInfoModal);

// EXTERNAL MODULE: ./src/common/util.bs.js
var util_bs = __webpack_require__(7667);
// EXTERNAL MODULE: ./node_modules/react-html-parser/lib/index.js
var lib = __webpack_require__(30653);
;// CONCATENATED MODULE: ./src/components/pages/store/zag/ZagExplanationModal.tsx
















var ZagExplanationModal = function(param) {
    var sku = param.sku, onClose = param.onClose;
    var ref, ref1, ref2;
    var retailerListDialog = (0,useDisclosure/* default */.Z)();
    var ref3 = (0,useQuery/* useQuery */.a)([
        "zagInfoModal"
    ], function() {
        return queries_zagInfoModal(util_bs/* EnvUtil.getCmsLanguageFromRegion */.i3.getCmsLanguageFromRegion(), false);
    }), data = ref3.data, isError = ref3.isError, isLoading = ref3.isLoading;
    var desktopScreen = window.matchMedia("(min-width: 577px)");
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)(react.Fragment, {
        children: [
            !retailerListDialog.isOpen && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)(Modal/* Modal */.u_, {
                isOpen: true,
                onClose: onClose,
                isCentered: true,
                size: desktopScreen.matches ? "md" : "xs",
                scrollBehavior: "inside",
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(Modal/* ModalOverlay */.ZA, {}),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)(Modal/* ModalContent */.hz, {
                        maxWidth: "800px",
                        margin: "20px",
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(Modal/* ModalHeader */.xB, {
                                pb: 0,
                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(Typography["default"], {
                                    variant: "h2",
                                    color: "gray.800",
                                    fontSize: "24",
                                    fontWeight: "bold",
                                    children: "Prezzee Plus eGift Card"
                                })
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(Modal/* ModalCloseButton */.ol, {
                                mt: 3
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)(Modal/* ModalBody */.fe, {
                                children: [
                                    isLoading && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(Box["default"], {
                                        display: "flex",
                                        justifyContent: "center",
                                        children: "Loading"
                                    }),
                                    isError && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(Box["default"], {
                                        display: "flex",
                                        justifyContent: "center",
                                        children: "Failed to fetch data, please try again later"
                                    }),
                                    data && (0,lib/* default */.ZP)(data.item.elements.content.value, {
                                        transform: function(node) {
                                            var ref;
                                            // Should move this to util package when we have the chance
                                            if ((node === null || node === void 0 ? void 0 : node.type) === "tag" && (node === null || node === void 0 ? void 0 : node.name) === "a") {
                                                return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(Button["default"], (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                                                    as: "a",
                                                    variant: "link",
                                                    textDecoration: "underline",
                                                    fontSize: "sm"
                                                }, node.attribs), {
                                                    children: node === null || node === void 0 ? void 0 : node.children.map(function(child) {
                                                        if (child.type === "text") {
                                                            return child.data;
                                                        }
                                                        return null;
                                                    })
                                                }));
                                            }
                                            if ((node === null || node === void 0 ? void 0 : node.type) === "text" && (node === null || node === void 0 ? void 0 : (ref = node.data) === null || ref === void 0 ? void 0 : ref.includes("{0}"))) {
                                                var ref1;
                                                var tempStrArr = node === null || node === void 0 ? void 0 : (ref1 = node.data) === null || ref1 === void 0 ? void 0 : ref1.split("{0}");
                                                return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)(emotion_react_jsx_runtime_browser_esm.Fragment, {
                                                    children: [
                                                        tempStrArr === null || tempStrArr === void 0 ? void 0 : tempStrArr[0],
                                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(Button["default"], {
                                                            variant: "link",
                                                            onClick: retailerListDialog.onOpen,
                                                            fontSize: "md",
                                                            textDecoration: "underline",
                                                            mb: "4",
                                                            children: data.item.elements.participating_brands_link.value
                                                        })
                                                    ]
                                                });
                                            }
                                        }
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(Stack.VStack, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, buttonStackStyles), {
                                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(Button["default"], {
                                            variant: "primary",
                                            onClick: onClose,
                                            width: "full",
                                            children: data === null || data === void 0 ? void 0 : (ref = data.item) === null || ref === void 0 ? void 0 : (ref1 = ref.elements) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.cta_text) === null || ref2 === void 0 ? void 0 : ref2.value
                                        })
                                    }))
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(RetailerListModal/* default */.Z, {
                showDefaultStore: true,
                isOpen: retailerListDialog.isOpen,
                onClose: function() {
                    retailerListDialog.onClose();
                    onClose();
                },
                uid: sku === null || sku === void 0 ? void 0 : sku.uid,
                title: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)(emotion_react_jsx_runtime_browser_esm.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(Button["default"], {
                            leftIcon: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(Box["default"], {
                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(ChevronLeftIcon/* default */.Z, {})
                            }),
                            variant: "unstyled",
                            onClick: retailerListDialog.onClose,
                            children: "Back"
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("br", {}),
                        "Available brands"
                    ]
                })
            })
        ]
    });
};
var buttonStackStyles = {
    justifyContent: "flex-start",
    alignItems: "flex-start",
    mb: 4
};
/* harmony default export */ var zag_ZagExplanationModal = (ZagExplanationModal);


/***/ }),

/***/ 13813:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "l": function() { return /* binding */ paymentMethodMap; },
/* harmony export */   "v": function() { return /* binding */ ProductSearchType; }
/* harmony export */ });
var paymentMethodMap = {
    applePay: "apple_pay",
    googlePay: "google_pay",
    creditCard: "credit_card",
    paypal: "paypal"
};
var ProductSearchType;
(function(ProductSearchType) {
    ProductSearchType["Keyword"] = "keyword";
    ProductSearchType["Filter"] = "filter";
    ProductSearchType["Both"] = "both";
})(ProductSearchType || (ProductSearchType = {}));


/***/ }),

/***/ 73763:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Qc": function() { return /* binding */ parse; },
/* harmony export */   "UW": function() { return /* binding */ resolver; }
/* harmony export */ });
/* unused harmony export modifyBlocks */
/* harmony import */ var _glennsl_bs_json_src_Json_bs_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(57687);
/* harmony import */ var _common_util_bs_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7667);
/* harmony import */ var _api_graphql_CmsData_bs_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(607);
/* harmony import */ var _rescript_std_lib_es6_js_dict_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(43437);
/* harmony import */ var _rescript_std_lib_es6_js_null_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(94518);
/* harmony import */ var _common_Constants_bs_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(47800);
/* harmony import */ var _rescript_std_lib_es6_js_string_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(37712);
/* harmony import */ var _rescript_std_lib_es6_belt_Array_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(96533);
/* harmony import */ var _rescript_std_lib_es6_js_promise_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(27097);
/* harmony import */ var _rescript_std_lib_es6_belt_Option_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(72491);
/* harmony import */ var _rescript_std_lib_es6_caml_option_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(25400);
/* harmony import */ var _api_queries_modifyBlocks__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(23328);
// Generated by ReScript, PLEASE EDIT WITH CARE












function modifyBlocks(prim0, prim1, prim2) {
    return ModifyBlocks.modifyBlocks(prim0, prim1, prim2);
}
function resolver(ctx, url, param) {
    if (_rescript_std_lib_es6_belt_Option_js__WEBPACK_IMPORTED_MODULE_4__/* .isNone */ .Wi(_rescript_std_lib_es6_js_dict_js__WEBPACK_IMPORTED_MODULE_5__/* .get */ .U2(ctx.query, "preview"))) {
        ctx.res.setHeader("Cache-Control", _common_Constants_bs_js__WEBPACK_IMPORTED_MODULE_6__/* .ssr_page_cache */ .p5);
    }
    var isPreview = _rescript_std_lib_es6_belt_Option_js__WEBPACK_IMPORTED_MODULE_4__/* .isSome */ .pC(_rescript_std_lib_es6_js_dict_js__WEBPACK_IMPORTED_MODULE_5__/* .get */ .U2(ctx.query, "preview"));
    var i = _rescript_std_lib_es6_js_dict_js__WEBPACK_IMPORTED_MODULE_5__/* .get */ .U2(ctx.query, "lang");
    var language = i !== undefined ? i : null;
    var path = _rescript_std_lib_es6_belt_Array_js__WEBPACK_IMPORTED_MODULE_7__/* .get */ .U2(_rescript_std_lib_es6_js_string_js__WEBPACK_IMPORTED_MODULE_8__/* .split */ .Vl("?", ctx.resolvedUrl), 0);
    var queryUrl = url !== undefined ? url : path !== undefined ? path : "";
    return _rescript_std_lib_es6_js_promise_js__WEBPACK_IMPORTED_MODULE_9__/* .then_ */ .k(function(res) {
        var content = _rescript_std_lib_es6_belt_Option_js__WEBPACK_IMPORTED_MODULE_4__/* .flatMap */ .VS(res, function(p) {
            return p.content;
        });
        var result = _rescript_std_lib_es6_js_null_js__WEBPACK_IMPORTED_MODULE_10__/* .fromOption */ .Yo(JSON.stringify(content));
        return _rescript_std_lib_es6_js_promise_js__WEBPACK_IMPORTED_MODULE_9__/* .then_ */ .k(function(modifiedResult) {
            return Promise.resolve({
                props: {
                    content: modifiedResult
                }
            });
        }, _api_queries_modifyBlocks__WEBPACK_IMPORTED_MODULE_3__/* .modifyBlocks */ .IN(result, isPreview, _common_util_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .EnvUtil.getCmsLanguage */ .i3.getCmsLanguage(language)));
    }, _api_graphql_CmsData_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .getPageContent */ .nW(_common_util_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .EnvUtil.getCmsLanguage */ .i3.getCmsLanguage(language), isPreview, queryUrl));
}
function parse(data) {
    return _rescript_std_lib_es6_belt_Option_js__WEBPACK_IMPORTED_MODULE_4__/* .map */ .UI(data == null ? undefined : _rescript_std_lib_es6_caml_option_js__WEBPACK_IMPORTED_MODULE_11__/* .some */ .G(data), _glennsl_bs_json_src_Json_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .parseOrRaise */ .YF);
}
 /* Util Not a pure module */ 


/***/ }),

/***/ 34708:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __importDefault = (void 0) && (void 0).__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
var faCaretDown_1 = __webpack_require__(77392);
var createIcon_1 = __importDefault(__webpack_require__(75541));
var CaretDownIcon = (0, createIcon_1.default)({
    displayName: "CaretDownIcon",
    title: "Caret down icon",
    icon: faCaretDown_1.faCaretDown
});
exports["default"] = CaretDownIcon;


/***/ }),

/***/ 29627:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "S": function() { return /* binding */ make; }
/* harmony export */ });
/* unused harmony export Styles */
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var bs_css_src_Css_Js_Core_bs_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(32885);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85893);
/* harmony import */ var _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(36585);
// Generated by ReScript, PLEASE EDIT WITH CARE




var wrapper = _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_3__/* .style */ .oBv([
    _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_3__/* .display */ .jfB("flex"),
    _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_3__/* .flexDirection */ .Me8("column"),
    _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_3__/* .boxShadow */ .Wnp(bs_css_src_Css_Js_Core_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .Shadow.box */ .jXB.box(_bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_3__.px(0), _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_3__.px(2), _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_3__.px(5), undefined, undefined, _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_3__/* .rgba */ .m4f(0, 0, 0, {
        NAME: "percent",
        VAL: 7.0
    }))),
    _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_3__/* .borderRadius */ .E0l(_bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_3__.px(8))
]);
var Styles = {
    wrapper: wrapper
};
function ContentCard(props) {
    var className = props.className;
    var className$1 = className !== undefined ? className : "";
    return react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx("div", {
        children: props.children,
        className: classnames__WEBPACK_IMPORTED_MODULE_0___default()([
            wrapper,
            className$1
        ])
    });
}
var make = ContentCard;
 /* wrapper Not a pure module */ 


/***/ }),

/***/ 70945:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "S": function() { return /* binding */ make; }
/* harmony export */ });
/* unused harmony export Styles */
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var bs_css_src_Css_Js_Core_bs_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(32885);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85893);
/* harmony import */ var _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(36585);
/* harmony import */ var _theme_Theme_Responsive_bs_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(70965);
// Generated by ReScript, PLEASE EDIT WITH CARE





var wrapper = _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_3__/* .style */ .oBv([
    _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_3__/* .display */ .jfB("flex"),
    _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_3__/* .paddingTop */ .odA(_bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_3__/* .rem */ .hOB(1)),
    _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_3__/* .paddingBottom */ .EtG(_bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_3__/* .rem */ .hOB(1)),
    _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_3__/* .paddingRight */ .WLm(_bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_3__/* .rem */ .hOB(1)),
    _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_3__/* .paddingLeft */ .rv2(_bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_3__/* .rem */ .hOB(1)),
    _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_3__/* .justifyContent */ .KlP("spaceBetween"),
    _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_3__/* .boxShadow */ .Wnp(bs_css_src_Css_Js_Core_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .Shadow.box */ .jXB.box(_bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_3__.px(0), _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_3__.px(2), _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_3__.px(5), undefined, undefined, _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_3__/* .rgba */ .m4f(0, 0, 0, {
        NAME: "percent",
        VAL: 7.0
    }))),
    _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_3__/* .borderBottomLeftRadius */ .AGO(_bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_3__.px(8)),
    _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_3__/* .borderBottomRightRadius */ .rfy(_bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_3__.px(8)),
    _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_3__/* .media */ .BC2(_theme_Theme_Responsive_bs_js__WEBPACK_IMPORTED_MODULE_4__/* .desktop */ .gv, [
        _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_3__/* .flexDirection */ .Me8("row")
    ]),
    _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_3__/* .media */ .BC2(_theme_Theme_Responsive_bs_js__WEBPACK_IMPORTED_MODULE_4__/* .tabletOrMobile */ .k$, [
        _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_3__/* .flexDirection */ .Me8("column")
    ])
]);
var Styles = {
    wrapper: wrapper
};
function ContentCard__BottomContainer(props) {
    var className = props.className;
    var className$1 = className !== undefined ? className : "";
    return react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx("div", {
        children: props.children,
        className: classnames__WEBPACK_IMPORTED_MODULE_0___default()([
            wrapper,
            className$1
        ])
    });
}
var make = ContentCard__BottomContainer;
 /* wrapper Not a pure module */ 


/***/ }),

/***/ 8266:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "S": function() { return /* binding */ make; }
/* harmony export */ });
/* unused harmony export Styles */
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(36585);
/* harmony import */ var _context_ThemeContext_ThemeContext_bs_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(28522);
/* harmony import */ var _theme_Theme_Responsive_bs_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(70965);
/* harmony import */ var _theme_Theme_Typography_bs_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(32567);
// Generated by ReScript, PLEASE EDIT WITH CARE






function title(theme) {
    var match = theme.components;
    return _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .merge */ .TSy([
        _theme_Theme_Typography_bs_js__WEBPACK_IMPORTED_MODULE_5__/* .Styles.style6 */ .z.style6,
        _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .style */ .oBv([
            _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .color */ .$_Y(match.contentCard.descriptionColor),
            _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .media */ .BC2(_theme_Theme_Responsive_bs_js__WEBPACK_IMPORTED_MODULE_4__/* .tabletOrMobile */ .k$, [
                _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .fontSize */ .JBY(_bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__.px(14)),
                _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .lineHeight */ .Nv8(_bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__.px(25))
            ])
        ])
    ]);
}
var Styles = {
    title: title
};
function ContentCard__Description(props) {
    var className = props.className;
    var className$1 = className !== undefined ? className : "";
    var theme = _context_ThemeContext_ThemeContext_bs_js__WEBPACK_IMPORTED_MODULE_3__/* .useTheme */ .Fg(undefined);
    return react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx("div", {
        children: props.children,
        className: classnames__WEBPACK_IMPORTED_MODULE_0___default()([
            title(theme),
            className$1
        ])
    });
}
var make = ContentCard__Description;
 /* classnames Not a pure module */ 


/***/ }),

/***/ 53973:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "S": function() { return /* binding */ make; }
/* harmony export */ });
/* unused harmony export Styles */
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(36585);
/* harmony import */ var _context_ThemeContext_ThemeContext_bs_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(28522);
/* harmony import */ var _theme_Theme_Responsive_bs_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(70965);
/* harmony import */ var _theme_Theme_Typography_bs_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(32567);
// Generated by ReScript, PLEASE EDIT WITH CARE






function title(theme) {
    var match = theme.components;
    return _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .merge */ .TSy([
        _theme_Theme_Typography_bs_js__WEBPACK_IMPORTED_MODULE_5__/* .Styles.style4 */ .z.style4,
        _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .style */ .oBv([
            _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .color */ .$_Y(match.contentCard.titleColor),
            _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .media */ .BC2(_theme_Theme_Responsive_bs_js__WEBPACK_IMPORTED_MODULE_4__/* .tabletSmOrTablet */ .Ku, [
                _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .marginBottom */ .yl7(_bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .rem */ .hOB(0.5)),
                _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .fontSize */ .JBY(_bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__.px(18)),
                _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .lineHeight */ .Nv8(_bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__.px(22))
            ]),
            _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .media */ .BC2(_theme_Theme_Responsive_bs_js__WEBPACK_IMPORTED_MODULE_4__/* .tabletSm */ .FV, [
                _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .marginBottom */ .yl7(_bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .rem */ .hOB(0.5)),
                _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .fontSize */ .JBY(_bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__.px(16)),
                _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .lineHeight */ .Nv8(_bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__.px(22))
            ])
        ])
    ]);
}
var Styles = {
    title: title
};
function ContentCard__Title(props) {
    var className = props.className;
    var className$1 = className !== undefined ? className : "";
    var theme = _context_ThemeContext_ThemeContext_bs_js__WEBPACK_IMPORTED_MODULE_3__/* .useTheme */ .Fg(undefined);
    return react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx("div", {
        children: props.children,
        className: classnames__WEBPACK_IMPORTED_MODULE_0___default()([
            title(theme),
            className$1
        ])
    });
}
var make = ContentCard__Title;
 /* classnames Not a pure module */ 


/***/ }),

/***/ 5926:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "S": function() { return /* binding */ make; }
/* harmony export */ });
/* unused harmony export Styles */
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(36585);
// Generated by ReScript, PLEASE EDIT WITH CARE



var wrapper = _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .style */ .oBv([
    _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .height */ .Cb8("auto")
]);
var Styles = {
    wrapper: wrapper
};
function ContentCard__TopContainer(props) {
    var className = props.className;
    var className$1 = className !== undefined ? className : "";
    return react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx("div", {
        children: props.children,
        className: classnames__WEBPACK_IMPORTED_MODULE_0___default()([
            wrapper,
            className$1
        ])
    });
}
var make = ContentCard__TopContainer;
 /* wrapper Not a pure module */ 


/***/ }),

/***/ 88795:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "S": function() { return /* binding */ make; }
/* harmony export */ });
/* harmony import */ var _Tag_bs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(22492);
/* TypeScript file generated from Tag.res by genType. */ /* eslint-disable import/first */ // @ts-ignore: Implicit any on import

var TagBS = _Tag_bs__WEBPACK_IMPORTED_MODULE_0__;
var make = TagBS.make;


/***/ }),

/***/ 50247:
/***/ (function() {

/* (ignored) */

/***/ }),

/***/ 20943:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _arrayLikeToArray; }
/* harmony export */ });
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}


/***/ }),

/***/ 39474:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _arrayWithHoles; }
/* harmony export */ });
function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}


/***/ }),

/***/ 13375:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _iterableToArray; }
/* harmony export */ });
function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}


/***/ }),

/***/ 53128:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _nonIterableRest; }
/* harmony export */ });
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}


/***/ }),

/***/ 10253:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _slicedToArray; }
/* harmony export */ });
/* harmony import */ var _array_with_holes_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(39474);
/* harmony import */ var _iterable_to_array_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(13375);
/* harmony import */ var _non_iterable_rest_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(53128);
/* harmony import */ var _unsupported_iterable_to_array_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(91566);





function _slicedToArray(arr, i) {
  return (0,_array_with_holes_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(arr) || (0,_iterable_to_array_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(arr, i) || (0,_unsupported_iterable_to_array_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(arr, i) || (0,_non_iterable_rest_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)();
}


/***/ }),

/***/ 29815:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ _toConsumableArray; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_array_like_to_array.mjs
var _array_like_to_array = __webpack_require__(20943);
;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_array_without_holes.mjs


function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return (0,_array_like_to_array/* default */.Z)(arr);
}

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_iterable_to_array.mjs
var _iterable_to_array = __webpack_require__(13375);
;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_non_iterable_spread.mjs
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_unsupported_iterable_to_array.mjs
var _unsupported_iterable_to_array = __webpack_require__(91566);
;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs





function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || (0,_iterable_to_array/* default */.Z)(arr) || (0,_unsupported_iterable_to_array/* default */.Z)(arr) || _nonIterableSpread();
}


/***/ }),

/***/ 91566:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _unsupportedIterableToArray; }
/* harmony export */ });
/* harmony import */ var _array_like_to_array_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(20943);


function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return (0,_array_like_to_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(n);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
    return (0,_array_like_to_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(o, minLen);
}


/***/ })

}]);